var items = {
  "block.minecraft.acacia_button": "אקאציענהאלצקנאף",
  "block.minecraft.acacia_door": "אקאציענההאלצטיר",
  "block.minecraft.acacia_fence": "אקאציענהאלצצוים",
  "block.minecraft.acacia_fence_gate": "אקאציענהאלצצוימטויער",
  "block.minecraft.acacia_hanging_sign": "אַקאַסיאַ כאַנגגינג צייכן",
  "block.minecraft.acacia_leaves": "אקאציענבלעטער",
  "block.minecraft.acacia_log": "אקאציענשטאם",
  "block.minecraft.acacia_planks": "אקאציענהאלצברעטער",
  "block.minecraft.acacia_pressure_plate": "אקאציענהאלצדרוקפּלאטע",
  "block.minecraft.acacia_sapling": "אקאציענהזעצלינג",
  "block.minecraft.acacia_shelf": "Acacia Shelf",
  "block.minecraft.acacia_sign": "אקאציענהאלצשילד",
  "block.minecraft.acacia_slab": "אקאציענהאלצפּלאטע",
  "block.minecraft.acacia_stairs": "אקאציענהאלצטרעף",
  "block.minecraft.acacia_trapdoor": "אקאציענהאלצפֿאלטיר",
  "block.minecraft.acacia_wall_hanging_sign": "אַקאַסיאַ וואנט כאַנגגינג צייכן",
  "block.minecraft.acacia_wall_sign": "אקאציענהאלצוואנדשילד",
  "block.minecraft.acacia_wood": "אקאציענהאלץ",
  "block.minecraft.activator_rail": "אקטיווירונגסבאן",
  "block.minecraft.air": "לופֿט",
  "block.minecraft.allium": "פּארע־ציבעלע",
  "block.minecraft.amethyst_block": "פאַרשפּאַרן פון אַמעטהיסט",
  "block.minecraft.amethyst_cluster": "אַמעטהיסט קלאַסטער",
  "block.minecraft.ancient_debris": "אלטע בויברעך",
  "block.minecraft.andesite": "אנדעזיט",
  "block.minecraft.andesite_slab": "אנדעזיטפלאטע",
  "block.minecraft.andesite_stairs": "אנדעזיטטרעפ",
  "block.minecraft.andesite_wall": "אנדעזיטמויער",
  "block.minecraft.anvil": "אנשטול",
  "block.minecraft.attached_melon_stem": "מעלאנעשטענגל",
  "block.minecraft.attached_pumpkin_stem": "קירבעסשטענגל",
  "block.minecraft.azalea": "אזאליע",
  "block.minecraft.azalea_leaves": "אַזייליאַ בלעטער",
  "block.minecraft.azure_bluet": "פּארצעלאנשטערנדל",
  "block.minecraft.bamboo": "באמבוק",
  "block.minecraft.bamboo_block": "בלאָק פון באַמבו",
  "block.minecraft.bamboo_button": "באַמבו קנעפּל",
  "block.minecraft.bamboo_door": "באַמבו טיר",
  "block.minecraft.bamboo_fence": "באַמבו פענס",
  "block.minecraft.bamboo_fence_gate": "באַמבו פענס גייט",
  "block.minecraft.bamboo_hanging_sign": "באַמבו כאַנגגינג צייכן",
  "block.minecraft.bamboo_mosaic": "באַמבו מאָזאַיִק",
  "block.minecraft.bamboo_mosaic_slab": "באַמבו מאָזאַיִק פּלאַטע",
  "block.minecraft.bamboo_mosaic_stairs": "באַמבו מאָזאַיִק סטאַירס",
  "block.minecraft.bamboo_planks": "באַמבו פּלאַנקס",
  "block.minecraft.bamboo_pressure_plate": "באַמבו דרוק פּלאַטע",
  "block.minecraft.bamboo_sapling": "באמבו ספראוט",
  "block.minecraft.bamboo_shelf": "Bamboo Shelf",
  "block.minecraft.bamboo_sign": "באַמבו צייכן",
  "block.minecraft.bamboo_slab": "באַמבו פּלאַטע",
  "block.minecraft.bamboo_stairs": "באַמבו סטאַירס",
  "block.minecraft.bamboo_trapdoor": "באַמבו טראַפּדאָר",
  "block.minecraft.bamboo_wall_hanging_sign": "באַמבו וואנט כאַנגגינג צייכן",
  "block.minecraft.bamboo_wall_sign": "באַמבו וואנט צייכן",
  "block.minecraft.banner.base.black": "גאַנץ שוואַרץ פעלד",
  "block.minecraft.banner.base.blue": "גאַנץ בלוי פעלד",
  "block.minecraft.banner.base.brown": "גאַנץ ברוין פעלד",
  "block.minecraft.banner.base.cyan": "גאַנץ סייאַן פעלד",
  "block.minecraft.banner.base.gray": "גאַנץ גרוי פעלד",
  "block.minecraft.banner.base.green": "גאַנץ גרין פעלד",
  "block.minecraft.banner.base.light_blue": "גאַנץ בלוי פעלד",
  "block.minecraft.banner.base.light_gray": "גאַנץ ליכט גרוי פעלד",
  "block.minecraft.banner.base.lime": "גאַנץ לייַם פעלד",
  "block.minecraft.banner.base.magenta": "א פול מאַגענטאַ פעלד",
  "block.minecraft.banner.base.orange": "גאַנץ מאַראַנץ פעלד",
  "block.minecraft.banner.base.pink": "גאַנץ ראָזעווע פעלד",
  "block.minecraft.banner.base.purple": "גאַנץ לילאַ פעלד",
  "block.minecraft.banner.base.red": "גאַנץ רויט פעלד",
  "block.minecraft.banner.base.white": "גאַנץ ווייַס פעלד",
  "block.minecraft.banner.base.yellow": "גאַנץ געל פעלד",
  "block.minecraft.banner.border.black": "בלויע בארדירונג",
  "block.minecraft.banner.border.blue": "בלויע בארדירונג",
  "block.minecraft.banner.border.brown": "ברוינע בארדירונג",
  "block.minecraft.banner.border.cyan": "טורקיזע בארדירונג",
  "block.minecraft.banner.border.gray": "גרויע בארדירונג",
  "block.minecraft.banner.border.green": "גרינע בארדירונג",
  "block.minecraft.banner.border.light_blue": "העלבלויע בארדירונג",
  "block.minecraft.banner.border.light_gray": "העלגרויע בארדירונג",
  "block.minecraft.banner.border.lime": "העלגרינע בארדירונג",
  "block.minecraft.banner.border.magenta": "מאדזשענטאע בארדירונג",
  "block.minecraft.banner.border.orange": "אראנזשע בארדירונג",
  "block.minecraft.banner.border.pink": "העלרויטע בארדירונג",
  "block.minecraft.banner.border.purple": "לילאע בארדירונג",
  "block.minecraft.banner.border.red": "רויטע בארדירונג",
  "block.minecraft.banner.border.white": "ווייסע בארדירונג",
  "block.minecraft.banner.border.yellow": "געלע בארדירונג",
  "block.minecraft.banner.bricks.black": "שווארצס געמויערטס פעלד",
  "block.minecraft.banner.bricks.blue": "בלויס געמויערטס פעלד",
  "block.minecraft.banner.bricks.brown": "ברויינס געמויערטס פעלד",
  "block.minecraft.banner.bricks.cyan": "טורקיזס געמויערטס פעלד",
  "block.minecraft.banner.bricks.gray": "גרויס געמויערטס פעלד",
  "block.minecraft.banner.bricks.green": "גרינס געמויערטס פעלד",
  "block.minecraft.banner.bricks.light_blue": "העלבלויס געמויערטס פעלד",
  "block.minecraft.banner.bricks.light_gray": "העלגרויס געמויערטס פעלד",
  "block.minecraft.banner.bricks.lime": "העלגרינס געמויערטס פעלד",
  "block.minecraft.banner.bricks.magenta": "מאדזשענטאס געמויערטס פעלד",
  "block.minecraft.banner.bricks.orange": "אראנזשס געמויערטס פעלד",
  "block.minecraft.banner.bricks.pink": "העלרויטס געמויערטס פעלד",
  "block.minecraft.banner.bricks.purple": "לילאס געמויערטס פעלד",
  "block.minecraft.banner.bricks.red": "רויטס געמויערטס פעלד",
  "block.minecraft.banner.bricks.white": "ווייַסס געמויערטס פעלד",
  "block.minecraft.banner.bricks.yellow": "געלס געמויערטס פעלד",
  "block.minecraft.banner.circle.black": "שווארצער פאנבאל",
  "block.minecraft.banner.circle.blue": "בלויער באל",
  "block.minecraft.banner.circle.brown": "ברוינער באל",
  "block.minecraft.banner.circle.cyan": "טורקיזער פאנבאל",
  "block.minecraft.banner.circle.gray": "גרויער פאנבאל",
  "block.minecraft.banner.circle.green": "גרינער באל",
  "block.minecraft.banner.circle.light_blue": "העלבלויער פאנבאל",
  "block.minecraft.banner.circle.light_gray": "העלגרויער פאנבאל",
  "block.minecraft.banner.circle.lime": "העלגרינער פאנבאל",
  "block.minecraft.banner.circle.magenta": "מאדזשענטאער פאנבאל",
  "block.minecraft.banner.circle.orange": "אראנזשער פאנבאל",
  "block.minecraft.banner.circle.pink": "העלרויטער פאנבאל",
  "block.minecraft.banner.circle.purple": "לילאער באל",
  "block.minecraft.banner.circle.red": "רויטער באל",
  "block.minecraft.banner.circle.white": "ווייסער פאנבאל",
  "block.minecraft.banner.circle.yellow": "געלער פאנבאל",
  "block.minecraft.banner.creeper.black": "שווארצע קריפערספארעם",
  "block.minecraft.banner.creeper.blue": "בלויע קריפערספארעם",
  "block.minecraft.banner.creeper.brown": "ברוינע קריפערספארעם",
  "block.minecraft.banner.creeper.cyan": "טורקיזע קריפערספארעם",
  "block.minecraft.banner.creeper.gray": "גרויע קריפערספארעם",
  "block.minecraft.banner.creeper.green": "גרינע קריפערספארעם",
  "block.minecraft.banner.creeper.light_blue": "העלבלויע קריפערספארעם",
  "block.minecraft.banner.creeper.light_gray": "העלגרויע קריפערספארעם",
  "block.minecraft.banner.creeper.lime": "העלגרינע קריפערספארעם",
  "block.minecraft.banner.creeper.magenta": "מאדזשענטאע קריפערספארעם",
  "block.minecraft.banner.creeper.orange": "אראנזשע קריפערספארעם",
  "block.minecraft.banner.creeper.pink": "העלרויטע קריפערספארעם",
  "block.minecraft.banner.creeper.purple": "קריפע קריפערספארעם",
  "block.minecraft.banner.creeper.red": "רויטע קריפערספארעם",
  "block.minecraft.banner.creeper.white": "ווייסע קריפערספארעם",
  "block.minecraft.banner.creeper.yellow": "געלע קריפערספארעם",
  "block.minecraft.banner.cross.black": "שווארצער אנדרעאסרייץ",
  "block.minecraft.banner.cross.blue": "בלויער אנדרעאסקרייץ",
  "block.minecraft.banner.cross.brown": "ברוינער אנדרעאסקרייץ",
  "block.minecraft.banner.cross.cyan": "טורקיזער אנדרעאסקרייץ",
  "block.minecraft.banner.cross.gray": "גרויער אנדרעאסקרייץ",
  "block.minecraft.banner.cross.green": "גרינער אנדרעאסקרייץ",
  "block.minecraft.banner.cross.light_blue": "העלבלויער אנדרעאסקרייץ",
  "block.minecraft.banner.cross.light_gray": "העלגרויער אנדרעאסקרייץ",
  "block.minecraft.banner.cross.lime": "העלגרינער אנדרעאסקרייץ",
  "block.minecraft.banner.cross.magenta": "מאדזשענטאער אנדרעאסקרייץ",
  "block.minecraft.banner.cross.orange": "אראנזשער אנדרעאסקרייץ",
  "block.minecraft.banner.cross.pink": "העלרויטער אנדרעאסקרייץ",
  "block.minecraft.banner.cross.purple": "לילאער אנדרעאסקרייץ",
  "block.minecraft.banner.cross.red": "רויטער אנדרעאסקרייץ",
  "block.minecraft.banner.cross.white": "ווייסער אנדרעאסקרייץ",
  "block.minecraft.banner.cross.yellow": "געלער אנדרעאסקרייץ",
  "block.minecraft.banner.curly_border.black": "בלויע שפיקלבארדירונג",
  "block.minecraft.banner.curly_border.blue": "בלויע שפיקלבארדירונג",
  "block.minecraft.banner.curly_border.brown": "ברוינע שפיקלבארדירונג",
  "block.minecraft.banner.curly_border.cyan": "טורקיזע שפיקלבארדירונג",
  "block.minecraft.banner.curly_border.gray": "גרויע שפיקלבארדירונג",
  "block.minecraft.banner.curly_border.green": "גרינע שפיקלבארדירונג",
  "block.minecraft.banner.curly_border.light_blue": "העלבלויע שפיקלבארדירונג",
  "block.minecraft.banner.curly_border.light_gray": "העלגרויע שפיקלבארדירונג",
  "block.minecraft.banner.curly_border.lime": "העלגרינע שפיקלבארדירונג",
  "block.minecraft.banner.curly_border.magenta": "מאדזשענטאע שפיקלבארדירונג",
  "block.minecraft.banner.curly_border.orange": "אראנזשע שפיקלבארדירונג",
  "block.minecraft.banner.curly_border.pink": "העלרויטע שפיקלבארדירונג",
  "block.minecraft.banner.curly_border.purple": "לילאע שפיקלבארדירונג",
  "block.minecraft.banner.curly_border.red": "רויטע שפיקלבארדירונג",
  "block.minecraft.banner.curly_border.white": "ווייסע שפיקלבארדירונג",
  "block.minecraft.banner.curly_border.yellow": "געלע שפיקלבארדירונג",
  "block.minecraft.banner.diagonal_left.black": "שווארץ שרעגלינקס געטיילט",
  "block.minecraft.banner.diagonal_left.blue": "בלוי שרעגלינקס געטיילט",
  "block.minecraft.banner.diagonal_left.brown": "ברוין שרעגלינקס געטיילט",
  "block.minecraft.banner.diagonal_left.cyan": "טורקיז שרעגלינקס געטיילט",
  "block.minecraft.banner.diagonal_left.gray": "גרוי שרעגלינקס געטיילט",
  "block.minecraft.banner.diagonal_left.green": "גרוין שרעגלינקס געטיילט",
  "block.minecraft.banner.diagonal_left.light_blue": "העלבלוי שרעגלינקס געטיילט",
  "block.minecraft.banner.diagonal_left.light_gray": "העלגרוי שרעגלינקס געטיילט",
  "block.minecraft.banner.diagonal_left.lime": "העלגרין שרעגלינקס געטיילט",
  "block.minecraft.banner.diagonal_left.magenta": "מאדזשענטא שרעגלינקס געטיילט",
  "block.minecraft.banner.diagonal_left.orange": "אראנזש שרעגלינקס געטיילט",
  "block.minecraft.banner.diagonal_left.pink": "העלרויט שרעגלינקס געטיילט",
  "block.minecraft.banner.diagonal_left.purple": "לילא שרעגלינקס געטיילט",
  "block.minecraft.banner.diagonal_left.red": "רויט שרעגלינקס געטיילט",
  "block.minecraft.banner.diagonal_left.white": "ווייס שרעגלינקס געטיילט",
  "block.minecraft.banner.diagonal_left.yellow": "געל שרעגלינקס געטיילט",
  "block.minecraft.banner.diagonal_right.black": "שווארץ שרעגרעכטס געטיילט",
  "block.minecraft.banner.diagonal_right.blue": "בלוי שרעגרעכטס געטיילט",
  "block.minecraft.banner.diagonal_right.brown": "ברוין שרעגרעכטס געטיילט",
  "block.minecraft.banner.diagonal_right.cyan": "טורקיז שרעגרעכטס געטיילט",
  "block.minecraft.banner.diagonal_right.gray": "גרוי שרעגרעכטס געטיילט",
  "block.minecraft.banner.diagonal_right.green": "גרוין שרעגרעכטס געטיילט",
  "block.minecraft.banner.diagonal_right.light_blue": "העלבלוי שרעגרעכטס געטיילט",
  "block.minecraft.banner.diagonal_right.light_gray": "העלגרוי שרעגרעכטס געטיילט",
  "block.minecraft.banner.diagonal_right.lime": "העלגרין שרעגרעכטס געטיילט",
  "block.minecraft.banner.diagonal_right.magenta": "מאדזשענטא שרעגרעכטס געטיילט",
  "block.minecraft.banner.diagonal_right.orange": "אראנזש שרעגרעכטס געטיילט",
  "block.minecraft.banner.diagonal_right.pink": "העלרויט שרעגרעכטס געטיילט",
  "block.minecraft.banner.diagonal_right.purple": "לילא שרעגרעכטס געטיילט",
  "block.minecraft.banner.diagonal_right.red": "רויט שרעגרעכטס געטיילט",
  "block.minecraft.banner.diagonal_right.white": "ווייס שרעגרעכטס געטיילט",
  "block.minecraft.banner.diagonal_right.yellow": "געל שרעגרעכטס געטיילט",
  "block.minecraft.banner.diagonal_up_left.black": "שווארץ שרעגרעכטס געטיילט אינווערטירט",
  "block.minecraft.banner.diagonal_up_left.blue": "בלוי שרעגרעכטס געטיילט אינווערטירט",
  "block.minecraft.banner.diagonal_up_left.brown": "ברוין שרעגרעכטס געטיילט אינווערטירט",
  "block.minecraft.banner.diagonal_up_left.cyan": "טורקיז שרעגרעכטס געטיילט אינווערטירט",
  "block.minecraft.banner.diagonal_up_left.gray": "גרוי שרעגרעכטס געטיילט אינווערטירט",
  "block.minecraft.banner.diagonal_up_left.green": "גרוין שרעגרעכטס געטיילט אינווערטירט",
  "block.minecraft.banner.diagonal_up_left.light_blue": "העלבלוי שרעגרעכטס געטיילט אינווערטירט",
  "block.minecraft.banner.diagonal_up_left.light_gray": "העלגרוי שרעגרעכטס געטיילט אינווערטירט",
  "block.minecraft.banner.diagonal_up_left.lime": "העלגרין שרעגרעכטס געטיילט אינווערטירט",
  "block.minecraft.banner.diagonal_up_left.magenta": "מאדזשענטא שרעגרעכטס געטיילט אינווערטירט",
  "block.minecraft.banner.diagonal_up_left.orange": "אראנזש שרעגרעכטס געטיילט אינווערטירט",
  "block.minecraft.banner.diagonal_up_left.pink": "העלרויט שרעגרעכטס געטיילט אינווערטירט",
  "block.minecraft.banner.diagonal_up_left.purple": "לילא שרעגרעכטס געטיילט אינווערטירט",
  "block.minecraft.banner.diagonal_up_left.red": "רויט שרעגרעכטס געטיילט אינווערטירט",
  "block.minecraft.banner.diagonal_up_left.white": "ווייַס שרעגרעכטס געטיילט אינווערטירט",
  "block.minecraft.banner.diagonal_up_left.yellow": "געל שרעגרעכטס געטיילט אינווערטירט",
  "block.minecraft.banner.diagonal_up_right.black": "שווארץ שרעגלינקס געטיילט אינווערטירט",
  "block.minecraft.banner.diagonal_up_right.blue": "בלוי שרעגלינקס געטיילט אינווערטירט",
  "block.minecraft.banner.diagonal_up_right.brown": "ברוין שרעגלינקס געטיילט אינווערטירט",
  "block.minecraft.banner.diagonal_up_right.cyan": "טורקיז שרעגלינקס געטיילט אינווערטירט",
  "block.minecraft.banner.diagonal_up_right.gray": "גרוי שרעגלינקס געטיילט אינווערטירט",
  "block.minecraft.banner.diagonal_up_right.green": "גרוין שרעגלינקס געטיילט אינווערטירט",
  "block.minecraft.banner.diagonal_up_right.light_blue": "העלבלוי שרעגלינקס געטיילט אינווערטירט",
  "block.minecraft.banner.diagonal_up_right.light_gray": "העלגרוי שרעגלינקס געטיילט אינווערטירט",
  "block.minecraft.banner.diagonal_up_right.lime": "העלגרין שרעגלינקס געטיילט אינווערטירט",
  "block.minecraft.banner.diagonal_up_right.magenta": "מאדזשענטא שרעגלינקס געטיילט אינווערטירט",
  "block.minecraft.banner.diagonal_up_right.orange": "אראנזש שרעגלינקס געטיילט אינווערטירט",
  "block.minecraft.banner.diagonal_up_right.pink": "העלרויט שרעגלינקס געטיילט אינווערטירט",
  "block.minecraft.banner.diagonal_up_right.purple": "לילא שרעגלינקס געטיילט אינווערטירט",
  "block.minecraft.banner.diagonal_up_right.red": "רויט שרעגלינקס געטיילט אינווערטירט",
  "block.minecraft.banner.diagonal_up_right.white": "ווייַס שרעגלינקס געטיילט אינווערטירט",
  "block.minecraft.banner.diagonal_up_right.yellow": "געל שרעגלינקס געטיילט אינווערטירט",
  "block.minecraft.banner.flow.black": "שוואַרץ לויפן",
  "block.minecraft.banner.flow.blue": "בלוי לויפן",
  "block.minecraft.banner.flow.brown": "ברוין לויפן",
  "block.minecraft.banner.flow.cyan": "ציאַן לויפן",
  "block.minecraft.banner.flow.gray": "גרוי לויפן",
  "block.minecraft.banner.flow.green": "גרין לויפן",
  "block.minecraft.banner.flow.light_blue": "ליכט בלוי לויפן",
  "block.minecraft.banner.flow.light_gray": "ליכט גרוי לויפן",
  "block.minecraft.banner.flow.lime": "לייַם לויפן",
  "block.minecraft.banner.flow.magenta": "מאַגענטאַ לויפן",
  "block.minecraft.banner.flow.orange": "אָראַנזשעריי שטראָם",
  "block.minecraft.banner.flow.pink": "ראָזעווע שטראָם",
  "block.minecraft.banner.flow.purple": "לילאַ לויפן",
  "block.minecraft.banner.flow.red": "רויט לויפן",
  "block.minecraft.banner.flow.white": "ווייַס לויפן",
  "block.minecraft.banner.flow.yellow": "געל לויפן",
  "block.minecraft.banner.flower.black": "שווארצע בלומנפארעם",
  "block.minecraft.banner.flower.blue": "בלויע בלומנפארעם",
  "block.minecraft.banner.flower.brown": "ברוינע בלומנפארעם",
  "block.minecraft.banner.flower.cyan": "טורקיזע בלומנפארעם",
  "block.minecraft.banner.flower.gray": "גרויע בלומנפארעם",
  "block.minecraft.banner.flower.green": "גרינע בלומנפארעם",
  "block.minecraft.banner.flower.light_blue": "העלבלויע בלומנפארעם",
  "block.minecraft.banner.flower.light_gray": "העלגרויע בלומנפארעם",
  "block.minecraft.banner.flower.lime": "העלגרינע בלומנפארעם",
  "block.minecraft.banner.flower.magenta": "מאדזשענטאע בלומנפארעם",
  "block.minecraft.banner.flower.orange": "אראנזשע בלומנפארעם",
  "block.minecraft.banner.flower.pink": "העלרויטע בלומנפארעם",
  "block.minecraft.banner.flower.purple": "קריפע בלומנפארעם",
  "block.minecraft.banner.flower.red": "רויטע בלומנפארעם",
  "block.minecraft.banner.flower.white": "ווייסע בלומנפארעם",
  "block.minecraft.banner.flower.yellow": "געלע בלומנפארעם",
  "block.minecraft.banner.globe.black": "שווארצער גלאבוס",
  "block.minecraft.banner.globe.blue": "בלויער גלאבוס",
  "block.minecraft.banner.globe.brown": "ברונער גלאבוס",
  "block.minecraft.banner.globe.cyan": "סייאןער גלאבוס",
  "block.minecraft.banner.globe.gray": "גרוי גלאבוס",
  "block.minecraft.banner.globe.green": "גרינער גלאבוס",
  "block.minecraft.banner.globe.light_blue": "ליכט בלויער גלאבוס",
  "block.minecraft.banner.globe.light_gray": "ליכט גרוי גלאבוס",
  "block.minecraft.banner.globe.lime": "לייַם גרינער גלאבוס",
  "block.minecraft.banner.globe.magenta": "מאגענטא גלאבוס",
  "block.minecraft.banner.globe.orange": "מאראנץ גלאבוס",
  "block.minecraft.banner.globe.pink": "ראזעווער גלאבוס",
  "block.minecraft.banner.globe.purple": "לילער גלאבוס",
  "block.minecraft.banner.globe.red": "רויטער גלאבוס",
  "block.minecraft.banner.globe.white": "ווייַס גלאבוס",
  "block.minecraft.banner.globe.yellow": "געלער גלאבוס",
  "block.minecraft.banner.gradient.black": "שווארצער פארבפארלויף",
  "block.minecraft.banner.gradient.blue": "בלויער פארבפארלויף",
  "block.minecraft.banner.gradient.brown": "ברוינער פארבפארלויף",
  "block.minecraft.banner.gradient.cyan": "טורקיזער פארבפארלויף",
  "block.minecraft.banner.gradient.gray": "גרויער פארבפארלויף",
  "block.minecraft.banner.gradient.green": "גרינער פארבפארלויף",
  "block.minecraft.banner.gradient.light_blue": "העלבלויער פארבפארלויף",
  "block.minecraft.banner.gradient.light_gray": "העלגרויער פארבפארלויף",
  "block.minecraft.banner.gradient.lime": "העלגרינער פארבפארלויף",
  "block.minecraft.banner.gradient.magenta": "מאדזשענטאער פארבפארלויף",
  "block.minecraft.banner.gradient.orange": "אראנזשער פארבפארלויף",
  "block.minecraft.banner.gradient.pink": "העלרויטער פארבפארלויף",
  "block.minecraft.banner.gradient.purple": "לילאער פארבפארלויף",
  "block.minecraft.banner.gradient.red": "רויטער פארבפארלויף",
  "block.minecraft.banner.gradient.white": "ווייַסער פארבפארלויף",
  "block.minecraft.banner.gradient.yellow": "געלער פארבפארלויף",
  "block.minecraft.banner.gradient_up.black": "שווארצער פארבפארלויף אינווערטירט",
  "block.minecraft.banner.gradient_up.blue": "בלויער פארבפארלויף אינווערטירט",
  "block.minecraft.banner.gradient_up.brown": "ברוינער פארבפארלויף אינווערטירט",
  "block.minecraft.banner.gradient_up.cyan": "טורקיזער פארבפארלויף אינווערטירט",
  "block.minecraft.banner.gradient_up.gray": "גרויער פארבפארלויף אינווערטירט",
  "block.minecraft.banner.gradient_up.green": "גרינער פארבפארלויף אינווערטירט",
  "block.minecraft.banner.gradient_up.light_blue": "העלבלויער פארבפארלויף אינווערטירט",
  "block.minecraft.banner.gradient_up.light_gray": "העלגרויער פארבפארלויף אינווערטירט",
  "block.minecraft.banner.gradient_up.lime": "העלגרינער פארבפארלויף אינווערטירט",
  "block.minecraft.banner.gradient_up.magenta": "מאדזשענטאער פארבפארלויף אינווערטירט",
  "block.minecraft.banner.gradient_up.orange": "אראנזשער פארבפארלויף אינווערטירט",
  "block.minecraft.banner.gradient_up.pink": "העלרויטער פארבפארלויף אינווערטירט",
  "block.minecraft.banner.gradient_up.purple": "לילאער פארבפארלויף אינווערטירט",
  "block.minecraft.banner.gradient_up.red": "רויטער פארבפארלויף",
  "block.minecraft.banner.gradient_up.white": "ווייַסער פארבפארלויף אינווערטירט",
  "block.minecraft.banner.gradient_up.yellow": "געלער פארבפארלויף אינווערטירט",
  "block.minecraft.banner.guster.black": "שווארצע שטורעם",
  "block.minecraft.banner.guster.blue": "בלויע שטורעם",
  "block.minecraft.banner.guster.brown": "ברוין שטורעם",
  "block.minecraft.banner.guster.cyan": "שטורעם סיאַן",
  "block.minecraft.banner.guster.gray": "שטורעם גרוי",
  "block.minecraft.banner.guster.green": "גרין שטורעם",
  "block.minecraft.banner.guster.light_blue": "בלוי שטורעם ליכטיק",
  "block.minecraft.banner.guster.light_gray": "שטורעם גרוי ליכטיק",
  "block.minecraft.banner.guster.lime": "שטורעם ליים",
  "block.minecraft.banner.guster.magenta": "מאַגענטאַ שטורעם",
  "block.minecraft.banner.guster.orange": "שטורעם מאַראַנץ",
  "block.minecraft.banner.guster.pink": "ראָזעווע שטורעם",
  "block.minecraft.banner.guster.purple": "שטורעם מעלה",
  "block.minecraft.banner.guster.red": "רויטע שטורעם",
  "block.minecraft.banner.guster.white": "ווייַס שטורעם",
  "block.minecraft.banner.guster.yellow": "געל שטורעם",
  "block.minecraft.banner.half_horizontal.black": "אייבן שווארץ געטיילט",
  "block.minecraft.banner.half_horizontal.blue": "אייבן בלוי געטיילט",
  "block.minecraft.banner.half_horizontal.brown": "אייבן ברוין געטיילט",
  "block.minecraft.banner.half_horizontal.cyan": "אייבן טורקיז געטיילט",
  "block.minecraft.banner.half_horizontal.gray": "אייבן גרוי געטיילט",
  "block.minecraft.banner.half_horizontal.green": "אייבן גרוין געטיילט",
  "block.minecraft.banner.half_horizontal.light_blue": "אייבן העלבלוי געטיילט",
  "block.minecraft.banner.half_horizontal.light_gray": "אייבן העלגרוי געטיילט",
  "block.minecraft.banner.half_horizontal.lime": "אייבן העלגרין געטיילט",
  "block.minecraft.banner.half_horizontal.magenta": "אייבן מאדזשענטא געטיילט",
  "block.minecraft.banner.half_horizontal.orange": "אייבן אראנזש געטיילט",
  "block.minecraft.banner.half_horizontal.pink": "אייבן העלרויט געטיילט",
  "block.minecraft.banner.half_horizontal.purple": "אייבן לילא געטיילט",
  "block.minecraft.banner.half_horizontal.red": "אייבן רויט געטיילט",
  "block.minecraft.banner.half_horizontal.white": "אייבן ווייס געטיילט",
  "block.minecraft.banner.half_horizontal.yellow": "אייבן געל געטיילט",
  "block.minecraft.banner.half_horizontal_bottom.black": "אונטן שווארץ געטיילט",
  "block.minecraft.banner.half_horizontal_bottom.blue": "אונטן בלוי געטיילט",
  "block.minecraft.banner.half_horizontal_bottom.brown": "אונטן ברוין געטיילט",
  "block.minecraft.banner.half_horizontal_bottom.cyan": "אונטן טורקיז געטיילט",
  "block.minecraft.banner.half_horizontal_bottom.gray": "אונטן גרוי געטיילט",
  "block.minecraft.banner.half_horizontal_bottom.green": "אונטן גרוין געטיילט",
  "block.minecraft.banner.half_horizontal_bottom.light_blue": "אונטן העלבלוי געטיילט",
  "block.minecraft.banner.half_horizontal_bottom.light_gray": "אונטן העלגרוי געטיילט",
  "block.minecraft.banner.half_horizontal_bottom.lime": "אונטן העלגרין געטיילט",
  "block.minecraft.banner.half_horizontal_bottom.magenta": "אונטן מאדזשענטא געטיילט",
  "block.minecraft.banner.half_horizontal_bottom.orange": "אונטן אראנזש געטיילט",
  "block.minecraft.banner.half_horizontal_bottom.pink": "אונטן העלרויט געטיילט",
  "block.minecraft.banner.half_horizontal_bottom.purple": "אונטן לילא געטיילט",
  "block.minecraft.banner.half_horizontal_bottom.red": "אונטן רויט געטיילט",
  "block.minecraft.banner.half_horizontal_bottom.white": "אונטן ווייַס געטיילט",
  "block.minecraft.banner.half_horizontal_bottom.yellow": "אונטן געל געטיילט",
  "block.minecraft.banner.half_vertical.black": "רעכטס שווארץ געשפאלטן",
  "block.minecraft.banner.half_vertical.blue": "רעכטס בלוי געשפאלטן",
  "block.minecraft.banner.half_vertical.brown": "רעכטס ברוין געשפאלטן",
  "block.minecraft.banner.half_vertical.cyan": "רעכטס טורקיז געשפאלטן",
  "block.minecraft.banner.half_vertical.gray": "רעכטס גרוי געשפאלטן",
  "block.minecraft.banner.half_vertical.green": "רעכטס גרין געשפאלטן",
  "block.minecraft.banner.half_vertical.light_blue": "רעכטס העלבלוי געשפאלטן",
  "block.minecraft.banner.half_vertical.light_gray": "רעכטס העלגרוי געשפאלטן",
  "block.minecraft.banner.half_vertical.lime": "רעכטס העלגרין געשפאלטן",
  "block.minecraft.banner.half_vertical.magenta": "רעכטס מאדזשענטא געשפאלטן",
  "block.minecraft.banner.half_vertical.orange": "רעכטס אראנזש געשפאלטן",
  "block.minecraft.banner.half_vertical.pink": "רעכטס העלרויט געשפאלטן",
  "block.minecraft.banner.half_vertical.purple": "רעכטס לילא געשפאלטן",
  "block.minecraft.banner.half_vertical.red": "רעכטס רויט געשפאלטן",
  "block.minecraft.banner.half_vertical.white": "רעכטס ווייַס געשפאלטן",
  "block.minecraft.banner.half_vertical.yellow": "רעכטס געל געשפאלטן",
  "block.minecraft.banner.half_vertical_right.black": "לינקס שווארץ געשפאלטן",
  "block.minecraft.banner.half_vertical_right.blue": "לינקס בלוי געשפאלטן",
  "block.minecraft.banner.half_vertical_right.brown": "לינקס ברוין געשפאלטן",
  "block.minecraft.banner.half_vertical_right.cyan": "לינקס טורקיז געשפאלטן",
  "block.minecraft.banner.half_vertical_right.gray": "לינקס גרוי געשפאלטן",
  "block.minecraft.banner.half_vertical_right.green": "לינקס גרין געשפאלטן",
  "block.minecraft.banner.half_vertical_right.light_blue": "לינקס העלבלוי געשפאלטן",
  "block.minecraft.banner.half_vertical_right.light_gray": "לינקס העלגרוי געשפאלטן",
  "block.minecraft.banner.half_vertical_right.lime": "לינקס העלגרין געשפאלטן",
  "block.minecraft.banner.half_vertical_right.magenta": "לינקס מאדזשענטא געשפאלטן",
  "block.minecraft.banner.half_vertical_right.orange": "לינקס אראנזש געשפאלטן",
  "block.minecraft.banner.half_vertical_right.pink": "לינקס העלרויט געשפאלטן",
  "block.minecraft.banner.half_vertical_right.purple": "לינקס לילא געשפאלטן",
  "block.minecraft.banner.half_vertical_right.red": "לינקס רויט געשפאלטן",
  "block.minecraft.banner.half_vertical_right.white": "לינקס ווייַס געשפאלטן",
  "block.minecraft.banner.half_vertical_right.yellow": "לינקס געל געשפאלטן",
  "block.minecraft.banner.mojang.black": "שווארצער שטעמפל",
  "block.minecraft.banner.mojang.blue": "בלויער שטעמפל",
  "block.minecraft.banner.mojang.brown": "ברוינער שטעמפל",
  "block.minecraft.banner.mojang.cyan": "טורקיזער שטעמפל",
  "block.minecraft.banner.mojang.gray": "גרויער שטעמפל",
  "block.minecraft.banner.mojang.green": "גרינער שטעמפל",
  "block.minecraft.banner.mojang.light_blue": "העלבלויער שטעמפל",
  "block.minecraft.banner.mojang.light_gray": "העלגרויער שטעמפל",
  "block.minecraft.banner.mojang.lime": "העלגרינער שטעמפל",
  "block.minecraft.banner.mojang.magenta": "מאדזשענטאער שטעמפל",
  "block.minecraft.banner.mojang.orange": "אראנזשער שטעמפל",
  "block.minecraft.banner.mojang.pink": "העלרויטער שטעמפל",
  "block.minecraft.banner.mojang.purple": "לילאער שטעמפל",
  "block.minecraft.banner.mojang.red": "רויטער שטעמפל",
  "block.minecraft.banner.mojang.white": "ווייסער שילדשטעמפל",
  "block.minecraft.banner.mojang.yellow": "געלער שטעמפל",
  "block.minecraft.banner.piglin.black": "שווארץ שנוק",
  "block.minecraft.banner.piglin.blue": "בלוי שנוק",
  "block.minecraft.banner.piglin.brown": "ברוין שנוק",
  "block.minecraft.banner.piglin.cyan": "סייאן שנוק",
  "block.minecraft.banner.piglin.gray": "גרוי סנאוט",
  "block.minecraft.banner.piglin.green": "גרין שנוק",
  "block.minecraft.banner.piglin.light_blue": "ליכט בלוי שנוק",
  "block.minecraft.banner.piglin.light_gray": "ליכט גריי שנוק",
  "block.minecraft.banner.piglin.lime": "לייַם שנוק",
  "block.minecraft.banner.piglin.magenta": "מאגענטא שנוק",
  "block.minecraft.banner.piglin.orange": "מאראנץ שנוק",
  "block.minecraft.banner.piglin.pink": "ראזעווע שנוק",
  "block.minecraft.banner.piglin.purple": "לילא שנוק",
  "block.minecraft.banner.piglin.red": "רויט שנוק",
  "block.minecraft.banner.piglin.white": "ווייסע שנוק",
  "block.minecraft.banner.piglin.yellow": "געל סנאוט",
  "block.minecraft.banner.rhombus.black": "שווארצס רויט",
  "block.minecraft.banner.rhombus.blue": "בלויס רויט",
  "block.minecraft.banner.rhombus.brown": "ברוינס רויט",
  "block.minecraft.banner.rhombus.cyan": "טורקיזס רויט",
  "block.minecraft.banner.rhombus.gray": "גרויס רויט",
  "block.minecraft.banner.rhombus.green": "גרינס רויט",
  "block.minecraft.banner.rhombus.light_blue": "העלבלויס רויט",
  "block.minecraft.banner.rhombus.light_gray": "העלגרויס רויט",
  "block.minecraft.banner.rhombus.lime": "העלגרינס רויט",
  "block.minecraft.banner.rhombus.magenta": "מאדזשענטאס רויט",
  "block.minecraft.banner.rhombus.orange": "אראנזשס רויט",
  "block.minecraft.banner.rhombus.pink": "העלרויטס רויט",
  "block.minecraft.banner.rhombus.purple": "לילאס רויט",
  "block.minecraft.banner.rhombus.red": "רויטס רויט",
  "block.minecraft.banner.rhombus.white": "ווייַסס רויט",
  "block.minecraft.banner.rhombus.yellow": "געלס רויט",
  "block.minecraft.banner.skull.black": "שווארצע שיידלפארעם",
  "block.minecraft.banner.skull.blue": "בלויע שיידלפארעם",
  "block.minecraft.banner.skull.brown": "ברוינע שיידלפארעם",
  "block.minecraft.banner.skull.cyan": "טורקיזע שיידלפארעם",
  "block.minecraft.banner.skull.gray": "גרויע שיידלפארעם",
  "block.minecraft.banner.skull.green": "גרינע שיידלפארעם",
  "block.minecraft.banner.skull.light_blue": "העלבלויע שיידלפארעם",
  "block.minecraft.banner.skull.light_gray": "העלגרויע שיידלפארעם",
  "block.minecraft.banner.skull.lime": "העלגרינע שיידלפארעם",
  "block.minecraft.banner.skull.magenta": "מאדזשענטאע שיידלפארעם",
  "block.minecraft.banner.skull.orange": "אראנזשע שיידלפארעם",
  "block.minecraft.banner.skull.pink": "העלרויטע שיידלפארעם",
  "block.minecraft.banner.skull.purple": "קריפע שיידלפארעם",
  "block.minecraft.banner.skull.red": "רויטע שיידלפארעם",
  "block.minecraft.banner.skull.white": "ווייסע שיידלפארעם",
  "block.minecraft.banner.skull.yellow": "געלע שיידלפארעם",
  "block.minecraft.banner.small_stripes.black": "פיר שווארצע פעל",
  "block.minecraft.banner.small_stripes.blue": "בלויע פעל",
  "block.minecraft.banner.small_stripes.brown": "ברוינער פעל",
  "block.minecraft.banner.small_stripes.cyan": "טורקיזע פעל",
  "block.minecraft.banner.small_stripes.gray": "גרויע פעל",
  "block.minecraft.banner.small_stripes.green": "גרינע פעל",
  "block.minecraft.banner.small_stripes.light_blue": "העלבלויע פעל",
  "block.minecraft.banner.small_stripes.light_gray": "העלגרויע פעל",
  "block.minecraft.banner.small_stripes.lime": "העלגרינע פעל",
  "block.minecraft.banner.small_stripes.magenta": "מאדזשענטאע פעל",
  "block.minecraft.banner.small_stripes.orange": "אראנזשע פעל",
  "block.minecraft.banner.small_stripes.pink": "העלרויטע פעל",
  "block.minecraft.banner.small_stripes.purple": "לילאע פעל",
  "block.minecraft.banner.small_stripes.red": "רויטע פעל",
  "block.minecraft.banner.small_stripes.white": "ווייסע פעל",
  "block.minecraft.banner.small_stripes.yellow": "געלע פעל",
  "block.minecraft.banner.square_bottom_left.black": "שווארצער רעכטער אונטערעק",
  "block.minecraft.banner.square_bottom_left.blue": "בלויער רעכטער אונטערעק",
  "block.minecraft.banner.square_bottom_left.brown": "ברוינער רעכטער אונטערעק",
  "block.minecraft.banner.square_bottom_left.cyan": "טורקיזער רעכטער אונטערעק",
  "block.minecraft.banner.square_bottom_left.gray": "גרויער רעכטער אונטערעק",
  "block.minecraft.banner.square_bottom_left.green": "גרינער רעכטער אונטערעק",
  "block.minecraft.banner.square_bottom_left.light_blue": "העלבלויער רעכטער אונטערעק",
  "block.minecraft.banner.square_bottom_left.light_gray": "העלגרויער רעכטער אונטערעק",
  "block.minecraft.banner.square_bottom_left.lime": "העלגרינער רעכטער אונטערעק",
  "block.minecraft.banner.square_bottom_left.magenta": "מאדזשענטאער רעכטער אונטערעק",
  "block.minecraft.banner.square_bottom_left.orange": "אראנזשער רעכטער אונטערעק",
  "block.minecraft.banner.square_bottom_left.pink": "העלרויטער רעכטער אונטערעק",
  "block.minecraft.banner.square_bottom_left.purple": "לילאער רעכטער אונטערעק",
  "block.minecraft.banner.square_bottom_left.red": "רויטער רעכטער אונטערעק",
  "block.minecraft.banner.square_bottom_left.white": "ווייסער רעכטער אונטערעק",
  "block.minecraft.banner.square_bottom_left.yellow": "געלער רעכטער אונטערעק",
  "block.minecraft.banner.square_bottom_right.black": "שווארצער לינקער אונטערעק",
  "block.minecraft.banner.square_bottom_right.blue": "בלויער לינקער אונטערעק",
  "block.minecraft.banner.square_bottom_right.brown": "ברוינער לינקער אונטערעק",
  "block.minecraft.banner.square_bottom_right.cyan": "טורקיזער לינקער אונטערעק",
  "block.minecraft.banner.square_bottom_right.gray": "גרויער לינקער אונטערעק",
  "block.minecraft.banner.square_bottom_right.green": "גרינער לינקער אונטערעק",
  "block.minecraft.banner.square_bottom_right.light_blue": "העלבלויער לינקער אונטערעק",
  "block.minecraft.banner.square_bottom_right.light_gray": "העלגרויער לינקער אונטערעק",
  "block.minecraft.banner.square_bottom_right.lime": "העלגרינער לינקער אונטערעק",
  "block.minecraft.banner.square_bottom_right.magenta": "מאדזשענטאער לינקער אונטערעק",
  "block.minecraft.banner.square_bottom_right.orange": "אראנזשער לינקער אונטערעק",
  "block.minecraft.banner.square_bottom_right.pink": "העלרויטער לינקער אונטערעק",
  "block.minecraft.banner.square_bottom_right.purple": "לילאער לינקער אונטערעק",
  "block.minecraft.banner.square_bottom_right.red": "רויטער לינקער אונטערעק",
  "block.minecraft.banner.square_bottom_right.white": "ווייסער לינקער אונטערעק",
  "block.minecraft.banner.square_bottom_right.yellow": "געלער לינקער אונטערעק",
  "block.minecraft.banner.square_top_left.black": "שווארצער רעכטער אייבערעק",
  "block.minecraft.banner.square_top_left.blue": "בלויער רעכטער אייבערעק",
  "block.minecraft.banner.square_top_left.brown": "ברוינער רעכטער אייבערעק",
  "block.minecraft.banner.square_top_left.cyan": "טורקיזער רעכטער אייבערעק",
  "block.minecraft.banner.square_top_left.gray": "גרויער רעכטער אייבערעק",
  "block.minecraft.banner.square_top_left.green": "גרינער רעכטער אייבערעק",
  "block.minecraft.banner.square_top_left.light_blue": "העלבלויער רעכטער אייבערעק",
  "block.minecraft.banner.square_top_left.light_gray": "העלגרויער רעכטער אייבערעק",
  "block.minecraft.banner.square_top_left.lime": "העלגרינער רעכטער אייבערעק",
  "block.minecraft.banner.square_top_left.magenta": "מאדזשענטאער רעכטער אייבערעק",
  "block.minecraft.banner.square_top_left.orange": "אראנזשער רעכטער אייבערעק",
  "block.minecraft.banner.square_top_left.pink": "העלרויטער רעכטער אייבערעק",
  "block.minecraft.banner.square_top_left.purple": "לילאער רעכטער אייבערעק",
  "block.minecraft.banner.square_top_left.red": "רויטער רעכטער אייבערעק",
  "block.minecraft.banner.square_top_left.white": "ווייסער רעכטער אייבערעק",
  "block.minecraft.banner.square_top_left.yellow": "געלער רעכטער אייבערעק",
  "block.minecraft.banner.square_top_right.black": "שווארצער לינקער אייבערעק",
  "block.minecraft.banner.square_top_right.blue": "בלויער לינקער אייבערעק",
  "block.minecraft.banner.square_top_right.brown": "ברויינער לינקער אייבערעק",
  "block.minecraft.banner.square_top_right.cyan": "טורקיזער לינקער אייבערעק",
  "block.minecraft.banner.square_top_right.gray": "גרויער לינקער אייבערעק",
  "block.minecraft.banner.square_top_right.green": "גרינער לינקער אייבערעק",
  "block.minecraft.banner.square_top_right.light_blue": "העלבלויער לינקער אייבערעק",
  "block.minecraft.banner.square_top_right.light_gray": "העלגרויער לינקער אייבערעק",
  "block.minecraft.banner.square_top_right.lime": "העלגרינער לינקער אייבערעק",
  "block.minecraft.banner.square_top_right.magenta": "מאדזשענטאער לינקער אייבערעק",
  "block.minecraft.banner.square_top_right.orange": "אראנזשער לינקער אייבערעק",
  "block.minecraft.banner.square_top_right.pink": "העלרויטער לינקער אייבערעק",
  "block.minecraft.banner.square_top_right.purple": "לילאער לינקער אייבערעק",
  "block.minecraft.banner.square_top_right.red": "רויטער רוייטער לינקער אייבערעק",
  "block.minecraft.banner.square_top_right.white": "ווייסער לינקער אייבערעק",
  "block.minecraft.banner.square_top_right.yellow": "געלער לינקער אייבערעק",
  "block.minecraft.banner.straight_cross.black": "שווארצער קרייץ",
  "block.minecraft.banner.straight_cross.blue": "בלויער קרייץ",
  "block.minecraft.banner.straight_cross.brown": "ברוינער קרייץ",
  "block.minecraft.banner.straight_cross.cyan": "טורקיזער קרייץ",
  "block.minecraft.banner.straight_cross.gray": "גרויער קרייץ",
  "block.minecraft.banner.straight_cross.green": "גרינער קרייץ",
  "block.minecraft.banner.straight_cross.light_blue": "העלבלויער קרייץ",
  "block.minecraft.banner.straight_cross.light_gray": "העלגרויער קרייץ",
  "block.minecraft.banner.straight_cross.lime": "העלגרינער קרייץ",
  "block.minecraft.banner.straight_cross.magenta": "מאדזשענטאער קרייץ",
  "block.minecraft.banner.straight_cross.orange": "אראנזשער קרייץ",
  "block.minecraft.banner.straight_cross.pink": "העלרויטער קרייץ",
  "block.minecraft.banner.straight_cross.purple": "לילאער קרייץ",
  "block.minecraft.banner.straight_cross.red": "רעכטער קרייץ",
  "block.minecraft.banner.straight_cross.white": "ווייסער קרייץ",
  "block.minecraft.banner.straight_cross.yellow": "געלער קרייץ",
  "block.minecraft.banner.stripe_bottom.black": "שווארצער פאנפוס",
  "block.minecraft.banner.stripe_bottom.blue": "בלויער פאנפוס",
  "block.minecraft.banner.stripe_bottom.brown": "ברויינער פאנפוס",
  "block.minecraft.banner.stripe_bottom.cyan": "טורקיזער פאנפוס",
  "block.minecraft.banner.stripe_bottom.gray": "גרויער פאנפוס",
  "block.minecraft.banner.stripe_bottom.green": "גרינער פאנפוס",
  "block.minecraft.banner.stripe_bottom.light_blue": "העלבלויער פאנפוס",
  "block.minecraft.banner.stripe_bottom.light_gray": "העלגרויער פאנפוס",
  "block.minecraft.banner.stripe_bottom.lime": "העלגרינער פאנפוס",
  "block.minecraft.banner.stripe_bottom.magenta": "מאדזשענטאער פאנפוס",
  "block.minecraft.banner.stripe_bottom.orange": "אראנזשער פאנפוס",
  "block.minecraft.banner.stripe_bottom.pink": "העלרויטער פאנפוס",
  "block.minecraft.banner.stripe_bottom.purple": "לילאער פאנפוס",
  "block.minecraft.banner.stripe_bottom.red": "רויטער פאנפוס",
  "block.minecraft.banner.stripe_bottom.white": "ווייסער פאנפוס",
  "block.minecraft.banner.stripe_bottom.yellow": "געלער פאנפוס",
  "block.minecraft.banner.stripe_center.black": "שווארצער פאל",
  "block.minecraft.banner.stripe_center.blue": "ברויער פאל",
  "block.minecraft.banner.stripe_center.brown": "ברוינער פאל",
  "block.minecraft.banner.stripe_center.cyan": "טורקיזער פאל",
  "block.minecraft.banner.stripe_center.gray": "גרויער פאל",
  "block.minecraft.banner.stripe_center.green": "גרינער פאל",
  "block.minecraft.banner.stripe_center.light_blue": "העלברויער פאל",
  "block.minecraft.banner.stripe_center.light_gray": "העלגרויער פאל",
  "block.minecraft.banner.stripe_center.lime": "העלגרינער פאל",
  "block.minecraft.banner.stripe_center.magenta": "מאדזשענטאער פאל",
  "block.minecraft.banner.stripe_center.orange": "אראנזשער פאל",
  "block.minecraft.banner.stripe_center.pink": "העלרויטער פאל",
  "block.minecraft.banner.stripe_center.purple": "לילאער פאל",
  "block.minecraft.banner.stripe_center.red": "רוייטער פאל",
  "block.minecraft.banner.stripe_center.white": "ווייסער פאל",
  "block.minecraft.banner.stripe_center.yellow": "געלער פאל",
  "block.minecraft.banner.stripe_downleft.black": "שווארצער שרעגלינקסבאלקן",
  "block.minecraft.banner.stripe_downleft.blue": "בלויער שרעגלינקסבאלקנ",
  "block.minecraft.banner.stripe_downleft.brown": "ברוינער שרעגלינקסבאלקן",
  "block.minecraft.banner.stripe_downleft.cyan": "טורקיזער שרעגלינקסבאלקנ",
  "block.minecraft.banner.stripe_downleft.gray": "גרויער שרעגלינקסבאלקן",
  "block.minecraft.banner.stripe_downleft.green": "גרינער שרעגלינקסבאלקן",
  "block.minecraft.banner.stripe_downleft.light_blue": "העלבלויער שרעגלינקסבאלקנ",
  "block.minecraft.banner.stripe_downleft.light_gray": "העלגרויער שרעגלינקסבאלקן",
  "block.minecraft.banner.stripe_downleft.lime": "העלגרינער שרעגלינקסבאלקנ",
  "block.minecraft.banner.stripe_downleft.magenta": "מאדזשענטאער שרעגלינקסבאלקן",
  "block.minecraft.banner.stripe_downleft.orange": "אראנזשער שרעגלינקסבאלקן",
  "block.minecraft.banner.stripe_downleft.pink": "העלרויטער שרעגלינקסבאלקנ",
  "block.minecraft.banner.stripe_downleft.purple": "לילאער שרעגלינקסבאלקן",
  "block.minecraft.banner.stripe_downleft.red": "רויטער שרעגלינקסבאלקן",
  "block.minecraft.banner.stripe_downleft.white": "ווייסער שרעגלינקסבאלקן",
  "block.minecraft.banner.stripe_downleft.yellow": "געלער שרעגלינקסבאלקנ",
  "block.minecraft.banner.stripe_downright.black": "שווארצער שרעגבאלקן",
  "block.minecraft.banner.stripe_downright.blue": "בלויער שרעגבאלקן",
  "block.minecraft.banner.stripe_downright.brown": "ברוינער שרעגבאלקן",
  "block.minecraft.banner.stripe_downright.cyan": "טורקיזער שרעגבאלקן",
  "block.minecraft.banner.stripe_downright.gray": "גרויער שרעגבאלקן",
  "block.minecraft.banner.stripe_downright.green": "גרינער שרעגבאלקן",
  "block.minecraft.banner.stripe_downright.light_blue": "העלבלויער שרעגבאלקן",
  "block.minecraft.banner.stripe_downright.light_gray": "העלגרויער שרעגבאלקן",
  "block.minecraft.banner.stripe_downright.lime": "העלגרינער שרעגבאלקן",
  "block.minecraft.banner.stripe_downright.magenta": "מאדזשענטאער שרעגבאלקן",
  "block.minecraft.banner.stripe_downright.orange": "אראנזשער שרעגבאלקן",
  "block.minecraft.banner.stripe_downright.pink": "העלרויטער שרעגבאלקן",
  "block.minecraft.banner.stripe_downright.purple": "לילאער שרעגבאלקן",
  "block.minecraft.banner.stripe_downright.red": "רויטער שרעגבאלקן",
  "block.minecraft.banner.stripe_downright.white": "ווייסער שרעגבאלקן",
  "block.minecraft.banner.stripe_downright.yellow": "געלער שרעגבאלקן",
  "block.minecraft.banner.stripe_left.black": "שווארצער רעכטער פלאנק",
  "block.minecraft.banner.stripe_left.blue": "ברויער רעכטער פלאנק",
  "block.minecraft.banner.stripe_left.brown": "ברוינער רעכטער פלאנק",
  "block.minecraft.banner.stripe_left.cyan": "טורקיזער רעכטער פלאנק",
  "block.minecraft.banner.stripe_left.gray": "גרויער רעכטער פלאנק",
  "block.minecraft.banner.stripe_left.green": "גרינער רעכטער פלאנק",
  "block.minecraft.banner.stripe_left.light_blue": "העלברויער רעכטער פלאנק",
  "block.minecraft.banner.stripe_left.light_gray": "העלגרויער רעכטער פלאנק",
  "block.minecraft.banner.stripe_left.lime": "העלגרינער רעכטער פלאנק",
  "block.minecraft.banner.stripe_left.magenta": "מאדזשענטאער רעכטער פלאנק",
  "block.minecraft.banner.stripe_left.orange": "אראנזשער רעכטער פלאנק",
  "block.minecraft.banner.stripe_left.pink": "העלרויטער רעכטער פלאנק",
  "block.minecraft.banner.stripe_left.purple": "לילאער רעכטער פלאנק",
  "block.minecraft.banner.stripe_left.red": "רויטער רעכטער פלאנק",
  "block.minecraft.banner.stripe_left.white": "ווייסער רעכטער פלאנק",
  "block.minecraft.banner.stripe_left.yellow": "געלער רעכטער פלאנק",
  "block.minecraft.banner.stripe_middle.black": "שווארצער באלקן",
  "block.minecraft.banner.stripe_middle.blue": "בלויער באלקן",
  "block.minecraft.banner.stripe_middle.brown": "ברוינער באלקן",
  "block.minecraft.banner.stripe_middle.cyan": "טורקיזער באלקן",
  "block.minecraft.banner.stripe_middle.gray": "גרויער באלקן",
  "block.minecraft.banner.stripe_middle.green": "גרינער באלקן",
  "block.minecraft.banner.stripe_middle.light_blue": "העלבלויער באלקן",
  "block.minecraft.banner.stripe_middle.light_gray": "העלגרויער באלקן",
  "block.minecraft.banner.stripe_middle.lime": "העלגרינער באלקן",
  "block.minecraft.banner.stripe_middle.magenta": "מאדזשענטאער באלקן",
  "block.minecraft.banner.stripe_middle.orange": "אראנזשער באלקן",
  "block.minecraft.banner.stripe_middle.pink": "העלרויטער באלקן",
  "block.minecraft.banner.stripe_middle.purple": "לילאער באלקן",
  "block.minecraft.banner.stripe_middle.red": "רעכטער באלקן",
  "block.minecraft.banner.stripe_middle.white": "ווייסער באלקן",
  "block.minecraft.banner.stripe_middle.yellow": "געלער באלקן",
  "block.minecraft.banner.stripe_right.black": "שווארצער לינקער פלאנק",
  "block.minecraft.banner.stripe_right.blue": "ברויער לינקער פלאנק",
  "block.minecraft.banner.stripe_right.brown": "ברוינער לינקער פלאנק",
  "block.minecraft.banner.stripe_right.cyan": "טורקיזער לינקער פלאנק",
  "block.minecraft.banner.stripe_right.gray": "גרויער לינקער פלאנק",
  "block.minecraft.banner.stripe_right.green": "גרינער לינקער פלאנק",
  "block.minecraft.banner.stripe_right.light_blue": "העלברויער לינקער פלאנק",
  "block.minecraft.banner.stripe_right.light_gray": "העלגרויער לינקער פלאנק",
  "block.minecraft.banner.stripe_right.lime": "העלגרינער לינקער פלאנק",
  "block.minecraft.banner.stripe_right.magenta": "מאדזשענטאער לינקער פלאנק",
  "block.minecraft.banner.stripe_right.orange": "אראנזשער לינקער פלאנק",
  "block.minecraft.banner.stripe_right.pink": "העלרויטער לינקער פלאנק",
  "block.minecraft.banner.stripe_right.purple": "לילאער לינקער פלאנק",
  "block.minecraft.banner.stripe_right.red": "רעכטער פלאנק לינקער",
  "block.minecraft.banner.stripe_right.white": "ווייסער לינקער פלאנק",
  "block.minecraft.banner.stripe_right.yellow": "געלער לינקער פלאנק",
  "block.minecraft.banner.stripe_top.black": "שווארצס פאנהויפט",
  "block.minecraft.banner.stripe_top.blue": "בלויס פאנהויפט",
  "block.minecraft.banner.stripe_top.brown": "ברויינס פאנהויפט",
  "block.minecraft.banner.stripe_top.cyan": "טורקיזס פאנהויפט",
  "block.minecraft.banner.stripe_top.gray": "גרויס פאנהויפט",
  "block.minecraft.banner.stripe_top.green": "גרינס פאנהויפט",
  "block.minecraft.banner.stripe_top.light_blue": "העלבלויס פאנהויפט",
  "block.minecraft.banner.stripe_top.light_gray": "העלגרויס פאנהויפט",
  "block.minecraft.banner.stripe_top.lime": "העלגרינס פאנהויפט",
  "block.minecraft.banner.stripe_top.magenta": "מאדזשענטאס פאנהויפט",
  "block.minecraft.banner.stripe_top.orange": "אראנזשס פאנהויפט",
  "block.minecraft.banner.stripe_top.pink": "העלרויטס פאנהויפט",
  "block.minecraft.banner.stripe_top.purple": "לילאס פאנהויפט",
  "block.minecraft.banner.stripe_top.red": "רויטס פאנהויפט",
  "block.minecraft.banner.stripe_top.white": "ווייסס פאנהויפט",
  "block.minecraft.banner.stripe_top.yellow": "געלס פאנהויפט",
  "block.minecraft.banner.triangle_bottom.black": "שווארצע האלבע שפיץ",
  "block.minecraft.banner.triangle_bottom.blue": "בלויע האלבע שפיץ",
  "block.minecraft.banner.triangle_bottom.brown": "ברוינע האלבע שפיץ",
  "block.minecraft.banner.triangle_bottom.cyan": "טורקיזע האלבע שפיץ",
  "block.minecraft.banner.triangle_bottom.gray": "גרויע האלבע שפיץ",
  "block.minecraft.banner.triangle_bottom.green": "גרינע האלבע שפיץ",
  "block.minecraft.banner.triangle_bottom.light_blue": "העלבלויע האלבע שפיץ",
  "block.minecraft.banner.triangle_bottom.light_gray": "העלגרויע האלבע שפיץ",
  "block.minecraft.banner.triangle_bottom.lime": "העלגרינע האלבע שפיץ",
  "block.minecraft.banner.triangle_bottom.magenta": "מאדזשענטאע האלבע שפיץ",
  "block.minecraft.banner.triangle_bottom.orange": "אראנזשע האלבע שפיץ",
  "block.minecraft.banner.triangle_bottom.pink": "העלרויטע האלבע שפיץ",
  "block.minecraft.banner.triangle_bottom.purple": "לילאע האלבע שפיץ",
  "block.minecraft.banner.triangle_bottom.red": "רויטע האלבע שפיץ",
  "block.minecraft.banner.triangle_bottom.white": "ווייסע האלבע שפיץ",
  "block.minecraft.banner.triangle_bottom.yellow": "געלע האלבע שפיץ",
  "block.minecraft.banner.triangle_top.black": "שווארצע קאפויערער האלבע שפיץ",
  "block.minecraft.banner.triangle_top.blue": "בלויע געשטירצטע האלבע שפיץ",
  "block.minecraft.banner.triangle_top.brown": "ברוינע געשטירצטע האלבע שפיץ",
  "block.minecraft.banner.triangle_top.cyan": "טורקיזע געשטירצטע האלבע שפיץ",
  "block.minecraft.banner.triangle_top.gray": "גרויע געשטירצטע האלבע שפיץ",
  "block.minecraft.banner.triangle_top.green": "גרינע געשטירצטע האלבע שפיץ",
  "block.minecraft.banner.triangle_top.light_blue": "העלבלויע געשטירצטע האלבע שפיץ",
  "block.minecraft.banner.triangle_top.light_gray": "העלגרויע געשטירצטע האלבע שפיץ",
  "block.minecraft.banner.triangle_top.lime": "העלגרינע געשטירצטע האלבע שפיץ",
  "block.minecraft.banner.triangle_top.magenta": "מאדזשענטאע געשטירצטע האלבע שפיץ",
  "block.minecraft.banner.triangle_top.orange": "אראנזשע געשטירצטע האלבע שפיץ",
  "block.minecraft.banner.triangle_top.pink": "העלרויטע געשטירצטע האלבע שפיץ",
  "block.minecraft.banner.triangle_top.purple": "לילאע געשטירצטע האלבע שפיץ",
  "block.minecraft.banner.triangle_top.red": "רויטע געשטירצטע האלבע שפיץ",
  "block.minecraft.banner.triangle_top.white": "ווייסע געשטירצטע האלבע שפיץ",
  "block.minecraft.banner.triangle_top.yellow": "געלע געשטירצטע האלבע שפיץ",
  "block.minecraft.banner.triangles_bottom.black": "שווארצער געשפיקעלטער פאנפוס",
  "block.minecraft.banner.triangles_bottom.blue": "בלויער געשפיקלטער פאנפוס",
  "block.minecraft.banner.triangles_bottom.brown": "ברוינער געשפיקלטער פאנפוס",
  "block.minecraft.banner.triangles_bottom.cyan": "טורקיזער געשפיקלטער פאנפוס",
  "block.minecraft.banner.triangles_bottom.gray": "גרויער געשפיקלטער פאנפוס",
  "block.minecraft.banner.triangles_bottom.green": "גרינער געשפיקלטער פאנפוס",
  "block.minecraft.banner.triangles_bottom.light_blue": "העלברויער געשפיקלטער פאנפוס",
  "block.minecraft.banner.triangles_bottom.light_gray": "העלגרויער געשפיקלטער פאנפוס",
  "block.minecraft.banner.triangles_bottom.lime": "העלגרינער געשפיקלטער פאנפוס",
  "block.minecraft.banner.triangles_bottom.magenta": "מאדזשענטאער געשפיקלטער פאנפוס",
  "block.minecraft.banner.triangles_bottom.orange": "אראנזשער געשפיקלטער פאנפוס",
  "block.minecraft.banner.triangles_bottom.pink": "העלרויטער געשפיקלטער פאנפוס",
  "block.minecraft.banner.triangles_bottom.purple": "לילאער געשפיקלטער פאנפוס",
  "block.minecraft.banner.triangles_bottom.red": "געשפיקלטער רויטער פאנפוס",
  "block.minecraft.banner.triangles_bottom.white": "ווייסער געשפיקלטער פאנפוס",
  "block.minecraft.banner.triangles_bottom.yellow": "געלער געשפיקלטער פאנפוס",
  "block.minecraft.banner.triangles_top.black": "שווארצס געשפיקעלטס פאנהויפט",
  "block.minecraft.banner.triangles_top.blue": "בלויס געשפיקלטס פאנהויפט",
  "block.minecraft.banner.triangles_top.brown": "ברויינס געשפיקלטס פאנהויפט",
  "block.minecraft.banner.triangles_top.cyan": "טורקיזס געשפיקלטס פאנהויפט",
  "block.minecraft.banner.triangles_top.gray": "גרויס געשפיקלטס פאנהויפט",
  "block.minecraft.banner.triangles_top.green": "גרינס געשפיקלטס פאנהויפט",
  "block.minecraft.banner.triangles_top.light_blue": "העלבלויס געשפיקלטס פאנהויפט",
  "block.minecraft.banner.triangles_top.light_gray": "העלגרויס געשפיקלטס פאנהויפט",
  "block.minecraft.banner.triangles_top.lime": "העלגרינס געשפיקלטס פאנהויפט",
  "block.minecraft.banner.triangles_top.magenta": "מאדזשענטאס געשפיקלטס פאנהויפט",
  "block.minecraft.banner.triangles_top.orange": "אראנזשס געשפיקלטס פאנהויפט",
  "block.minecraft.banner.triangles_top.pink": "העלרויטס געשפיקלטס פאנהויפט",
  "block.minecraft.banner.triangles_top.purple": "לילאס געשפיקלטס פאנהויפט",
  "block.minecraft.banner.triangles_top.red": "רויטס געשפיקלטס פאנהויפט",
  "block.minecraft.banner.triangles_top.white": "ווייסס געשפיקלטס פאנהויפט",
  "block.minecraft.banner.triangles_top.yellow": "געלס געשפיקלטס פאנהויפט",
  "block.minecraft.barrel": "פאס",
  "block.minecraft.barrier": "באריער",
  "block.minecraft.basalt": "באזאלט",
  "block.minecraft.beacon": "לייַכטפֿייַער",
  "block.minecraft.beacon.primary": "הויפּטווירקונג",
  "block.minecraft.beacon.secondary": "צווייטע ווירקונג",
  "block.minecraft.bed.no_sleep": "דו קענסט נאר שלאפן בייַנאכט אדער בשעת שטורעמס",
  "block.minecraft.bed.not_safe": "דו קענסט נישט שלאפן יצט, עס גיבט מאנסטערס דערבייַ",
  "block.minecraft.bed.obstructed": "דאס בעט איז בלאקירט",
  "block.minecraft.bed.occupied": "דאס בעט איז באלעגט",
  "block.minecraft.bed.too_far_away": "דו קענסט נישט שלאפן יצט, דאס בעט איז צו ווייַט אוועק",
  "block.minecraft.bedrock": "טיפֿגרונטשטיין",
  "block.minecraft.bee_nest": "ביננעסט",
  "block.minecraft.beehive": "בינשטאק",
  "block.minecraft.beetroots": "צוויקעס",
  "block.minecraft.bell": "גלאק",
  "block.minecraft.big_dripleaf": "גרויס דריפּלעף",
  "block.minecraft.big_dripleaf_stem": "גרויס דריפּלעף סטעם",
  "block.minecraft.birch_button": "בערעזעהאלצקנאף",
  "block.minecraft.birch_door": "בערעזעהאלצטיר",
  "block.minecraft.birch_fence": "בערעזעהאלצצוים",
  "block.minecraft.birch_fence_gate": "בערעזעהאלצצוימטויער",
  "block.minecraft.birch_hanging_sign": "בערעזע כאַנגגינג צייכן",
  "block.minecraft.birch_leaves": "בערעזעבלעטער",
  "block.minecraft.birch_log": "בערעזעשטאם",
  "block.minecraft.birch_planks": "בערעזעהאלצברעטער",
  "block.minecraft.birch_pressure_plate": "בערעזעהאלצדרוקפּלאטע",
  "block.minecraft.birch_sapling": "בערעזעזעצלינג",
  "block.minecraft.birch_shelf": "Birch Shelf",
  "block.minecraft.birch_sign": "בערעזעהאלצשילד",
  "block.minecraft.birch_slab": "בערעזעהאלצפּלאטע",
  "block.minecraft.birch_stairs": "בערעזעהאלצטרעף",
  "block.minecraft.birch_trapdoor": "בערעזעהילצערנע פאַלטיר",
  "block.minecraft.birch_wall_hanging_sign": "בערעזע וואנט כאַנגגינג צייכן",
  "block.minecraft.birch_wall_sign": "בערעזעהאלצוואנדשילד",
  "block.minecraft.birch_wood": "בערעזעהאלץ",
  "block.minecraft.black_banner": "שווארצע פאן",
  "block.minecraft.black_bed": "שווארצס בעט",
  "block.minecraft.black_candle": "שוואַרץ ליכט",
  "block.minecraft.black_candle_cake": "שטיקל מיט שוואַרץ ליכט",
  "block.minecraft.black_carpet": "שווארצער טעפּעך",
  "block.minecraft.black_concrete": "שווארצבעטאן",
  "block.minecraft.black_concrete_powder": "שווארצבעטאנפולווער",
  "block.minecraft.black_glazed_terracotta": "שווארצגלאזירטע קעראמיק",
  "block.minecraft.black_shulker_box": "שווארצע שולקערקאסע",
  "block.minecraft.black_stained_glass": "שווארצגעפֿארבטס גלאז",
  "block.minecraft.black_stained_glass_pane": "שווארצגעפֿארבטע גלאזשויב",
  "block.minecraft.black_terracotta": "שווארצע קעראמיק",
  "block.minecraft.black_wool": "שווארצע וואל",
  "block.minecraft.blackstone": "שווארצשטיין",
  "block.minecraft.blackstone_slab": "שווארצשטיינפלאטע",
  "block.minecraft.blackstone_stairs": "שווארצשטיינטרעף",
  "block.minecraft.blackstone_wall": "שווארצשטיינמויער",
  "block.minecraft.blast_furnace": "שמעלצויוון",
  "block.minecraft.blue_banner": "בלויע פאן",
  "block.minecraft.blue_bed": "בלויס בעט",
  "block.minecraft.blue_candle": "בלוי קאַנדלע",
  "block.minecraft.blue_candle_cake": "שטיקל מיט בלו קאַנדלע",
  "block.minecraft.blue_carpet": "בלויער טעפּעך",
  "block.minecraft.blue_concrete": "בלויבעטאן",
  "block.minecraft.blue_concrete_powder": "בלויבעטאנפולווער",
  "block.minecraft.blue_glazed_terracotta": "בלויגלאזירטע קעראמיק",
  "block.minecraft.blue_ice": "בלויייַז",
  "block.minecraft.blue_orchid": "בלויע ארכידייע",
  "block.minecraft.blue_shulker_box": "בלויע שולקערקאסע",
  "block.minecraft.blue_stained_glass": "בלויגעפֿארבטס גלאז",
  "block.minecraft.blue_stained_glass_pane": "בלויגעפֿארבטע גלאזשויב",
  "block.minecraft.blue_terracotta": "בלויע קעראמיק",
  "block.minecraft.blue_wool": "בלויע וואל",
  "block.minecraft.bone_block": "ביינבלאק",
  "block.minecraft.bookshelf": "ביכערשענק",
  "block.minecraft.brain_coral": "געהירנקאראל",
  "block.minecraft.brain_coral_block": "געהירנקאראלנבלאק",
  "block.minecraft.brain_coral_fan": "געהירנקאראלנפעכער",
  "block.minecraft.brain_coral_wall_fan": "געהירנקאראלנוואנדפעכער",
  "block.minecraft.brewing_stand": "ברוישטאנד",
  "block.minecraft.brick_slab": "ציגלשטיינפּלאטע",
  "block.minecraft.brick_stairs": "ציגלטשטיינרעף",
  "block.minecraft.brick_wall": "ציגלשטיינמויער",
  "block.minecraft.bricks": "ציגלשטיינער",
  "block.minecraft.brown_banner": "ברוינע פאן",
  "block.minecraft.brown_bed": "ברוינס בעט",
  "block.minecraft.brown_candle": "ברוין ליכט",
  "block.minecraft.brown_candle_cake": "שטיקל מיט ברוין ליכט",
  "block.minecraft.brown_carpet": "ברוינער טעפּעך",
  "block.minecraft.brown_concrete": "ברוינבעטאן",
  "block.minecraft.brown_concrete_powder": "ברוינבעטאנפולווער",
  "block.minecraft.brown_glazed_terracotta": "ברוינגלאזירטע קעראמיק",
  "block.minecraft.brown_mushroom": "ברוינשוועמל",
  "block.minecraft.brown_mushroom_block": "ברוינשוועמלבלאק",
  "block.minecraft.brown_shulker_box": "ברוינע שולקערקאסע",
  "block.minecraft.brown_stained_glass": "ברוינגעפֿארבטס גלאז",
  "block.minecraft.brown_stained_glass_pane": "ברוינגעפֿארבטע גלאזשויב",
  "block.minecraft.brown_terracotta": "ברוינע קעראמיק",
  "block.minecraft.brown_wool": "ברוינע וואל",
  "block.minecraft.bubble_column": "בלאזנזייל",
  "block.minecraft.bubble_coral": "בלאזקאראל",
  "block.minecraft.bubble_coral_block": "בלאזקאראלנבלאק",
  "block.minecraft.bubble_coral_fan": "בלאזקאראלנפעכער",
  "block.minecraft.bubble_coral_wall_fan": "בלאזקאראלנוואנדפעכער",
  "block.minecraft.budding_amethyst": "באַדינג אַמעטהיסט",
  "block.minecraft.bush": "קוסט",
  "block.minecraft.cactus": "קאקטוס",
  "block.minecraft.cactus_flower": "קאַקטוסבלום",
  "block.minecraft.cake": "באבקע",
  "block.minecraft.calcite": "קאַלסייט",
  "block.minecraft.calibrated_sculk_sensor": "קאַלאַברייטיד סקולק סענסאָר",
  "block.minecraft.campfire": "לאגערפייער",
  "block.minecraft.candle": "ליכט",
  "block.minecraft.candle_cake": "שפּיל ליכט שטיקל",
  "block.minecraft.carrots": "מערן",
  "block.minecraft.cartography_table": "קארטנטיש",
  "block.minecraft.carved_pumpkin": "געשניצער קירבעס",
  "block.minecraft.cauldron": "קעסל",
  "block.minecraft.cave_air": "היילנלופט",
  "block.minecraft.cave_vines": "קאַווע וויינז",
  "block.minecraft.cave_vines_plant": "קאַווע וויינז פּלאַנט",
  "block.minecraft.chain": "פארקייטלן",
  "block.minecraft.chain_command_block": "קייטנבאפֿעלסבלאק",
  "block.minecraft.cherry_button": "קאַרש קנעפּל",
  "block.minecraft.cherry_door": "קאַרש טיר",
  "block.minecraft.cherry_fence": "קאַרש פענס",
  "block.minecraft.cherry_fence_gate": "קאַרש פענס גייט",
  "block.minecraft.cherry_hanging_sign": "קאַרש האַנגינג צייכן",
  "block.minecraft.cherry_leaves": "קאַרש בלעטער",
  "block.minecraft.cherry_log": "קאַרש קלאָץ",
  "block.minecraft.cherry_planks": "קאַרש פּלאַנקס",
  "block.minecraft.cherry_pressure_plate": "קאַרש דרוק פּלאַטע",
  "block.minecraft.cherry_sapling": "קאַרש סאַפּלינג",
  "block.minecraft.cherry_shelf": "Cherry Shelf",
  "block.minecraft.cherry_sign": "קאַרש צייכן",
  "block.minecraft.cherry_slab": "קאַרש פּלאַטע",
  "block.minecraft.cherry_stairs": "קאַרש סטאַירס",
  "block.minecraft.cherry_trapdoor": "קאַרש טראַפּדאָר",
  "block.minecraft.cherry_wall_hanging_sign": "קאַרש וואנט כאַנגגינג צייכן",
  "block.minecraft.cherry_wall_sign": "קאַרש וואנט צייכן",
  "block.minecraft.cherry_wood": "קאַרש האָלץ",
  "block.minecraft.chest": "קאסטן",
  "block.minecraft.chipped_anvil": "אנגעשלאגנער אנשטול",
  "block.minecraft.chiseled_bookshelf": "טשיסעלעד בוקשעלף",
  "block.minecraft.chiseled_copper": "סקאַלפּט קופּער",
  "block.minecraft.chiseled_deepslate": "סקאַלפּטיד וואַקס",
  "block.minecraft.chiseled_nether_bricks": "גראווירטע נעדערציגל",
  "block.minecraft.chiseled_polished_blackstone": "גראווירטער פאלישט שווארצשטיין",
  "block.minecraft.chiseled_quartz_block": "גראווירטער קווארצבלאק",
  "block.minecraft.chiseled_red_sandstone": "גראווירטער רויטער זאמדשטיין",
  "block.minecraft.chiseled_resin_bricks": "גראווירטע סמאָלעציגל",
  "block.minecraft.chiseled_sandstone": "גראווירטער זאמדשטיין",
  "block.minecraft.chiseled_stone_bricks": "גראווירטע שטיינציגל",
  "block.minecraft.chiseled_tuff": "סקאַלפּטיד טאַף",
  "block.minecraft.chiseled_tuff_bricks": "סקאַלפּטיד טאַף בריקס",
  "block.minecraft.chorus_flower": "כארבלום",
  "block.minecraft.chorus_plant": "כארקרויט",
  "block.minecraft.clay": "ליימבלאק",
  "block.minecraft.closed_eyeblossom": "Closed Eyeblossom",
  "block.minecraft.coal_block": "קוילבלאק",
  "block.minecraft.coal_ore": "שטיינקויל",
  "block.minecraft.coarse_dirt": "גראבע ערד",
  "block.minecraft.cobbled_deepslate": "קאָבבלעד דעעפּסלאַטע",
  "block.minecraft.cobbled_deepslate_slab": "קאָבבלעד דעעפּסלאַטע סלאַב",
  "block.minecraft.cobbled_deepslate_stairs": "קאָבבלעד דעעפּסלאַטע טרעפּ",
  "block.minecraft.cobbled_deepslate_wall": "אַ פּאַוועד וווילשטאנד וואנט",
  "block.minecraft.cobblestone": "ברוקשטיין",
  "block.minecraft.cobblestone_slab": "ברוקפּלאטע",
  "block.minecraft.cobblestone_stairs": "ברוקטרעף",
  "block.minecraft.cobblestone_wall": "ברוקמויער",
  "block.minecraft.cobweb": "פאוועטינע",
  "block.minecraft.cocoa": "קאקאא",
  "block.minecraft.command_block": "באפֿעלסבלאק",
  "block.minecraft.comparator": "רעדסטאן־קאמפאראטאר",
  "block.minecraft.composter": "קאמפאסטער",
  "block.minecraft.conduit": "אקוויזאטאר",
  "block.minecraft.copper_bars": "קופּער שטאַנגען",
  "block.minecraft.copper_block": "בלאָק פון קאַפּער",
  "block.minecraft.copper_bulb": "קופּער ציבעלע",
  "block.minecraft.copper_chain": "Copper Chain",
  "block.minecraft.copper_chest": "Copper Chest",
  "block.minecraft.copper_door": "קופּער טיר",
  "block.minecraft.copper_golem_statue": "Copper Golem Statue",
  "block.minecraft.copper_grate": "קופּער כאַבאַרניק",
  "block.minecraft.copper_lantern": "Copper Lantern",
  "block.minecraft.copper_ore": "קופּער אַרץ",
  "block.minecraft.copper_torch": "Copper Torch",
  "block.minecraft.copper_trapdoor": "א באהאלטענע קופערנע טיר",
  "block.minecraft.copper_wall_torch": "Copper Wall Torch",
  "block.minecraft.cornflower": "קארנבלימל",
  "block.minecraft.cracked_deepslate_bricks": "קראַקט וואַפליע בריקס",
  "block.minecraft.cracked_deepslate_tiles": "קראַקט לאַוואַ טיילז",
  "block.minecraft.cracked_nether_bricks": "ריסיקע נעדערציגל",
  "block.minecraft.cracked_polished_blackstone_bricks": "קראקט פאלישט שווארצשטיינציגל",
  "block.minecraft.cracked_stone_bricks": "ריסיקע שטיינציגל",
  "block.minecraft.crafter": "ווערקער",
  "block.minecraft.crafting_table": "ווערקבאנק",
  "block.minecraft.creaking_heart": "סקריפּענדיקע האַרץ",
  "block.minecraft.creeper_head": "קריפערקאף",
  "block.minecraft.creeper_wall_head": "קריפערוואנדקאף",
  "block.minecraft.crimson_button": "פלאטע קנעפל",
  "block.minecraft.crimson_door": "פאמסן טיר",
  "block.minecraft.crimson_fence": "פאמסן פלויט",
  "block.minecraft.crimson_fence_gate": "פאמסן פלויט טויער",
  "block.minecraft.crimson_fungus": "פאמסן שוועמל",
  "block.minecraft.crimson_hanging_sign": "פּאָמסן האַנגינג צייכן",
  "block.minecraft.crimson_hyphae": "פאמסן היפא",
  "block.minecraft.crimson_nylium": "פאמסן ניליום",
  "block.minecraft.crimson_planks": "פאמסן בארדז",
  "block.minecraft.crimson_pressure_plate": "פאמסן דרוקפלאטע",
  "block.minecraft.crimson_roots": "פאמסן ווארצל",
  "block.minecraft.crimson_shelf": "Crimson Shelf",
  "block.minecraft.crimson_sign": "פאמסן שילד",
  "block.minecraft.crimson_slab": "פאמסן פלאטע",
  "block.minecraft.crimson_stairs": "פלאטע טרעפ",
  "block.minecraft.crimson_stem": "פּאמסן־שטאם",
  "block.minecraft.crimson_trapdoor": "פלאטע טראפ טיר",
  "block.minecraft.crimson_wall_hanging_sign": "פּאָמסן וואנט כאַנגגינג צייכן",
  "block.minecraft.crimson_wall_sign": "פּאמסן וואנט צייכן",
  "block.minecraft.crying_obsidian": "געוויין אבסידיאן",
  "block.minecraft.cut_copper": "שנייַדן קאַפּער",
  "block.minecraft.cut_copper_slab": "שנייַדן קאַפּער סלאַב",
  "block.minecraft.cut_copper_stairs": "שנייַדן קאַפּער טרעפּ",
  "block.minecraft.cut_red_sandstone": "געשניטנער רויטער זאמדשטיין",
  "block.minecraft.cut_red_sandstone_slab": "געשניטנע רויטע זאמדשטייןנפלאטע",
  "block.minecraft.cut_sandstone": "געשניטנער זאמדשטיין",
  "block.minecraft.cut_sandstone_slab": "געשניטנע זאמדשטיינפּלאטע",
  "block.minecraft.cyan_banner": "טורקיזע פאן",
  "block.minecraft.cyan_bed": "טורקיזס בעט",
  "block.minecraft.cyan_candle": "סיאַן ליכט",
  "block.minecraft.cyan_candle_cake": "שטיקל מיט סיאַן ליכט",
  "block.minecraft.cyan_carpet": "טורקיזער טעפּעך",
  "block.minecraft.cyan_concrete": "טורקיזבעטאן",
  "block.minecraft.cyan_concrete_powder": "טורקיזבעטאנפולווער",
  "block.minecraft.cyan_glazed_terracotta": "טורקיזגלאזירטע קעראמיק",
  "block.minecraft.cyan_shulker_box": "טורקיזע שולקערקאסע",
  "block.minecraft.cyan_stained_glass": "טורקיזגעפֿארבטס גלאז",
  "block.minecraft.cyan_stained_glass_pane": "טורקיזגעפֿארבטע גלאזשויב",
  "block.minecraft.cyan_terracotta": "טורקיזע קעראמיק",
  "block.minecraft.cyan_wool": "טורקיסע וואל",
  "block.minecraft.damaged_anvil": "באשעדיקטער אנשטול",
  "block.minecraft.dandelion": "לופטל",
  "block.minecraft.dark_oak_button": "שווארצייכנהאלצקנאף",
  "block.minecraft.dark_oak_door": "שווארצייכנהאלצטיר",
  "block.minecraft.dark_oak_fence": "שווארצייכנהאלצצוים",
  "block.minecraft.dark_oak_fence_gate": "שווארצייכנהאלצצוימטויער",
  "block.minecraft.dark_oak_hanging_sign": "טונקל דעמב כאַנגגינג צייכן",
  "block.minecraft.dark_oak_leaves": "שווארצייכנבלעטער",
  "block.minecraft.dark_oak_log": "שווארצייכנשטאם",
  "block.minecraft.dark_oak_planks": "שווארצייכנהאלצברעטער",
  "block.minecraft.dark_oak_pressure_plate": "שווארצייכנהאלצדרוקפּלאטע",
  "block.minecraft.dark_oak_sapling": "שווארצייכנזעצלינג",
  "block.minecraft.dark_oak_shelf": "Dark Oak Shelf",
  "block.minecraft.dark_oak_sign": "שווארצייכנהאלצשילד",
  "block.minecraft.dark_oak_slab": "שווארצייכנהאלצפּלאטע",
  "block.minecraft.dark_oak_stairs": "שווארצייכנהאלצטרעף",
  "block.minecraft.dark_oak_trapdoor": "שווארצייכנהאלצפֿאלטיר",
  "block.minecraft.dark_oak_wall_hanging_sign": "טונקל דעמב וואנט כאַנגגינג צייכן",
  "block.minecraft.dark_oak_wall_sign": "שווארצייכנהאלצוואנדשילד",
  "block.minecraft.dark_oak_wood": "שווארצייכנהאלץ",
  "block.minecraft.dark_prismarine": "טונקלפּריסמארין",
  "block.minecraft.dark_prismarine_slab": "טונקלפּריסמארינפּלאטע",
  "block.minecraft.dark_prismarine_stairs": "טונקלפּריסמארינטרעף",
  "block.minecraft.daylight_detector": "טאגליכטססענסאר",
  "block.minecraft.dead_brain_coral": "אפגעשטארבנער געהירנקאראל",
  "block.minecraft.dead_brain_coral_block": "אפגעשטארבנער געהירנקאראלנבלאק",
  "block.minecraft.dead_brain_coral_fan": "אפגעשטארבנער געהירנקאראלנפעכער",
  "block.minecraft.dead_brain_coral_wall_fan": "אפגעשטארבנער געהירנקאראלנוואנדפעכער",
  "block.minecraft.dead_bubble_coral": "אפגעשטארבנער בלאזנקאראל",
  "block.minecraft.dead_bubble_coral_block": "אפגעשטארבנער בלאזנקאראלנבלאק",
  "block.minecraft.dead_bubble_coral_fan": "אפגעשטארבנער בלאזקאראלנפעכער",
  "block.minecraft.dead_bubble_coral_wall_fan": "אפגעשטארבנער בלאזקאראלנוואנדפעכער",
  "block.minecraft.dead_bush": "טויטער קוסט",
  "block.minecraft.dead_fire_coral": "אפגעשטארבנער פייערקאראל",
  "block.minecraft.dead_fire_coral_block": "אפגעשטארבנער פייערקאראלנבלאק",
  "block.minecraft.dead_fire_coral_fan": "אפגעשטארבנער פֿייַערקאראלנפעכער",
  "block.minecraft.dead_fire_coral_wall_fan": "אפגעשטארבנער פֿייַערקאראלנוואנדפעכער",
  "block.minecraft.dead_horn_coral": "אפגעשטארבנער הארנקאראל",
  "block.minecraft.dead_horn_coral_block": "אפגעשטארבנער הארנקאראלנבלאק",
  "block.minecraft.dead_horn_coral_fan": "אפגעשטארבנער הארנקאראלנפעכער",
  "block.minecraft.dead_horn_coral_wall_fan": "אפגעשטארבנער הארנקאראלנוואנדפעכער",
  "block.minecraft.dead_tube_coral": "אפגעשטארבנער ארגלקאראל",
  "block.minecraft.dead_tube_coral_block": "אפגעשטארבנער ארגלקאראלנבלאק",
  "block.minecraft.dead_tube_coral_fan": "אפגעשטארבנער ארגלקאראלנפעכער",
  "block.minecraft.dead_tube_coral_wall_fan": "אפגעשטארבנער ארגלקאראלנוואנדפעכער",
  "block.minecraft.decorated_pot": "דעקערייטאַד פּאָט",
  "block.minecraft.deepslate": "דעעפּסלאַטע",
  "block.minecraft.deepslate_brick_slab": "ציגל שפּאַלטן כאַווד",
  "block.minecraft.deepslate_brick_stairs": "טרעפּ צו לעוואַנאַ",
  "block.minecraft.deepslate_brick_wall": "א ציגל וואַנט",
  "block.minecraft.deepslate_bricks": "כאַווד לאַוואַהאַ",
  "block.minecraft.deepslate_coal_ore": "דעעפּסלאַטע קוילן אַרץ",
  "block.minecraft.deepslate_copper_ore": "דעעפּסלאַטע קאַפּער אַרץ",
  "block.minecraft.deepslate_diamond_ore": "דעעפּסלאַטע דיאַמאָנד אַרץ",
  "block.minecraft.deepslate_emerald_ore": "דעעפּסלאַטע שמאַראַגד אַרץ",
  "block.minecraft.deepslate_gold_ore": "דעעפּסלאַטע גאָלד אַרץ",
  "block.minecraft.deepslate_iron_ore": "דעעפּסלאַטע יראָן אַרץ",
  "block.minecraft.deepslate_lapis_ore": "דעעפּסלאַטע לאַפּיס לאַזולי אַרץ",
  "block.minecraft.deepslate_redstone_ore": "דעעפּסלאַטע רעדסטאָנע אַרץ",
  "block.minecraft.deepslate_tile_slab": "קאַכל פֿאַר כאַווד",
  "block.minecraft.deepslate_tile_stairs": "טרעפּ צו לאַוואַ טיילז",
  "block.minecraft.deepslate_tile_wall": "וואַלאַ קאַכל וואַנט",
  "block.minecraft.deepslate_tiles": "לאַוואַ טיילז",
  "block.minecraft.detector_rail": "סענסארבאן",
  "block.minecraft.diamond_block": "דימענטבלאק",
  "block.minecraft.diamond_ore": "דימענטארץ",
  "block.minecraft.diorite": "דיאגיט",
  "block.minecraft.diorite_slab": "דיאגיטפלאטע",
  "block.minecraft.diorite_stairs": "דיאגיטטרעפ",
  "block.minecraft.diorite_wall": "דיאגיטמוייער",
  "block.minecraft.dirt": "ערד",
  "block.minecraft.dirt_path": "שמוץ דרך",
  "block.minecraft.dispenser": "צעגעבער",
  "block.minecraft.dragon_egg": "דראַקאָנאײ",
  "block.minecraft.dragon_head": "דראקאנסקאף",
  "block.minecraft.dragon_wall_head": "דראקאנסוואנדקאף",
  "block.minecraft.dried_ghast": "Dried Ghast",
  "block.minecraft.dried_kelp_block": "טרוקנע ים־גראזבלאק",
  "block.minecraft.dripstone_block": "דריפּסטאָנע בלאַק",
  "block.minecraft.dropper": "פֿארגיסער",
  "block.minecraft.emerald_block": "שמאראקבלאק",
  "block.minecraft.emerald_ore": "שמאראקארץ",
  "block.minecraft.enchanting_table": "צויבערטיש",
  "block.minecraft.end_gateway": "ענדטראנזיטפארטאל",
  "block.minecraft.end_portal": "ענדפארטאל",
  "block.minecraft.end_portal_frame": "ענדפּארטאלראם",
  "block.minecraft.end_rod": "ענדשטאב",
  "block.minecraft.end_stone": "ענדשטיין",
  "block.minecraft.end_stone_brick_slab": "ענדשטיינציגלפלאטע",
  "block.minecraft.end_stone_brick_stairs": "ענדשטיינציגלטרעף",
  "block.minecraft.end_stone_brick_wall": "ענדשטיינציגלמויער",
  "block.minecraft.end_stone_bricks": "ענדשטיינציגל",
  "block.minecraft.ender_chest": "ענדערקאסטן",
  "block.minecraft.exposed_chiseled_copper": "סקאַלפּט נאַקעט קופּער",
  "block.minecraft.exposed_copper": "יקספּאָוזד קופּער",
  "block.minecraft.exposed_copper_bars": "Exposed Copper Bars",
  "block.minecraft.exposed_copper_bulb": "נאַקעט קופּער ציבעלע",
  "block.minecraft.exposed_copper_chain": "Exposed Copper Chain",
  "block.minecraft.exposed_copper_chest": "Exposed Copper Chest",
  "block.minecraft.exposed_copper_door": "נאקעטע קופערנע טיר",
  "block.minecraft.exposed_copper_golem_statue": "Exposed Copper Golem Statue",
  "block.minecraft.exposed_copper_grate": "נאַקעט קופּער כאַבאַרניק",
  "block.minecraft.exposed_copper_lantern": "Exposed Copper Lantern",
  "block.minecraft.exposed_copper_trapdoor": "יקספּאָוזד קופּער פאַרבאָרגן טיר",
  "block.minecraft.exposed_cut_copper": "יקספּאָוזד קאַט קאַפּער",
  "block.minecraft.exposed_cut_copper_slab": "יקספּאָוזד קאַט קופּער פּלאַטע",
  "block.minecraft.exposed_cut_copper_stairs": "יקספּאָוזד קאַט קאַפּער טרעפּ",
  "block.minecraft.exposed_lightning_rod": "Exposed Lightning Rod",
  "block.minecraft.farmland": "אקערבאדן",
  "block.minecraft.fern": "פֿעדערגראז",
  "block.minecraft.fire": "פֿייַער",
  "block.minecraft.fire_coral": "פֿייַערקאראל",
  "block.minecraft.fire_coral_block": "פֿייַערקאראלנבלאק",
  "block.minecraft.fire_coral_fan": "פֿייַערקאראלנפעכער",
  "block.minecraft.fire_coral_wall_fan": "פֿייַערקאראלנוואנדפעכער",
  "block.minecraft.firefly_bush": "Firefly Bush",
  "block.minecraft.fletching_table": "בויגנערטיש",
  "block.minecraft.flower_pot": "בלומנטאף",
  "block.minecraft.flowering_azalea": "פלאַוערינג אַזאַלעאַ",
  "block.minecraft.flowering_azalea_leaves": "פלאַוערינג אַזאַליאַ בלעטער",
  "block.minecraft.frogspawn": "פראָגספּאָן",
  "block.minecraft.frosted_ice": "פֿראסטייַז",
  "block.minecraft.furnace": "אויוון",
  "block.minecraft.gilded_blackstone": "גאלד-קריסקראסס שווארצשטיין",
  "block.minecraft.glass": "גלאז",
  "block.minecraft.glass_pane": "בלעזערל",
  "block.minecraft.glow_lichen": "שייַנען ליטשען",
  "block.minecraft.glowstone": "לייַכטשטיין",
  "block.minecraft.gold_block": "גאלדבלאק",
  "block.minecraft.gold_ore": "גאלדארץ",
  "block.minecraft.golden_dandelion": "Golden Dandelion",
  "block.minecraft.granite": "גראניט",
  "block.minecraft.granite_slab": "גראניטפלאטע",
  "block.minecraft.granite_stairs": "גראניטטרעפ",
  "block.minecraft.granite_wall": "גראניטמויער",
  "block.minecraft.grass": "גראז",
  "block.minecraft.grass_block": "גראזבלאק",
  "block.minecraft.gravel": "זשוויר",
  "block.minecraft.gray_banner": "גרויע פאן",
  "block.minecraft.gray_bed": "גרויס בעט",
  "block.minecraft.gray_candle": "גרוי קאַנדלע",
  "block.minecraft.gray_candle_cake": "שטיקל מיט גריי ליכט",
  "block.minecraft.gray_carpet": "גרויער טעפּעך",
  "block.minecraft.gray_concrete": "גרויבעטאן",
  "block.minecraft.gray_concrete_powder": "גרויבעטאנפולווער",
  "block.minecraft.gray_glazed_terracotta": "גרויגלאזירטע קעראמיק",
  "block.minecraft.gray_shulker_box": "גרויע שולקערקאסע",
  "block.minecraft.gray_stained_glass": "גרויגעפֿארבטס גלאז",
  "block.minecraft.gray_stained_glass_pane": "גרויגעפֿארבטע גלאזשויב",
  "block.minecraft.gray_terracotta": "גרויע קעראמיק",
  "block.minecraft.gray_wool": "גרויע וואל",
  "block.minecraft.green_banner": "גרינע פאן",
  "block.minecraft.green_bed": "גרינס בעט",
  "block.minecraft.green_candle": "גרין ליכט",
  "block.minecraft.green_candle_cake": "שטיקל מיט גרין ליכט",
  "block.minecraft.green_carpet": "גרינער טעפּעך",
  "block.minecraft.green_concrete": "גרינבעטאן",
  "block.minecraft.green_concrete_powder": "גרינבעטאנפולווער",
  "block.minecraft.green_glazed_terracotta": "גרינגלאזירטע קעראמיק",
  "block.minecraft.green_shulker_box": "גרינע שולקערקאסע",
  "block.minecraft.green_stained_glass": "גרינגעפֿארבטס גלאז",
  "block.minecraft.green_stained_glass_pane": "גרינגעפֿארבטע גלאזשויב",
  "block.minecraft.green_terracotta": "גרינע קעראמיק",
  "block.minecraft.green_wool": "גרינע וואל",
  "block.minecraft.grindstone": "שלייפשטיין",
  "block.minecraft.hanging_roots": "כאַנגגינג ראָאָץ",
  "block.minecraft.hay_block": "שטרויבאלן",
  "block.minecraft.heavy_core": "שווער האַרץ",
  "block.minecraft.heavy_weighted_pressure_plate": "גראבגעוויכטדרוקפּלאטע",
  "block.minecraft.honey_block": "האניק בלאק",
  "block.minecraft.honeycomb_block": "האנייקאמב בלאק",
  "block.minecraft.hopper": "לייקע",
  "block.minecraft.horn_coral": "הארנקאראל",
  "block.minecraft.horn_coral_block": "הארנקאראלנבלאק",
  "block.minecraft.horn_coral_fan": "הארנקאראלנפעכער",
  "block.minecraft.horn_coral_wall_fan": "הארנקאראלנוואנדפעכער",
  "block.minecraft.ice": "אייַז",
  "block.minecraft.infested_chiseled_stone_bricks": "פֿארשרצטע גראווירטע שטיינציגל",
  "block.minecraft.infested_cobblestone": "פֿארשרצטער ברוק",
  "block.minecraft.infested_cracked_stone_bricks": "פֿארשרצטע ריסיקע שטיינציגל",
  "block.minecraft.infested_deepslate": "ינפעקטאַד ינפעקציע",
  "block.minecraft.infested_mossy_stone_bricks": "פֿארשרצטע באמאכטע שטיינציגל",
  "block.minecraft.infested_stone": "פֿארשרצטער שטיין",
  "block.minecraft.infested_stone_bricks": "פֿארשרצטע שטיינציגל",
  "block.minecraft.iron_bars": "אייַזנשטאנגן",
  "block.minecraft.iron_block": "אייַזנבלאק",
  "block.minecraft.iron_chain": "Iron Chain",
  "block.minecraft.iron_door": "אייַזנטיר",
  "block.minecraft.iron_ore": "אייַזנארץ",
  "block.minecraft.iron_trapdoor": "אייַזנפֿאלטיר",
  "block.minecraft.jack_o_lantern": "קירבעסלאמטערן",
  "block.minecraft.jigsaw": "פארבונדבלאק",
  "block.minecraft.jukebox": "מוזיקאמאט",
  "block.minecraft.jungle_button": "זשונגלהאלצקנאף",
  "block.minecraft.jungle_door": "זשונגלהאלצטיר",
  "block.minecraft.jungle_fence": "זשונגלהאלצצוים",
  "block.minecraft.jungle_fence_gate": "זשונגלהאלצצוימטויער",
  "block.minecraft.jungle_hanging_sign": "דזשונגלע כאַנגגינג צייכן",
  "block.minecraft.jungle_leaves": "זשונגלבלעטער",
  "block.minecraft.jungle_log": "זשונגלשטאם",
  "block.minecraft.jungle_planks": "זשונגלהאלצברעטער",
  "block.minecraft.jungle_pressure_plate": "זשונגלהאלצדרוקפּלאטע",
  "block.minecraft.jungle_sapling": "זשונגלזעצלינג",
  "block.minecraft.jungle_shelf": "Jungle Shelf",
  "block.minecraft.jungle_sign": "זשונגלהאלצשילד",
  "block.minecraft.jungle_slab": "זשונגלהאלצפּלאטע",
  "block.minecraft.jungle_stairs": "זשונגלהאלצטרעף",
  "block.minecraft.jungle_trapdoor": "זשונגלהאלצפֿאלטיר",
  "block.minecraft.jungle_wall_hanging_sign": "דזשונגלע וואנט כאַנגגינג צייכן",
  "block.minecraft.jungle_wall_sign": "זשונגלהאלצוואנדשילד",
  "block.minecraft.jungle_wood": "זשונגלהאלץ",
  "block.minecraft.kelp": "ים־גראז",
  "block.minecraft.kelp_plant": "ים־גראזקרויט",
  "block.minecraft.ladder": "לייטער",
  "block.minecraft.lantern": "לאמטערן",
  "block.minecraft.lapis_block": "פאַרשפּאַרן פון לאַפּיס לאַזולי",
  "block.minecraft.lapis_ore": "בלאשטיינארץ",
  "block.minecraft.large_amethyst_bud": "גרויס אַמעטהיסט באַד",
  "block.minecraft.large_fern": "גרויסס פֿעדערגראז",
  "block.minecraft.lava": "לאווע",
  "block.minecraft.lava_cauldron": "לאַוואַ קעסל",
  "block.minecraft.leaf_litter": "Leaf Litter",
  "block.minecraft.lectern": "שטענדער",
  "block.minecraft.lever": "הייבל",
  "block.minecraft.light": "ליכט",
  "block.minecraft.light_blue_banner": "העלבלויע פאן",
  "block.minecraft.light_blue_bed": "העלבלויס בעט",
  "block.minecraft.light_blue_candle": "העלבלױע ליכט",
  "block.minecraft.light_blue_candle_cake": "שטיקל מיט ליכט בלו קאַנדלע",
  "block.minecraft.light_blue_carpet": "העלבלויער טעפּעך",
  "block.minecraft.light_blue_concrete": "העלבלויבעטאן",
  "block.minecraft.light_blue_concrete_powder": "העלבלויבעטאנפולווער",
  "block.minecraft.light_blue_glazed_terracotta": "העלבלויגלאזירטע קעראמיק",
  "block.minecraft.light_blue_shulker_box": "העלבלויע שולקערקאסע",
  "block.minecraft.light_blue_stained_glass": "העלבלויגעפֿארבטס גלאז",
  "block.minecraft.light_blue_stained_glass_pane": "העלבלויגעפֿארבטע גלאזשויב",
  "block.minecraft.light_blue_terracotta": "העלבלויע קעראמיק",
  "block.minecraft.light_blue_wool": "העלבלויע וואל",
  "block.minecraft.light_gray_banner": "העלגרויע פאן",
  "block.minecraft.light_gray_bed": "העלגרויס בעט",
  "block.minecraft.light_gray_candle": "ליכט גריי קאַנדלע",
  "block.minecraft.light_gray_candle_cake": "שטיקל מיט ליכט גרוי ליכט",
  "block.minecraft.light_gray_carpet": "העלגרויער טעפּעך",
  "block.minecraft.light_gray_concrete": "העלגרויבעטאן",
  "block.minecraft.light_gray_concrete_powder": "העלגרויבעטאנפולווער",
  "block.minecraft.light_gray_glazed_terracotta": "העלגרויגלאזירטע קעראמיק",
  "block.minecraft.light_gray_shulker_box": "העלגרויע שולקערקאסע",
  "block.minecraft.light_gray_stained_glass": "העלגרויגעפֿארבטס גלאז",
  "block.minecraft.light_gray_stained_glass_pane": "העלגרויגעפֿארבטע גלאזשויב",
  "block.minecraft.light_gray_terracotta": "העלגרויע קעראמיק",
  "block.minecraft.light_gray_wool": "העלגרויע וואל",
  "block.minecraft.light_weighted_pressure_plate": "פֿייַנגעוויכטדרוקפּלאטע",
  "block.minecraft.lightning_rod": "בליץ רוט",
  "block.minecraft.lilac": "בעז",
  "block.minecraft.lily_of_the_valley": "מייגלעקל",
  "block.minecraft.lily_pad": "ים־רויזבלאק",
  "block.minecraft.lime_banner": "העלגרינע פאן",
  "block.minecraft.lime_bed": "העלגרינס בעט",
  "block.minecraft.lime_candle": "לייַם קאַנדלע",
  "block.minecraft.lime_candle_cake": "שטיקל מיט לייַם קאַנדלע",
  "block.minecraft.lime_carpet": "העלגרינער טעפּעך",
  "block.minecraft.lime_concrete": "העלגרינבעטאן",
  "block.minecraft.lime_concrete_powder": "העלגרינבעטאנפולווער",
  "block.minecraft.lime_glazed_terracotta": "העלגרינגלאזירטע קעראמיק",
  "block.minecraft.lime_shulker_box": "העלגרינע שולקערקאסע",
  "block.minecraft.lime_stained_glass": "העלגרינגעפֿארבטס גלאז",
  "block.minecraft.lime_stained_glass_pane": "העלגרינגעפֿארבטע גלאזשויב",
  "block.minecraft.lime_terracotta": "העלגרינע קעראמיק",
  "block.minecraft.lime_wool": "העלגרינע וואל",
  "block.minecraft.lodestone": "לאדעשטיין",
  "block.minecraft.loom": "וועבשטול",
  "block.minecraft.magenta_banner": "מאדזשענטאע פאן",
  "block.minecraft.magenta_bed": "מאדזשענטאס בעט",
  "block.minecraft.magenta_candle": "מאַגענטאַ קאַנדלע",
  "block.minecraft.magenta_candle_cake": "שטיקל מיט מאַגענטאַ קאַנדלע",
  "block.minecraft.magenta_carpet": "מאדזשענטאער טעפּעך",
  "block.minecraft.magenta_concrete": "מאדזשענטאבעטאן",
  "block.minecraft.magenta_concrete_powder": "מאדזשענטאבעטאנפולווער",
  "block.minecraft.magenta_glazed_terracotta": "מאדזשענטאגלאזירטע קעראמיק",
  "block.minecraft.magenta_shulker_box": "מאדזשענטאע שולקערקאסע",
  "block.minecraft.magenta_stained_glass": "מאדזשענטאגעפֿארבטס גלאז",
  "block.minecraft.magenta_stained_glass_pane": "מאדזשענטאגעפֿארבטע גלאזשויב",
  "block.minecraft.magenta_terracotta": "מאדזשענטאע קעראמיק",
  "block.minecraft.magenta_wool": "מאדזשענטאע וואל",
  "block.minecraft.magma_block": "מאגמעבלאק",
  "block.minecraft.mangrove_button": "מאַנגראָווע קנעפּל",
  "block.minecraft.mangrove_door": "מאַנגראָווע טיר",
  "block.minecraft.mangrove_fence": "מאַנגראָווע פענס",
  "block.minecraft.mangrove_fence_gate": "מאַנגראָווע פענס גייט",
  "block.minecraft.mangrove_hanging_sign": "מאַנגראָווע כאַנגגינג צייכן",
  "block.minecraft.mangrove_leaves": "מאַנגראָווע בלעטער",
  "block.minecraft.mangrove_log": "מאַנגראָווע קלאָץ",
  "block.minecraft.mangrove_planks": "מאַנגראָווע פּלאַנקס",
  "block.minecraft.mangrove_pressure_plate": "מאַנגראָווע דרוק פּלאַטע",
  "block.minecraft.mangrove_propagule": "מאַנגראָווע פּראָפּאַגולע",
  "block.minecraft.mangrove_roots": "מאַנגראָווע ראָאָץ",
  "block.minecraft.mangrove_shelf": "Mangrove Shelf",
  "block.minecraft.mangrove_sign": "מאַנגראָווע צייכן",
  "block.minecraft.mangrove_slab": "מאַנגראָווע פּלאַטע",
  "block.minecraft.mangrove_stairs": "מאַנגראָווע סטאַירס",
  "block.minecraft.mangrove_trapdoor": "מאַנגראָווע טראַפּדאָר",
  "block.minecraft.mangrove_wall_hanging_sign": "מאַנגראָווע וואנט כאַנגגינג צייכן",
  "block.minecraft.mangrove_wall_sign": "מאַנגראָווע וואנט צייכן",
  "block.minecraft.mangrove_wood": "מאַנגראָווע האָלץ",
  "block.minecraft.medium_amethyst_bud": "מיטל אַמעטהיסט באַד",
  "block.minecraft.melon": "קאווענע",
  "block.minecraft.melon_stem": "מעלאנענשטאם",
  "block.minecraft.moss_block": "מאָך בלאַק",
  "block.minecraft.moss_carpet": "מאָך קאַרפּעט",
  "block.minecraft.mossy_cobblestone": "באמאכטער ברוק",
  "block.minecraft.mossy_cobblestone_slab": "באמאכטע ברוקפלאטע",
  "block.minecraft.mossy_cobblestone_stairs": "באמאכטער ברוקטרעפ",
  "block.minecraft.mossy_cobblestone_wall": "באמאכטע ברוקמויער",
  "block.minecraft.mossy_stone_brick_slab": "באמאכטע שטיינציגלפלאטע",
  "block.minecraft.mossy_stone_brick_stairs": "באמאכטע שטיינציגלטרעף",
  "block.minecraft.mossy_stone_brick_wall": "באמאכטע שטיינציגלמויער",
  "block.minecraft.mossy_stone_bricks": "באמאכטע שטיינציגל",
  "block.minecraft.moving_piston": "באוועגנדיקע קאלבע",
  "block.minecraft.mud": "בלאָטע",
  "block.minecraft.mud_brick_slab": "בלאָטע בריק פּלאַטע",
  "block.minecraft.mud_brick_stairs": "בלאָטע בריק סטאַירס",
  "block.minecraft.mud_brick_wall": "בלאָטע ציגל וואנט",
  "block.minecraft.mud_bricks": "בלאָטע ציגל",
  "block.minecraft.muddy_mangrove_roots": "מוטנע מאַנגראָווע רוץ",
  "block.minecraft.mushroom_stem": "שוועמלשטאם",
  "block.minecraft.mycelium": "מיצעל",
  "block.minecraft.nether_brick_fence": "נעדער־ציגלצוים",
  "block.minecraft.nether_brick_slab": "נעדערציגלפּלאטע",
  "block.minecraft.nether_brick_stairs": "נעדער־ציגלטרכף",
  "block.minecraft.nether_brick_wall": "נעדערציגלמויער",
  "block.minecraft.nether_bricks": "נעדער־ציגל",
  "block.minecraft.nether_gold_ore": "נעטהער גאלד אר",
  "block.minecraft.nether_portal": "נעדער־פּארטאל",
  "block.minecraft.nether_quartz_ore": "נעדער־קווארצארץ",
  "block.minecraft.nether_sprouts": "נעטהער ספּראוץ",
  "block.minecraft.nether_wart": "נעדער־בראדעווקעס",
  "block.minecraft.nether_wart_block": "נעדער־בראדעווקעסבלאק",
  "block.minecraft.netherite_block": "נעטהעריטע בלאק",
  "block.minecraft.netherrack": "נעדערראק",
  "block.minecraft.note_block": "נאטנבלאק",
  "block.minecraft.oak_button": "אייכנהאלצקנאף",
  "block.minecraft.oak_door": "אייכנהאלצטיר",
  "block.minecraft.oak_fence": "דעמבהאלץ צוים",
  "block.minecraft.oak_fence_gate": "דעמבהאלץ צוימטויער",
  "block.minecraft.oak_hanging_sign": "דעמב האנגנדיקער שילד",
  "block.minecraft.oak_leaves": "דעמבבלעטער",
  "block.minecraft.oak_log": "דעמבשטאם",
  "block.minecraft.oak_planks": "דעמבהאלץ ברעטער",
  "block.minecraft.oak_pressure_plate": "דעמבהאלץ דרוקפּלאטע",
  "block.minecraft.oak_sapling": "דעמב שפראצל",
  "block.minecraft.oak_shelf": "דעמבהאלץ פאליצע",
  "block.minecraft.oak_sign": "דעמבהאלצשילד",
  "block.minecraft.oak_slab": "דעמבהאלצפּלאטע",
  "block.minecraft.oak_stairs": "דעמבהאלצטרעפף",
  "block.minecraft.oak_trapdoor": "דעמבהאלץ כאפטירל",
  "block.minecraft.oak_wall_hanging_sign": "דעמב וואנט כאַנגגינג צייכן",
  "block.minecraft.oak_wall_sign": "אייכנהאלצוואנדשילד",
  "block.minecraft.oak_wood": "דעמבהאלץ",
  "block.minecraft.observer": "אכטגעבער",
  "block.minecraft.obsidian": "אבסידיאן",
  "block.minecraft.ochre_froglight": "אָטשער פראָגליגהט",
  "block.minecraft.ominous_banner": "בייז־סימנדיקע פאן",
  "block.minecraft.open_eyeblossom": "Open Eyeblossom",
  "block.minecraft.orange_banner": "אראנזשע פאן",
  "block.minecraft.orange_bed": "אראנזשס בעט",
  "block.minecraft.orange_candle": "מאַראַנץ קאַנדלע",
  "block.minecraft.orange_candle_cake": "שטיקל מיט אָראַנדזש קאַנדלע",
  "block.minecraft.orange_carpet": "אראנזשער טעפּעך",
  "block.minecraft.orange_concrete": "אראנזשבעטאן",
  "block.minecraft.orange_concrete_powder": "אראנזשבעטאנפולווער",
  "block.minecraft.orange_glazed_terracotta": "אראנזשגלאזירטע קעראמיק",
  "block.minecraft.orange_shulker_box": "אראנזשע שולקערקאסע",
  "block.minecraft.orange_stained_glass": "אראנזשגעפֿארבטס גלאז",
  "block.minecraft.orange_stained_glass_pane": "אראנזשגעפֿארבטע גלאזשויב",
  "block.minecraft.orange_terracotta": "אראנזשע קעראמיק",
  "block.minecraft.orange_tulip": "אראנזשע טולפּע",
  "block.minecraft.orange_wool": "אראנזשע וואל",
  "block.minecraft.oxeye_daisy": "מארגעריטע",
  "block.minecraft.oxidized_chiseled_copper": "אַקסאַדייזד סקאַלפּטיד קופּער בריקס",
  "block.minecraft.oxidized_copper": "אַקסאַדייזד קאַפּער",
  "block.minecraft.oxidized_copper_bars": "Oxidized Copper Bars",
  "block.minecraft.oxidized_copper_bulb": "אַ אַקסאַדייזד קופּער ציבעלע",
  "block.minecraft.oxidized_copper_chain": "Oxidized Copper Chain",
  "block.minecraft.oxidized_copper_chest": "Oxidized Copper Chest",
  "block.minecraft.oxidized_copper_door": "אַקסאַדייזד קופּער טיר",
  "block.minecraft.oxidized_copper_golem_statue": "Oxidized Copper Golem Statue",
  "block.minecraft.oxidized_copper_grate": "אַקסאַדייזד קופּער כאַבאַרניק",
  "block.minecraft.oxidized_copper_lantern": "Oxidized Copper Lantern",
  "block.minecraft.oxidized_copper_trapdoor": "אַקסאַדייזד קופּער פאַרבאָרגן טיר",
  "block.minecraft.oxidized_cut_copper": "אַקסאַדייזד קאַט קאַפּער",
  "block.minecraft.oxidized_cut_copper_slab": "אַקסאַדייזד קאַט קופּער פּלאַטע",
  "block.minecraft.oxidized_cut_copper_stairs": "אַקסאַדייזד קאַט קופּער טרעפּ",
  "block.minecraft.oxidized_lightning_rod": "Oxidized Lightning Rod",
  "block.minecraft.packed_ice": "פּאקייַז",
  "block.minecraft.packed_mud": "פּאַקט בלאָטע",
  "block.minecraft.pale_hanging_moss": "Pale Hanging Moss",
  "block.minecraft.pale_moss_block": "Pale Moss Block",
  "block.minecraft.pale_moss_carpet": "Pale Moss Carpet",
  "block.minecraft.pale_oak_button": "Pale Oak Button",
  "block.minecraft.pale_oak_door": "Pale Oak Door",
  "block.minecraft.pale_oak_fence": "Pale Oak Fence",
  "block.minecraft.pale_oak_fence_gate": "Pale Oak Fence Gate",
  "block.minecraft.pale_oak_hanging_sign": "Pale Oak Hanging Sign",
  "block.minecraft.pale_oak_leaves": "Pale Oak Leaves",
  "block.minecraft.pale_oak_log": "Pale Oak Log",
  "block.minecraft.pale_oak_planks": "Pale Oak Planks",
  "block.minecraft.pale_oak_pressure_plate": "Pale Oak Pressure Plate",
  "block.minecraft.pale_oak_sapling": "Pale Oak Sapling",
  "block.minecraft.pale_oak_shelf": "Pale Oak Shelf",
  "block.minecraft.pale_oak_sign": "Pale Oak Sign",
  "block.minecraft.pale_oak_slab": "Pale Oak Slab",
  "block.minecraft.pale_oak_stairs": "Pale Oak Stairs",
  "block.minecraft.pale_oak_trapdoor": "Pale Oak Trapdoor",
  "block.minecraft.pale_oak_wall_hanging_sign": "Pale Oak Wall Hanging Sign",
  "block.minecraft.pale_oak_wall_sign": "Pale Oak Wall Sign",
  "block.minecraft.pale_oak_wood": "Pale Oak Wood",
  "block.minecraft.pearlescent_froglight": "פּערלעססענט פראָגליגהט",
  "block.minecraft.peony": "פּיאן",
  "block.minecraft.petrified_oak_slab": "פֿארשטיינערטע אייַכנהאלצפּלאטע",
  "block.minecraft.piglin_head": "פּיגלין קאָפּ",
  "block.minecraft.piglin_wall_head": "פּיגלין וואנט קאָפּ",
  "block.minecraft.pink_banner": "העלרויטע פאן",
  "block.minecraft.pink_bed": "העלרויטס בעט",
  "block.minecraft.pink_candle": "ראָזעווע קאַנדלע",
  "block.minecraft.pink_candle_cake": "שטיקל מיט ראָזעווע קאַנדלע",
  "block.minecraft.pink_carpet": "העלרויטער טעפּעך",
  "block.minecraft.pink_concrete": "העלרויטבעטאן",
  "block.minecraft.pink_concrete_powder": "העלרויטבעטאנפולווער",
  "block.minecraft.pink_glazed_terracotta": "העלרויטגלאזירטע קעראמיק",
  "block.minecraft.pink_petals": "ראָזעווע פּעטאַלז",
  "block.minecraft.pink_shulker_box": "העלרויטע שולקערקאסע",
  "block.minecraft.pink_stained_glass": "העלרויטגעפֿארבטס גלאז",
  "block.minecraft.pink_stained_glass_pane": "העלרויטגעפֿארבטע גלאזשויב",
  "block.minecraft.pink_terracotta": "העלרויטע קעראמיק",
  "block.minecraft.pink_tulip": "העלרויטעטולפּע",
  "block.minecraft.pink_wool": "העלרויטע וואל",
  "block.minecraft.piston": "קאלבע",
  "block.minecraft.piston_head": "קאלבעסקאף",
  "block.minecraft.pitcher_crop": "קרוג גערעטעניש",
  "block.minecraft.pitcher_plant": "קרוג פּלאַנט",
  "block.minecraft.player_head": "ספילערקאף",
  "block.minecraft.player_head.named": "קאף פון %s",
  "block.minecraft.player_wall_head": "ספילערוואנדקאף",
  "block.minecraft.podzol": "אשבאדן",
  "block.minecraft.pointed_dripstone": "שפּיציק דריפּסטאָנע",
  "block.minecraft.polished_andesite": "פּאלירטער אנדעזיט",
  "block.minecraft.polished_andesite_slab": "פּאלירטע אנדעזיטפלאטע",
  "block.minecraft.polished_andesite_stairs": "פּאלירטער אנדעזיטטרעפ",
  "block.minecraft.polished_basalt": "פאלישט באזאלט",
  "block.minecraft.polished_blackstone": "פאלישט שווארצשטיין",
  "block.minecraft.polished_blackstone_brick_slab": "פאלישט שווארצשטיינציגלפלאטע",
  "block.minecraft.polished_blackstone_brick_stairs": "פאלישט שווארצשטיינציגלטרעף",
  "block.minecraft.polished_blackstone_brick_wall": "פאלישט שווארצשטיינציגלמויער",
  "block.minecraft.polished_blackstone_bricks": "פאלישט שווארצשטיינציגל",
  "block.minecraft.polished_blackstone_button": "פאלישט שווארצשטיינציגלקנעפל",
  "block.minecraft.polished_blackstone_pressure_plate": "פאלישט שווארצשטיינדרוקפלאטע",
  "block.minecraft.polished_blackstone_slab": "פאלישט שווארצשטיינפלאטע",
  "block.minecraft.polished_blackstone_stairs": "פאלישט שווארצשטיינטרעף",
  "block.minecraft.polished_blackstone_wall": "פאלישט שווארצשטיינמויער",
  "block.minecraft.polished_deepslate": "פּאַלישט וואַקס",
  "block.minecraft.polished_deepslate_slab": "שפּאַלטן פּאַלישט וואַקס",
  "block.minecraft.polished_deepslate_stairs": "גליטשיק פּאַלישט טרעפּ",
  "block.minecraft.polished_deepslate_wall": "פּאַלישט וואַפליע וואַנט",
  "block.minecraft.polished_diorite": "פּאלירטער דיאגיט",
  "block.minecraft.polished_diorite_slab": "פּאלירטע דיאגיטפלאטע",
  "block.minecraft.polished_diorite_stairs": "פּאלירטער דיאגיטטרעפ",
  "block.minecraft.polished_granite": "פּאלירטער גראניט",
  "block.minecraft.polished_granite_slab": "פּאלירטע גראניטפלאטע",
  "block.minecraft.polished_granite_stairs": "פּאלירטער גראניטטרעפ",
  "block.minecraft.polished_tuff": "פּאַלישט טוף",
  "block.minecraft.polished_tuff_slab": "פּאַלישט טאַף שנייַדן אין האַלב",
  "block.minecraft.polished_tuff_stairs": "פּאַלישט טוף טרעפּ",
  "block.minecraft.polished_tuff_wall": "פּאַלישט טוף וואַנט",
  "block.minecraft.poppy": "מאן",
  "block.minecraft.potatoes": "קארטאפלן",
  "block.minecraft.potted_acacia_sapling": "איינגעטאפטער אקאציענהזעצלינג",
  "block.minecraft.potted_allium": "איינגעטאפטע פּארע־ציבעלע",
  "block.minecraft.potted_azalea_bush": "פּאָטטעד אַזאַליאַ",
  "block.minecraft.potted_azure_bluet": "איינגעטאפטס פּארצעלאנשטערנדל",
  "block.minecraft.potted_bamboo": "איינגעטאפטער באמבוק",
  "block.minecraft.potted_birch_sapling": "איינגעטאפטער בערעזעזעצלינג",
  "block.minecraft.potted_blue_orchid": "איינגעטאפטע בלויע ארכידייע",
  "block.minecraft.potted_brown_mushroom": "איינגעטאפטס ברוינשוועמל",
  "block.minecraft.potted_cactus": "איינגעטאפטער קאקטוס",
  "block.minecraft.potted_cherry_sapling": "פּאָטטעד קאַרש סאַפּלינג",
  "block.minecraft.potted_closed_eyeblossom": "Potted Closed Eyeblossom",
  "block.minecraft.potted_cornflower": "איינגעטאפטס קארנבלימל",
  "block.minecraft.potted_crimson_fungus": "פאטטעד פאמסן שוועמל",
  "block.minecraft.potted_crimson_roots": "פאטטעד פאמסן ווארצל",
  "block.minecraft.potted_dandelion": "איינגעטאפטס לופטל",
  "block.minecraft.potted_dark_oak_sapling": "איינגעטאפטער שווארצייכנזעצלינג",
  "block.minecraft.potted_dead_bush": "איינגעטאפטער טויטער קוסט",
  "block.minecraft.potted_fern": "איינגעטאפטס פֿעדערגראז",
  "block.minecraft.potted_flowering_azalea_bush": "פּאָטטעד פלאַוערינג אַזאַלעאַ",
  "block.minecraft.potted_golden_dandelion": "Potted Golden Dandelion",
  "block.minecraft.potted_jungle_sapling": "איינגעטאפטער זשונגלזעצלינג",
  "block.minecraft.potted_lily_of_the_valley": "איינגעטאפטס מייגלעקל",
  "block.minecraft.potted_mangrove_propagule": "פּאָטטעד מאַנגראָווע פּראָפּאַגולע",
  "block.minecraft.potted_oak_sapling": "איינגעטאפטער אייכנזעצלינג",
  "block.minecraft.potted_open_eyeblossom": "Potted Open Eyeblossom",
  "block.minecraft.potted_orange_tulip": "איינגעטאפטע אראנזשע טולפּע",
  "block.minecraft.potted_oxeye_daisy": "איינגעטאפטע מארגעריטע",
  "block.minecraft.potted_pale_oak_sapling": "Potted Pale Oak Sapling",
  "block.minecraft.potted_pink_tulip": "איינגעטאפטע העלרויטע טולפּע",
  "block.minecraft.potted_poppy": "איינגעטאפטע מאנבלום",
  "block.minecraft.potted_red_mushroom": "איינגעטאפטס רויטשוועמל",
  "block.minecraft.potted_red_tulip": "איינגעטאפטע רויטע טולפּע",
  "block.minecraft.potted_spruce_sapling": "איינגעטאפטער טענענזעצלינג",
  "block.minecraft.potted_torchflower": "פּאָטטעד טאָרטשפלאָווער",
  "block.minecraft.potted_warped_fungus": "פאטטעד צעמישט שוועמל",
  "block.minecraft.potted_warped_roots": "פאטטעד צעמישט ווארצל",
  "block.minecraft.potted_white_tulip": "איינגעטאפטע ווייַסע טולפּע",
  "block.minecraft.potted_wither_rose": "איינגעטאפטע ווידער־רויז",
  "block.minecraft.powder_snow": "פּודער שניי",
  "block.minecraft.powder_snow_cauldron": "פּודער שניי קעסל",
  "block.minecraft.powered_rail": "אנטריבסבאן",
  "block.minecraft.prismarine": "פּריסמארין",
  "block.minecraft.prismarine_brick_slab": "פּריסמארינציגלפּלאטע",
  "block.minecraft.prismarine_brick_stairs": "פּריסמארינציגלטרעף",
  "block.minecraft.prismarine_bricks": "פּריסמארינציגל",
  "block.minecraft.prismarine_slab": "פּריסמארינפּלאטע",
  "block.minecraft.prismarine_stairs": "פּריסמארינטרעף",
  "block.minecraft.prismarine_wall": "פּריסמארינמויער",
  "block.minecraft.pumpkin": "קירבעס",
  "block.minecraft.pumpkin_stem": "קירבעסשטאם",
  "block.minecraft.purple_banner": "לילאע פאן",
  "block.minecraft.purple_bed": "לילאס בעט",
  "block.minecraft.purple_candle": "לילאַ קאַנדלע",
  "block.minecraft.purple_candle_cake": "שטיקל מיט לילאַ קאַנדלע",
  "block.minecraft.purple_carpet": "לילאער טעפּעך",
  "block.minecraft.purple_concrete": "לילאבעטאן",
  "block.minecraft.purple_concrete_powder": "לילאבעטאנפולווער",
  "block.minecraft.purple_glazed_terracotta": "לילאגלאזירטע קעראמיק",
  "block.minecraft.purple_shulker_box": "לילאע שולקערקאסע",
  "block.minecraft.purple_stained_glass": "לילאגעפֿארבטס גלאז",
  "block.minecraft.purple_stained_glass_pane": "לילאגעפֿארבטע גלאזשויב",
  "block.minecraft.purple_terracotta": "לילאע קעראמיק",
  "block.minecraft.purple_wool": "לילאע וואל",
  "block.minecraft.purpur_block": "פורפורבלאק",
  "block.minecraft.purpur_pillar": "פורפורצייל",
  "block.minecraft.purpur_slab": "פורפורפלאטע",
  "block.minecraft.purpur_stairs": "פורפורטרעף",
  "block.minecraft.quartz_block": "קווארצבלאק",
  "block.minecraft.quartz_bricks": "קווארצציגל",
  "block.minecraft.quartz_pillar": "קווארצזייַל",
  "block.minecraft.quartz_slab": "קווארצפּלאטע",
  "block.minecraft.quartz_stairs": "קווארצטרעף",
  "block.minecraft.rail": "באן",
  "block.minecraft.raw_copper_block": "קופּער בלאָק ביטע",
  "block.minecraft.raw_gold_block": "גאָלד בלאָק ביטע",
  "block.minecraft.raw_iron_block": "אייַזן בלאַק ביטע",
  "block.minecraft.red_banner": "רויטע פאן",
  "block.minecraft.red_bed": "רויטס בעט",
  "block.minecraft.red_candle": "רויט ליכט",
  "block.minecraft.red_candle_cake": "שטיקל מיט רויט ליכט",
  "block.minecraft.red_carpet": "רויטער טעפּעך",
  "block.minecraft.red_concrete": "רויטבעטאן",
  "block.minecraft.red_concrete_powder": "רויטבעטאנפולווער",
  "block.minecraft.red_glazed_terracotta": "רויטגלאזירטע קעראמיק",
  "block.minecraft.red_mushroom": "רויטשוועמל",
  "block.minecraft.red_mushroom_block": "רויטשוועמלבלאק",
  "block.minecraft.red_nether_brick_slab": "רויטע נעדער־ציגלפלאטע",
  "block.minecraft.red_nether_brick_stairs": "רויטע נעדער־ציגלטרכף",
  "block.minecraft.red_nether_brick_wall": "רויטע נעדערציגלמויער",
  "block.minecraft.red_nether_bricks": "רויטע נעדער־ציגל",
  "block.minecraft.red_sand": "רויטער זאמד",
  "block.minecraft.red_sandstone": "רויטער זאמדשטיין",
  "block.minecraft.red_sandstone_slab": "רויטזאמדשטיינפּלאטע",
  "block.minecraft.red_sandstone_stairs": "רויטזאמדשטיינטרעף",
  "block.minecraft.red_sandstone_wall": "רויטע זאמדשטיינמויער",
  "block.minecraft.red_shulker_box": "רויטע שולקערקאסע",
  "block.minecraft.red_stained_glass": "רויטגעפֿארבטס גלאז",
  "block.minecraft.red_stained_glass_pane": "רויטגעפֿארבטע גלאזשויב",
  "block.minecraft.red_terracotta": "רויטע קעראמיק",
  "block.minecraft.red_tulip": "רויטע טולפּע",
  "block.minecraft.red_wool": "רויטע וואל",
  "block.minecraft.redstone_block": "רעדסטאנ־בלאק",
  "block.minecraft.redstone_lamp": "רעדסטאנ־לאמף",
  "block.minecraft.redstone_ore": "רעדסטאן־ארץ",
  "block.minecraft.redstone_torch": "רעדסטאן־פֿאקל",
  "block.minecraft.redstone_wall_torch": "רעדסטאן־וואנטפֿאקל",
  "block.minecraft.redstone_wire": "רעדסטאן־שנירל",
  "block.minecraft.reinforced_deepslate": "ריינפאָרסט דיפּשיווערשטיין",
  "block.minecraft.repeater": "רעדסטאן־פארשטארקער",
  "block.minecraft.repeating_command_block": "איבערחזרונגסבאפֿעלסבלאק",
  "block.minecraft.resin_block": "סמאָלע־בלאָק",
  "block.minecraft.resin_brick_slab": "סמאָלעציגלפּלאַטע",
  "block.minecraft.resin_brick_stairs": "סמאָלעציגל־טרעף",
  "block.minecraft.resin_brick_wall": "סמאָלעציגל־מױער",
  "block.minecraft.resin_bricks": "סמאָלעציגל",
  "block.minecraft.resin_clump": "Resin Clump",
  "block.minecraft.respawn_anchor": "רעספאוון אנקער",
  "block.minecraft.rooted_dirt": "איינגעווארצלט שמוץ",
  "block.minecraft.rose_bush": "רויזנקשאקע",
  "block.minecraft.sand": "זאמד",
  "block.minecraft.sandstone": "זאמדשטיין",
  "block.minecraft.sandstone_slab": "זאמדשטיינפּלאטע",
  "block.minecraft.sandstone_stairs": "זאמדשטיינטרעף",
  "block.minecraft.sandstone_wall": "זאמדשטיינמויער",
  "block.minecraft.scaffolding": "געשטעל",
  "block.minecraft.sculk": "סקולק",
  "block.minecraft.sculk_catalyst": "סקולק קאַטאַליסט",
  "block.minecraft.sculk_sensor": "סקולק סענסאָר",
  "block.minecraft.sculk_shrieker": "סקולק שריקער",
  "block.minecraft.sculk_vein": "סקולק וועין",
  "block.minecraft.sea_lantern": "ים־לאמטערן",
  "block.minecraft.sea_pickle": "ים־וגערקע",
  "block.minecraft.seagrass": "ים־גראז",
  "block.minecraft.set_spawn": "ריספּאן פונט שטעלן",
  "block.minecraft.short_dry_grass": "קורץ טרוקן גראָז",
  "block.minecraft.short_grass": "קורץ גראָז",
  "block.minecraft.shroomlight": "שראאםליכט",
  "block.minecraft.shulker_box": "שולקערקאסע",
  "block.minecraft.skeleton_skull": "סקעלעטשיידל",
  "block.minecraft.skeleton_wall_skull": "סקעלעטוואנדשיידל",
  "block.minecraft.slime_block": "שליימבלאק",
  "block.minecraft.small_amethyst_bud": "קליין אַמעטהיסט באַד",
  "block.minecraft.small_dripleaf": "קליין דריפּלעף",
  "block.minecraft.smithing_table": "שמידטיש",
  "block.minecraft.smoker": "רויכערויוון",
  "block.minecraft.smooth_basalt": "גלאַט באַסאַלט",
  "block.minecraft.smooth_quartz": "גלאטע קווארצפלאטע",
  "block.minecraft.smooth_quartz_slab": "גלאטע קווארצפלאטע",
  "block.minecraft.smooth_quartz_stairs": "גלאטער קווארצטרעפ",
  "block.minecraft.smooth_red_sandstone": "גלאטער רויטזאמגשטיין",
  "block.minecraft.smooth_red_sandstone_slab": "גלאטע רויטזאמגשטיינפלאטע",
  "block.minecraft.smooth_red_sandstone_stairs": "גלאטע רויטזאמדשטיינטרעף",
  "block.minecraft.smooth_sandstone": "גלאטער זאמגשטיין",
  "block.minecraft.smooth_sandstone_slab": "גלאטע זאמגשטיינפלאטע",
  "block.minecraft.smooth_sandstone_stairs": "גלאטע זאמדשטיינטרעף",
  "block.minecraft.smooth_stone": "גלאטער שטיין",
  "block.minecraft.smooth_stone_slab": "גלאטע שטיינפּלאטע",
  "block.minecraft.sniffer_egg": "סניפפער איי",
  "block.minecraft.snow": "שניי",
  "block.minecraft.snow_block": "שנייבלאק",
  "block.minecraft.soul_campfire": "נשמה קאמפפירע",
  "block.minecraft.soul_fire": "נשמה פייער",
  "block.minecraft.soul_lantern": "נשמה לאנטערן",
  "block.minecraft.soul_sand": "זעלנזאמד",
  "block.minecraft.soul_soil": "נשמה באדן",
  "block.minecraft.soul_torch": "נשמה טארטש",
  "block.minecraft.soul_wall_torch": "נשמה וואנט טארטש",
  "block.minecraft.spawn.not_valid": "איר האט קיין היים בעט אדער א אפּצאל אנטשיינדזשד אנקער, אדער דאס איז געווען אבסטראקטיד",
  "block.minecraft.spawner": "פֿאַרזעעניש רויגנער",
  "block.minecraft.spawner.desc1": "ינטעראַקט מיט שאַפֿן איי:",
  "block.minecraft.spawner.desc2": "באַשטעטיקט מאָב טיפּ",
  "block.minecraft.sponge": "שוואם",
  "block.minecraft.spore_blossom": "ספּאָר בלאָססאָם",
  "block.minecraft.spruce_button": "טענענהאלצקנאף",
  "block.minecraft.spruce_door": "טענענהאלצטיר",
  "block.minecraft.spruce_fence": "טענענהאלצצוים",
  "block.minecraft.spruce_fence_gate": "טענענהאלצצוימטויער",
  "block.minecraft.spruce_hanging_sign": "טענענבוים כאַנגגינג צייכן",
  "block.minecraft.spruce_leaves": "טענענבלעטער",
  "block.minecraft.spruce_log": "טענענשטאם",
  "block.minecraft.spruce_planks": "טענענהאלצברעטער",
  "block.minecraft.spruce_pressure_plate": "טענענהאלצדרוקפּלאטע",
  "block.minecraft.spruce_sapling": "טענענזעצלינג",
  "block.minecraft.spruce_shelf": "Spruce Shelf",
  "block.minecraft.spruce_sign": "טענענהאלצשילד",
  "block.minecraft.spruce_slab": "טענענהאלצפּלאטע",
  "block.minecraft.spruce_stairs": "טענענהאלצטרעפף",
  "block.minecraft.spruce_trapdoor": "טענענהאלצפֿאלטיר",
  "block.minecraft.spruce_wall_hanging_sign": "טענענבוים וואנט כאַנגגינג צייכן",
  "block.minecraft.spruce_wall_sign": "טענענהאלצוואנדשילד",
  "block.minecraft.spruce_wood": "טענענהאלץ",
  "block.minecraft.sticky_piston": "קלעפּיקע קאלבע",
  "block.minecraft.stone": "שטיין",
  "block.minecraft.stone_brick_slab": "שטיינציגלפּלאטע",
  "block.minecraft.stone_brick_stairs": "שטיינציגלטרעף",
  "block.minecraft.stone_brick_wall": "שטיינציגלמויער",
  "block.minecraft.stone_bricks": "שטיינציגל",
  "block.minecraft.stone_button": "שטיינקנאף",
  "block.minecraft.stone_pressure_plate": "שטיינדרוקפלאטע",
  "block.minecraft.stone_slab": "שטיינפּלאטע",
  "block.minecraft.stone_stairs": "שטיינטרעף",
  "block.minecraft.stonecutter": "שטיינזעג",
  "block.minecraft.stripped_acacia_log": "געשיילטער אקאציענשטאם",
  "block.minecraft.stripped_acacia_wood": "געשיילטער אקאציענהאלץ",
  "block.minecraft.stripped_bamboo_block": "בלאָק פון סטריפּט באַמבו",
  "block.minecraft.stripped_birch_log": "געשיילטער בערעזעשטאם",
  "block.minecraft.stripped_birch_wood": "געשיילטער בערעזעהאלץ",
  "block.minecraft.stripped_cherry_log": "סטריפּט קאַרש קלאָץ",
  "block.minecraft.stripped_cherry_wood": "סטריפּט קאַרש האָלץ",
  "block.minecraft.stripped_crimson_hyphae": "סטריפט פאמסן היפא",
  "block.minecraft.stripped_crimson_stem": "סטריפט פאמסן סטעם",
  "block.minecraft.stripped_dark_oak_log": "געשיילטער שווארצייכנשטאם",
  "block.minecraft.stripped_dark_oak_wood": "געשיילטער שווארצייכנהאלץ",
  "block.minecraft.stripped_jungle_log": "געשיילטער זשונגלשטאם",
  "block.minecraft.stripped_jungle_wood": "געשיילטער זשונגלהאלץ",
  "block.minecraft.stripped_mangrove_log": "סטריפּט מאַנגראָווע קלאָץ",
  "block.minecraft.stripped_mangrove_wood": "סטריפּט מאַנגראָווע האָלץ",
  "block.minecraft.stripped_oak_log": "געשיילטער אייכנשטאם",
  "block.minecraft.stripped_oak_wood": "געשיילטער אייכנהאלץ",
  "block.minecraft.stripped_pale_oak_log": "Stripped Pale Oak Log",
  "block.minecraft.stripped_pale_oak_wood": "Stripped Pale Oak Wood",
  "block.minecraft.stripped_spruce_log": "געשיילטער טענענשטאם",
  "block.minecraft.stripped_spruce_wood": "געשיילטער טענענהאלץ",
  "block.minecraft.stripped_warped_hyphae": "סטריפט צעמישט היפא",
  "block.minecraft.stripped_warped_stem": "סטריפט צעמישט סטעם",
  "block.minecraft.structure_block": "סטרוקטורבלאק",
  "block.minecraft.structure_void": "סטרוקטור־תּהום",
  "block.minecraft.sugar_cane": "צוקערראר",
  "block.minecraft.sunflower": "סאנישניק",
  "block.minecraft.suspicious_gravel": "סאַספּישאַס גראַוואַל",
  "block.minecraft.suspicious_sand": "סאַספּישאַס זאַמד",
  "block.minecraft.sweet_berry_bush": "זיסיאגדעסקשאקע",
  "block.minecraft.tall_dry_grass": "הױך טרוקן גראָז",
  "block.minecraft.tall_grass": "הויךגראז",
  "block.minecraft.tall_seagrass": "האיכס ים־גראז",
  "block.minecraft.target": "ציל בלאק",
  "block.minecraft.terracotta": "קעראמיק",
  "block.minecraft.test_block": "Test Block",
  "block.minecraft.test_instance_block": "Test Instance Block",
  "block.minecraft.tinted_glass": "טינטעד גלאַס",
  "block.minecraft.tnt": "דינאמיט",
  "block.minecraft.tnt.disabled": "TNT explosions are disabled",
  "block.minecraft.torch": "פֿאקל",
  "block.minecraft.torchflower": "טאָרטשפלאָווער",
  "block.minecraft.torchflower_crop": "טאָרטשפלאָווער קראָפּ",
  "block.minecraft.trapped_chest": "כאפּקאסטן",
  "block.minecraft.trial_spawner": "לאַנג צוריק טשאַלאַנדזשיז",
  "block.minecraft.tripwire": "ניכשלדראט",
  "block.minecraft.tripwire_hook": "ניכשלדראטהאקן",
  "block.minecraft.tube_coral": "ארגלקארא",
  "block.minecraft.tube_coral_block": "ארגלקאראלנבלאק",
  "block.minecraft.tube_coral_fan": "ארגלקאראלנפעכער",
  "block.minecraft.tube_coral_wall_fan": "ארגלקאראלנוואנדפעכער",
  "block.minecraft.tuff": "טוף",
  "block.minecraft.tuff_brick_slab": "טאַף ציגל שנייַדן אין האַלב",
  "block.minecraft.tuff_brick_stairs": "טאַף ציגל טרעפּ",
  "block.minecraft.tuff_brick_wall": "א טוף ציגל וואַנט",
  "block.minecraft.tuff_bricks": "טוף בריקס",
  "block.minecraft.tuff_slab": "טוף אין האַלב",
  "block.minecraft.tuff_stairs": "טוף טרעפּ",
  "block.minecraft.tuff_wall": "טאַף וואַנט",
  "block.minecraft.turtle_egg": "שילדקרויטניי",
  "block.minecraft.twisting_vines": "טוויסטינג וויינשטאק",
  "block.minecraft.twisting_vines_plant": "טוויסטינג וויינשטאק זאוואד",
  "block.minecraft.vault": "זיכער",
  "block.minecraft.verdant_froglight": "ווערדאַנט פראָגליגהט",
  "block.minecraft.vine": "קלעטערערקרויט",
  "block.minecraft.void_air": "תּהום־לופט",
  "block.minecraft.wall_torch": "וואנדפֿאקל",
  "block.minecraft.warped_button": "צעמישט קנעפּל",
  "block.minecraft.warped_door": "צעמישט טיר",
  "block.minecraft.warped_fence": "צעמישט פלויט",
  "block.minecraft.warped_fence_gate": "צעמישט פלויט טויער",
  "block.minecraft.warped_fungus": "צעמישט שוועמל",
  "block.minecraft.warped_hanging_sign": "וואָרפּט כאַנגגינג צייכן",
  "block.minecraft.warped_hyphae": "צעמישט היפא",
  "block.minecraft.warped_nylium": "צעמישט ניליום",
  "block.minecraft.warped_planks": "צעמישט בארדז",
  "block.minecraft.warped_pressure_plate": "צעמישט דרוקפלאטע",
  "block.minecraft.warped_roots": "צעמישט ווארצל",
  "block.minecraft.warped_shelf": "Warped Shelf",
  "block.minecraft.warped_sign": "צעמישט שילד",
  "block.minecraft.warped_slab": "צעמישט פלאטע",
  "block.minecraft.warped_stairs": "צעמישט טרעפ",
  "block.minecraft.warped_stem": "צעמישט סטעם",
  "block.minecraft.warped_trapdoor": "צעמישט טראפ טיר",
  "block.minecraft.warped_wall_hanging_sign": "וואָרפּט וואנט כאַנגגינג צייכן",
  "block.minecraft.warped_wall_sign": "ווארפּט וואנט צייכן",
  "block.minecraft.warped_wart_block": "צעמישט בראדעווקע בלאק",
  "block.minecraft.water": "וואסער",
  "block.minecraft.water_cauldron": "וואַסער קעסל",
  "block.minecraft.waxed_chiseled_copper": "סקאַלפּטיד קופּער קאָוטאַד מיט וואַקס",
  "block.minecraft.waxed_copper_bars": "Waxed Copper Bars",
  "block.minecraft.waxed_copper_block": "וואַקסט בלאַק פון קופּער",
  "block.minecraft.waxed_copper_bulb": "א וואַקס קאָוטאַד קופּער ציבעלע",
  "block.minecraft.waxed_copper_chain": "Waxed Copper Chain",
  "block.minecraft.waxed_copper_chest": "Waxed Copper Chest",
  "block.minecraft.waxed_copper_door": "וואַקס קאָוטאַד קופּער טיר",
  "block.minecraft.waxed_copper_golem_statue": "Waxed Copper Golem Statue",
  "block.minecraft.waxed_copper_grate": "א וואַקס-קאָוטאַד קופּער כאַבאַרניק",
  "block.minecraft.waxed_copper_lantern": "Waxed Copper Lantern",
  "block.minecraft.waxed_copper_trapdoor": "פאַרבאָרגן טיר געמאכט פון וואַקס-קאָוטאַד קופּער",
  "block.minecraft.waxed_cut_copper": "וואַקסט קאַט קופּער",
  "block.minecraft.waxed_cut_copper_slab": "וואַקסט קאַט קופּער פּלאַטע",
  "block.minecraft.waxed_cut_copper_stairs": "וואַקסעד קאַט קופּער טרעפּ",
  "block.minecraft.waxed_exposed_chiseled_copper": "סקאַלפּטיד נאַקעט קופּער קאָוטאַד מיט וואַקס",
  "block.minecraft.waxed_exposed_copper": "וואַקסעד יקספּאָוזד קופּער",
  "block.minecraft.waxed_exposed_copper_bars": "Waxed Exposed Copper Bars",
  "block.minecraft.waxed_exposed_copper_bulb": "נאַקעט קופּער ציבעלע קאָוטאַד מיט וואַקס",
  "block.minecraft.waxed_exposed_copper_chain": "Waxed Exposed Copper Chain",
  "block.minecraft.waxed_exposed_copper_chest": "Waxed Exposed Copper Chest",
  "block.minecraft.waxed_exposed_copper_door": "נאַקעט קופּער טיר מיט וואַקס קאָוטינג",
  "block.minecraft.waxed_exposed_copper_golem_statue": "Waxed Exposed Copper Golem Statue",
  "block.minecraft.waxed_exposed_copper_grate": "נאַקעט קופּער כאַבאַרניק קאָוטאַד מיט וואַקס",
  "block.minecraft.waxed_exposed_copper_lantern": "Waxed Exposed Copper Lantern",
  "block.minecraft.waxed_exposed_copper_trapdoor": "פאַרבאָרגן טיר געמאכט פון נאַקעט קופּער קאָוטאַד מיט וואַקס",
  "block.minecraft.waxed_exposed_cut_copper": "וואַקסעד יקספּאָוזד קאַט קופּער",
  "block.minecraft.waxed_exposed_cut_copper_slab": "וואַקסעד יקספּאָוזד קאַט קופּער פּלאַטע",
  "block.minecraft.waxed_exposed_cut_copper_stairs": "וואַקסעד קאַט קופּער טרעפּ",
  "block.minecraft.waxed_exposed_lightning_rod": "Waxed Exposed Lightning Rod",
  "block.minecraft.waxed_lightning_rod": "Waxed Lightning Rod",
  "block.minecraft.waxed_oxidized_chiseled_copper": "סקאַלפּטיד אַקסאַדייזד קופּער קאָוטאַד מיט וואַקס",
  "block.minecraft.waxed_oxidized_copper": "וואַקסעד אַקסאַדייזד קאַפּער",
  "block.minecraft.waxed_oxidized_copper_bars": "Waxed Oxidized Copper Bars",
  "block.minecraft.waxed_oxidized_copper_bulb": "וואַקס קאָוטאַד אַקסאַדייזד קופּער ציבעלע",
  "block.minecraft.waxed_oxidized_copper_chain": "Waxed Oxidized Copper Chain",
  "block.minecraft.waxed_oxidized_copper_chest": "Waxed Oxidized Copper Chest",
  "block.minecraft.waxed_oxidized_copper_door": "אַקסאַדייזד קופּער טיר מיט וואַקס קאָוטינג",
  "block.minecraft.waxed_oxidized_copper_golem_statue": "Waxed Oxidized Copper Golem Statue",
  "block.minecraft.waxed_oxidized_copper_grate": "וואַקס קאָוטאַד אַקסאַדייזד קופּער כאַבאַרניק",
  "block.minecraft.waxed_oxidized_copper_lantern": "Waxed Oxidized Copper Lantern",
  "block.minecraft.waxed_oxidized_copper_trapdoor": "אַקסאַדייזד קופּער טיר מיט וואַקס קאָוטינג",
  "block.minecraft.waxed_oxidized_cut_copper": "וואַקסיד אַקסידייזד קאַט קאַפּער",
  "block.minecraft.waxed_oxidized_cut_copper_slab": "וואַקסיד אַקסאַדייזד קאַט קופּער פּלאַטע",
  "block.minecraft.waxed_oxidized_cut_copper_stairs": "וואַקסיד אַקסאַדייזד קאַט קופּער טרעפּ",
  "block.minecraft.waxed_oxidized_lightning_rod": "Waxed Oxidized Lightning Rod",
  "block.minecraft.waxed_weathered_chiseled_copper": "וואָרן סקאַלפּטיד קופּער מיט וואַקס קאָוטינג",
  "block.minecraft.waxed_weathered_copper": "וואַקסעד וועדערד קופּער",
  "block.minecraft.waxed_weathered_copper_bars": "Waxed Weathered Copper Bars",
  "block.minecraft.waxed_weathered_copper_bulb": "וואָרן קופּער ציבעלע קאָוטאַד מיט וואַקס",
  "block.minecraft.waxed_weathered_copper_chain": "Waxed Weathered Copper Chain",
  "block.minecraft.waxed_weathered_copper_chest": "Waxed Weathered Copper Chest",
  "block.minecraft.waxed_weathered_copper_door": "וואָרן קופּער טיר מיט וואַקס קאָוטינג",
  "block.minecraft.waxed_weathered_copper_golem_statue": "Waxed Weathered Copper Golem Statue",
  "block.minecraft.waxed_weathered_copper_grate": "וואָרן קופּער כאַבאַרניק קאָוטאַד מיט וואַקס",
  "block.minecraft.waxed_weathered_copper_lantern": "Waxed Weathered Copper Lantern",
  "block.minecraft.waxed_weathered_copper_trapdoor": "וואַקסעד וועטערעד קאָפּפּער טראַפּדאָאָר",
  "block.minecraft.waxed_weathered_cut_copper": "וואַקסעד וועדערד קאַט קאַפּער",
  "block.minecraft.waxed_weathered_cut_copper_slab": "וואַקסעד וועדערד קאַט קופּער פּלאַטע",
  "block.minecraft.waxed_weathered_cut_copper_stairs": "וואַקסעד וועדערד קאַט קאַפּער טרעפּ",
  "block.minecraft.waxed_weathered_lightning_rod": "Waxed Weathered Lightning Rod",
  "block.minecraft.weathered_chiseled_copper": "וועדערד טשיסעלעד קופּער",
  "block.minecraft.weathered_copper": "וועדערד קופּער",
  "block.minecraft.weathered_copper_bars": "Weathered Copper Bars",
  "block.minecraft.weathered_copper_bulb": "וועדערד קופּער ציבעלע",
  "block.minecraft.weathered_copper_chain": "Weathered Copper Chain",
  "block.minecraft.weathered_copper_chest": "Weathered Copper Chest",
  "block.minecraft.weathered_copper_door": "וועדערד קופּער טיר",
  "block.minecraft.weathered_copper_golem_statue": "Weathered Copper Golem Statue",
  "block.minecraft.weathered_copper_grate": "וואָרן קופּער כאַבאַרניק",
  "block.minecraft.weathered_copper_lantern": "Weathered Copper Lantern",
  "block.minecraft.weathered_copper_trapdoor": "וואָרן קופּער פאַרבאָרגן טיר",
  "block.minecraft.weathered_cut_copper": "וועדערד קאַט קאַפּער",
  "block.minecraft.weathered_cut_copper_slab": "וועדערד קאַט קופּער פּלאַטע",
  "block.minecraft.weathered_cut_copper_stairs": "וועדערד קאַט קאַפּער טרעפּ",
  "block.minecraft.weathered_lightning_rod": "Weathered Lightning Rod",
  "block.minecraft.weeping_vines": "וויינען וויינשטאק",
  "block.minecraft.weeping_vines_plant": "וויינען וויינשטאק זאוואד",
  "block.minecraft.wet_sponge": "נאסער שוואם",
  "block.minecraft.wheat": "ווייצנפֿלאנצונג",
  "block.minecraft.white_banner": "ווייסע פאן",
  "block.minecraft.white_bed": "ווייַסס בעט",
  "block.minecraft.white_candle": "ווייַס ליכט",
  "block.minecraft.white_candle_cake": "שטיקל מיט ווייַס ליכט",
  "block.minecraft.white_carpet": "ווייַסער טעפּעך",
  "block.minecraft.white_concrete": "ווייַסבעטאן",
  "block.minecraft.white_concrete_powder": "ווייַסבעטאנפולווער",
  "block.minecraft.white_glazed_terracotta": "ווייַסגלאזירטע קעראמיק",
  "block.minecraft.white_shulker_box": "ווייסע שולקערקאסע",
  "block.minecraft.white_stained_glass": "ווייַסגעפֿארבטס גלאז",
  "block.minecraft.white_stained_glass_pane": "ווייַסגעפֿארבטע גלאזשויב",
  "block.minecraft.white_terracotta": "ווייַסע קעראמיק",
  "block.minecraft.white_tulip": "ווייַסע טולפּע",
  "block.minecraft.white_wool": "ווייַסע וואל",
  "block.minecraft.wildflowers": "פֿעלדבלומען",
  "block.minecraft.wither_rose": "ווידער־רויז",
  "block.minecraft.wither_skeleton_skull": "ווידער־סקעלעטשיידל",
  "block.minecraft.wither_skeleton_wall_skull": "ווידער־סקעלעטוואנדשיידל",
  "block.minecraft.yellow_banner": "געלע פאן",
  "block.minecraft.yellow_bed": "געלס בעט",
  "block.minecraft.yellow_candle": "געל ליכט",
  "block.minecraft.yellow_candle_cake": "שטיקל מיט אַ געל ליכט",
  "block.minecraft.yellow_carpet": "געלער טעפּעך",
  "block.minecraft.yellow_concrete": "געלבעטאן",
  "block.minecraft.yellow_concrete_powder": "געלבעטאנפולווער",
  "block.minecraft.yellow_glazed_terracotta": "געלגלאזירטע קעראמיק",
  "block.minecraft.yellow_shulker_box": "געלע שולקערקאסע",
  "block.minecraft.yellow_stained_glass": "געלגעפֿארבטס גלאז",
  "block.minecraft.yellow_stained_glass_pane": "געלגעפֿארבטע גלאזשויב",
  "block.minecraft.yellow_terracotta": "געלע קעראמיק",
  "block.minecraft.yellow_wool": "געלע וואל",
  "block.minecraft.zombie_head": "זאמביקאף",
  "block.minecraft.zombie_wall_head": "זאמביוואנדקאף",
  "item.minecraft.acacia_boat": "אקאציענההאלצלאדקעלאדקע",
  "item.minecraft.acacia_chest_boat": "אַקיישאַ שיפל מיט קאַסטן",
  "item.minecraft.allay_spawn_egg": "אַליי ספּאון איי",
  "item.minecraft.amethyst_shard": "אַהלאַמאַ סליווער",
  "item.minecraft.angler_pottery_shard": "אַנגלער טעפּערייַ שאַרד",
  "item.minecraft.angler_pottery_sherd": "אַנגלער טעפּערייַ שערד",
  "item.minecraft.apple": "עפל",
  "item.minecraft.archer_pottery_shard": "אַרטשער טעפּערייַ שאַרד",
  "item.minecraft.archer_pottery_sherd": "אַרטשער טעפּערייַ שערד",
  "item.minecraft.armadillo_scute": "א שטיק ארמאדילא פאנצער",
  "item.minecraft.armadillo_spawn_egg": "אַרמאַדילאָ סוממאָנינג יי",
  "item.minecraft.armor_stand": "פאנצערשטאנד",
  "item.minecraft.arms_up_pottery_shard": "געווער אַרויף טעפּערייַ שאַרד",
  "item.minecraft.arms_up_pottery_sherd": "אַרמס אַרויף טעפּערייַ שערד",
  "item.minecraft.arrow": "פֿייַל",
  "item.minecraft.axolotl_bucket": "עמער פון אַקסאָלאָטל",
  "item.minecraft.axolotl_spawn_egg": "אַקסאָלאָטל ספּאָן איי",
  "item.minecraft.baked_potato": "אויוונקארטאלפן",
  "item.minecraft.bamboo_chest_raft": "באַמבו פּליט מיט קאַסטן",
  "item.minecraft.bamboo_raft": "באַמבו פּליט",
  "item.minecraft.bat_spawn_egg": "פֿלעדערמויז־באמידשזי־איי",
  "item.minecraft.bee_spawn_egg": "האנייקאמב בלאק",
  "item.minecraft.beef": "רויעס רינדפלייש",
  "item.minecraft.beetroot": "צוויק",
  "item.minecraft.beetroot_seeds": "צוויקעסזוימענס",
  "item.minecraft.beetroot_soup": "בארשט",
  "item.minecraft.birch_boat": "בערעזעהאלצלאדקע",
  "item.minecraft.birch_chest_boat": "בערעזע שיפל מיט קאַסטן",
  "item.minecraft.black_bundle": "Black Bundle",
  "item.minecraft.black_dye": "שווארצער פארבשטאף",
  "item.minecraft.black_harness": "Black Harness",
  "item.minecraft.blade_pottery_shard": "בלייד טעפּערייַ שאַרד",
  "item.minecraft.blade_pottery_sherd": "בלייד טעפּערייַ שערד",
  "item.minecraft.blaze_powder": "טאוזנשטויב",
  "item.minecraft.blaze_rod": "טאוזנשטאב",
  "item.minecraft.blaze_spawn_egg": "טאוזנ־באמידשזי־איי",
  "item.minecraft.blue_bundle": "Blue Bundle",
  "item.minecraft.blue_dye": "בלויער פארבשטאף",
  "item.minecraft.blue_egg": "בלױע אײן",
  "item.minecraft.blue_harness": "Blue Harness",
  "item.minecraft.bogged_spawn_egg": "סאַבמערדזשד סוממאָנינג יי",
  "item.minecraft.bolt_armor_trim_smithing_template": "שמיד ס שאַבלאָן",
  "item.minecraft.bolt_armor_trim_smithing_template.new": "בליץ פאנצער באַפּוצונג",
  "item.minecraft.bone": "קנאכן",
  "item.minecraft.bone_meal": "ביינמעל",
  "item.minecraft.book": "בוך",
  "item.minecraft.bordure_indented_banner_pattern": "קערלד גרענעץ פאָן מוסטער",
  "item.minecraft.bow": "בויגן",
  "item.minecraft.bowl": "שיסל",
  "item.minecraft.bread": "ברויט",
  "item.minecraft.breeze_rod": "בריז רוט",
  "item.minecraft.breeze_spawn_egg": "בריז סוממאָנינג יי",
  "item.minecraft.brewer_pottery_shard": "טרונק פאַבריקאַנט טעפּערייַ שאַרד",
  "item.minecraft.brewer_pottery_sherd": "טרונק פאַבריקאַנט טעפּערייַ שערד",
  "item.minecraft.brewing_stand": "ברויען־סטאַנציע",
  "item.minecraft.brick": "ציגלשטיין",
  "item.minecraft.brown_bundle": "Brown Bundle",
  "item.minecraft.brown_dye": "ברויינער פארבשטאף",
  "item.minecraft.brown_egg": "ברױנע אײ",
  "item.minecraft.brown_harness": "Brown Harness",
  "item.minecraft.brush": "באַרשט",
  "item.minecraft.bucket": "עמער",
  "item.minecraft.bundle": "פּעקל",
  "item.minecraft.bundle.empty": "ליידיק",
  "item.minecraft.bundle.empty.description": "קענען האַלטן אַ געמישט הויפן פון זאכן",
  "item.minecraft.bundle.full": "פול",
  "item.minecraft.bundle.fullness": "%s/%s",
  "item.minecraft.burn_pottery_shard": "ברענען טעפּערייַ שאַרד",
  "item.minecraft.burn_pottery_sherd": "ברענען טעפּערייַ שערד",
  "item.minecraft.camel_husk_spawn_egg": "Camel Husk Spawn Egg",
  "item.minecraft.camel_spawn_egg": "דראָמעדאַר רויגן־אײ",
  "item.minecraft.carrot": "מער",
  "item.minecraft.carrot_on_a_stick": "מעררוט",
  "item.minecraft.cat_spawn_egg": "קאץ־באמידשזי־איי",
  "item.minecraft.cauldron": "קעסל",
  "item.minecraft.cave_spider_spawn_egg": "היילנשפּינ־באמידשזי־איי",
  "item.minecraft.chainmail_boots": "קייטנשטיוול",
  "item.minecraft.chainmail_chestplate": "קייטנהעמד",
  "item.minecraft.chainmail_helmet": "קייטנהעלם",
  "item.minecraft.chainmail_leggings": "קייטנהויזן",
  "item.minecraft.charcoal": "האלצקויל",
  "item.minecraft.cherry_boat": "קאַרש באָאַט",
  "item.minecraft.cherry_chest_boat": "קאַרש שיפל מיט קאַסטן",
  "item.minecraft.chest_minecart": "קאסטנדראבינע",
  "item.minecraft.chicken": "רויס הינערפלייש",
  "item.minecraft.chicken_spawn_egg": "הונ־באמידשזי־איי",
  "item.minecraft.chorus_fruit": "כארכארויפס",
  "item.minecraft.clay_ball": "שטיק פון ליים",
  "item.minecraft.clock": "זייגער",
  "item.minecraft.coal": "קויל",
  "item.minecraft.coast_armor_trim_smithing_template": "שמיד ס שאַבלאָן",
  "item.minecraft.coast_armor_trim_smithing_template.new": "קאָוסטאַל פאנצער באַפּוצונג",
  "item.minecraft.cocoa_beans": "קאקאאבוינענ",
  "item.minecraft.cod": "רויער דארש",
  "item.minecraft.cod_bucket": "דארשעמער",
  "item.minecraft.cod_spawn_egg": "דארש־באמידשזי־איי",
  "item.minecraft.command_block_minecart": "באפֿעלסבלאקדראבינע",
  "item.minecraft.compass": "קאמפאס",
  "item.minecraft.cooked_beef": "געבראטנס רינדפלייש",
  "item.minecraft.cooked_chicken": "געבראטנס הינערפלייש",
  "item.minecraft.cooked_cod": "געבראטנער דארש",
  "item.minecraft.cooked_mutton": "געבראטנס שאפנפלייש",
  "item.minecraft.cooked_porkchop": "געבראטנס שוויינפלייש",
  "item.minecraft.cooked_rabbit": "געבראטנס קראליקפלייש",
  "item.minecraft.cooked_salmon": "געבראטנער לאקס",
  "item.minecraft.cookie": "קיכל",
  "item.minecraft.copper_axe": "Copper Axe",
  "item.minecraft.copper_boots": "Copper Boots",
  "item.minecraft.copper_chestplate": "Copper Chestplate",
  "item.minecraft.copper_golem_spawn_egg": "Copper Golem Spawn Egg",
  "item.minecraft.copper_helmet": "Copper Helmet",
  "item.minecraft.copper_hoe": "Copper Hoe",
  "item.minecraft.copper_horse_armor": "Copper Horse Armor",
  "item.minecraft.copper_ingot": "קופּער ינגגאַץ",
  "item.minecraft.copper_leggings": "Copper Leggings",
  "item.minecraft.copper_nautilus_armor": "Copper Nautilus Armor",
  "item.minecraft.copper_nugget": "Copper Nugget",
  "item.minecraft.copper_pickaxe": "Copper Pickaxe",
  "item.minecraft.copper_shovel": "Copper Shovel",
  "item.minecraft.copper_spear": "Copper Spear",
  "item.minecraft.copper_sword": "Copper Sword",
  "item.minecraft.cow_spawn_egg": "קו־באמידשזי־איי",
  "item.minecraft.creaking_spawn_egg": "Creaking Spawn Egg",
  "item.minecraft.creeper_banner_pattern": "פאנפארלאג",
  "item.minecraft.creeper_banner_pattern.desc": "קריפערספארעם",
  "item.minecraft.creeper_banner_pattern.new": "קרעעפּער לאַסט פאָן מוסטער",
  "item.minecraft.creeper_spawn_egg": "קריפּער־באמידשזי־איי",
  "item.minecraft.crossbow": "ארמברוסט",
  "item.minecraft.crossbow.projectile": "שאס:",
  "item.minecraft.crossbow.projectile.multiple": "Projectile: %s x %s",
  "item.minecraft.crossbow.projectile.single": "Projectile: %s",
  "item.minecraft.cyan_bundle": "Cyan Bundle",
  "item.minecraft.cyan_dye": "טורקיזפארבשטאף",
  "item.minecraft.cyan_harness": "Cyan Harness",
  "item.minecraft.danger_pottery_shard": "געפאַר פּאָטערי שאַרד",
  "item.minecraft.danger_pottery_sherd": "געפאַר פּאָטערי שערד",
  "item.minecraft.dark_oak_boat": "שווארצייכנהאלצלאדקע",
  "item.minecraft.dark_oak_chest_boat": "טונקל דעמב שיפל מיט קאַסטן",
  "item.minecraft.debug_stick": "דיבאג־שטאב",
  "item.minecraft.debug_stick.empty": "%s האט נישט קיינע בלאקצושטאנדן",
  "item.minecraft.debug_stick.select": "״%s״ אויסגעוויילט (%s)",
  "item.minecraft.debug_stick.update": "״%s״ צו %s",
  "item.minecraft.diamond": "דימענט",
  "item.minecraft.diamond_axe": "דימענטהאק",
  "item.minecraft.diamond_boots": "דימענטשטיוול",
  "item.minecraft.diamond_chestplate": "דימענטהעמד",
  "item.minecraft.diamond_helmet": "דימענטהעלם",
  "item.minecraft.diamond_hoe": "דימענטגראבאייַזן",
  "item.minecraft.diamond_horse_armor": "דימענטפערדפאנצער",
  "item.minecraft.diamond_leggings": "דימענטהויזן",
  "item.minecraft.diamond_nautilus_armor": "Diamond Nautilus Armor",
  "item.minecraft.diamond_pickaxe": "דימענטשפיצהאק",
  "item.minecraft.diamond_shovel": "דימענטשופל",
  "item.minecraft.diamond_spear": "Diamond Spear",
  "item.minecraft.diamond_sword": "דימענטשווערד",
  "item.minecraft.disc_fragment_5": "דיסק פראַגמענט",
  "item.minecraft.disc_fragment_5.desc": "מוזיק דיסק - 5",
  "item.minecraft.dolphin_spawn_egg": "דעלפֿינ־באמידשזי־איי",
  "item.minecraft.donkey_spawn_egg": "אייזל־באמידשזי־איי",
  "item.minecraft.dragon_breath": "דראקאנאטעם",
  "item.minecraft.dried_kelp": "טרוקנס ים־גראז",
  "item.minecraft.drowned_spawn_egg": "דערטרונקענען־באמידשזי־איי",
  "item.minecraft.dune_armor_trim_smithing_template": "שמיד ס שאַבלאָן",
  "item.minecraft.dune_armor_trim_smithing_template.new": "אַרמאָר באַפּוצונג - דון",
  "item.minecraft.echo_shard": "ווידערקאָל שערד",
  "item.minecraft.egg": "איי",
  "item.minecraft.elder_guardian_spawn_egg": "גרויסדאזארע־באמידשזי־איי",
  "item.minecraft.elytra": "עליטרע",
  "item.minecraft.emerald": "שמאראק",
  "item.minecraft.enchanted_book": "פארצויבערטס בוך",
  "item.minecraft.enchanted_golden_apple": "פארצויבערטער גאלדעפל",
  "item.minecraft.end_crystal": "ענדקרישטאל",
  "item.minecraft.ender_dragon_spawn_egg": "ענדערדראַקאָן רויגן אײ",
  "item.minecraft.ender_eye": "ענדערויג",
  "item.minecraft.ender_pearl": "ענדערפערל",
  "item.minecraft.enderman_spawn_egg": "ענדערמאַן רויגן אײ",
  "item.minecraft.endermite_spawn_egg": "ענדערמיטן־באמידשזי־איי",
  "item.minecraft.evoker_spawn_egg": "אויסרופער־באמידשזי־איי",
  "item.minecraft.experience_bottle": "דערפארונגספלעשל",
  "item.minecraft.explorer_pottery_shard": "מענטש וואָס יקספּלאָרז פּאָטערי שאַרד",
  "item.minecraft.explorer_pottery_sherd": "מענטש וואָס יקספּלאָרז פּאָטערי שערד",
  "item.minecraft.eye_armor_trim_smithing_template": "שמיד ס שאַבלאָן",
  "item.minecraft.eye_armor_trim_smithing_template.new": "אויג פאנצער באַפּוצונג",
  "item.minecraft.feather": "פעדער",
  "item.minecraft.fermented_spider_eye": "געיוירנס שפינענויג",
  "item.minecraft.field_masoned_banner_pattern": "Field Masoned Banner Pattern",
  "item.minecraft.filled_map": "מאפע",
  "item.minecraft.fire_charge": "פייערבאל",
  "item.minecraft.firework_rocket": "פייערווערקסראקעט",
  "item.minecraft.firework_rocket.flight": "פלידויער:",
  "item.minecraft.firework_rocket.multiple_stars": "%s x %s",
  "item.minecraft.firework_rocket.single_star": "%s",
  "item.minecraft.firework_star": "פייערווערקסשטערן",
  "item.minecraft.firework_star.black": "שווארץ",
  "item.minecraft.firework_star.blue": "בלוי",
  "item.minecraft.firework_star.brown": "ברוין",
  "item.minecraft.firework_star.custom_color": "מנהג",
  "item.minecraft.firework_star.cyan": "טורקיז",
  "item.minecraft.firework_star.fade_to": "איבערגאנג צו",
  "item.minecraft.firework_star.flicker": "פינקעלן",
  "item.minecraft.firework_star.gray": "גרויע",
  "item.minecraft.firework_star.green": "גרין",
  "item.minecraft.firework_star.light_blue": "העלבלוי",
  "item.minecraft.firework_star.light_gray": "העלגרוי",
  "item.minecraft.firework_star.lime": "העלגרין",
  "item.minecraft.firework_star.magenta": "מאדזשענטא",
  "item.minecraft.firework_star.orange": "אראנזש",
  "item.minecraft.firework_star.pink": "העלרויט",
  "item.minecraft.firework_star.purple": "לילא",
  "item.minecraft.firework_star.red": "רויט",
  "item.minecraft.firework_star.shape": "אומבאקאנטע פארעם",
  "item.minecraft.firework_star.shape.burst": "אויפרייס",
  "item.minecraft.firework_star.shape.creeper": "קריפערפארעמיק",
  "item.minecraft.firework_star.shape.large_ball": "גרויסער באל",
  "item.minecraft.firework_star.shape.small_ball": "קליינער באל",
  "item.minecraft.firework_star.shape.star": "שטערנפארעמיק",
  "item.minecraft.firework_star.trail": "וואנדערוועג",
  "item.minecraft.firework_star.white": "ווייַס",
  "item.minecraft.firework_star.yellow": "געל",
  "item.minecraft.fishing_rod": "ווענטקע",
  "item.minecraft.flint": "קיזלשטיין",
  "item.minecraft.flint_and_steel": "פייערשטיין און שטאל",
  "item.minecraft.flow_armor_trim_smithing_template": "Smithing Template",
  "item.minecraft.flow_armor_trim_smithing_template.new": "Flow Armor Trim",
  "item.minecraft.flow_banner_pattern": "Banner Pattern",
  "item.minecraft.flow_banner_pattern.desc": "לויפן",
  "item.minecraft.flow_banner_pattern.new": "Flow Banner Pattern",
  "item.minecraft.flow_pottery_sherd": "Flow Pottery Sherd",
  "item.minecraft.flower_banner_pattern": "באַנער מוסטער",
  "item.minecraft.flower_banner_pattern.desc": "בלומנפארעם",
  "item.minecraft.flower_banner_pattern.new": "Flower Charge Banner Pattern",
  "item.minecraft.flower_pot": "בלומען האלטער",
  "item.minecraft.fox_spawn_egg": "פאקס־באמידשזי־איי",
  "item.minecraft.friend_pottery_shard": "פריינד טעפּערייַ שאַרד",
  "item.minecraft.friend_pottery_sherd": "פרייַנד פּאָטערי שערד",
  "item.minecraft.frog_spawn_egg": "זשאַבע ספּאַון איי",
  "item.minecraft.furnace_minecart": "אויוונדראבינע",
  "item.minecraft.ghast_spawn_egg": "גאסט־באמידשזי־איי",
  "item.minecraft.ghast_tear": "גאסט־טרער",
  "item.minecraft.glass_bottle": "גלאזפלאש",
  "item.minecraft.glistering_melon_slice": "גלענצלדיקע מעלאנענשויב",
  "item.minecraft.globe_banner_pattern": "באַנער מוסטער",
  "item.minecraft.globe_banner_pattern.desc": "גלאבוס",
  "item.minecraft.globe_banner_pattern.new": "Globe Banner Pattern",
  "item.minecraft.glow_berries": "גלאָוינג בעריז",
  "item.minecraft.glow_ink_sac": "גלאָוינג טינט זעקל",
  "item.minecraft.glow_item_frame": "גלאָוינג נומער ראַם",
  "item.minecraft.glow_squid_spawn_egg": "סוממונינג יי סומס שייַנען",
  "item.minecraft.glowstone_dust": "לייַכטשטיינשטויב",
  "item.minecraft.goat_horn": "ציג האָרן",
  "item.minecraft.goat_spawn_egg": "אַ ציג סוממאָנינג יי",
  "item.minecraft.gold_ingot": "גאלדצאנקען",
  "item.minecraft.gold_nugget": "גאלדקלומף",
  "item.minecraft.golden_apple": "גילדנער עפל",
  "item.minecraft.golden_axe": "גאלדהאק",
  "item.minecraft.golden_boots": "גאלדשטיוול",
  "item.minecraft.golden_carrot": "גאלדמער",
  "item.minecraft.golden_chestplate": "גאלדהעמד",
  "item.minecraft.golden_helmet": "גאלדהעלם",
  "item.minecraft.golden_hoe": "גאלדגראבאייַזן",
  "item.minecraft.golden_horse_armor": "גאלדפערדפאנצער",
  "item.minecraft.golden_leggings": "גאלדהויזן",
  "item.minecraft.golden_nautilus_armor": "Golden Nautilus Armor",
  "item.minecraft.golden_pickaxe": "גאלדשפיצהאק",
  "item.minecraft.golden_shovel": "גאלדשופל",
  "item.minecraft.golden_spear": "Golden Spear",
  "item.minecraft.golden_sword": "גאלדשווערד",
  "item.minecraft.gray_bundle": "Gray Bundle",
  "item.minecraft.gray_dye": "גרויפארבשטאף",
  "item.minecraft.gray_harness": "Gray Harness",
  "item.minecraft.green_bundle": "Green Bundle",
  "item.minecraft.green_dye": "גרינער פארבשטאף",
  "item.minecraft.green_harness": "Green Harness",
  "item.minecraft.guardian_spawn_egg": "דאזארע־באמידשזי־איי",
  "item.minecraft.gunpowder": "שווארצפולווער",
  "item.minecraft.guster_banner_pattern": "Banner Pattern",
  "item.minecraft.guster_banner_pattern.desc": "שטורעם",
  "item.minecraft.guster_banner_pattern.new": "Guster Banner Pattern",
  "item.minecraft.guster_pottery_sherd": "Guster Pottery Sherd",
  "item.minecraft.happy_ghast_spawn_egg": "Happy Ghast Spawn Egg",
  "item.minecraft.harness": "Harness",
  "item.minecraft.heart_of_the_sea": "ים־הערץ",
  "item.minecraft.heart_pottery_shard": "האַרץ טעפּערייַ שאַרד",
  "item.minecraft.heart_pottery_sherd": "האַרץ טעפּערייַ שערד",
  "item.minecraft.heartbreak_pottery_shard": "צעבראכן האַרץ פּאָטערי שאַרד",
  "item.minecraft.heartbreak_pottery_sherd": "צעבראכן הארץ פּאָטערי שערד",
  "item.minecraft.hoglin_spawn_egg": "האגלין באמידשזי איי",
  "item.minecraft.honey_bottle": "האניקפֿלאש",
  "item.minecraft.honeycomb": "סאט",
  "item.minecraft.hopper_minecart": "לייקעדראבינע",
  "item.minecraft.horse_spawn_egg": "פערד־באמידשזי־איי",
  "item.minecraft.host_armor_trim_smithing_template": "Smithing Template",
  "item.minecraft.host_armor_trim_smithing_template.new": "Host Armor Trim",
  "item.minecraft.howl_pottery_shard": "כאַול טעפּערייַ שאַרד",
  "item.minecraft.howl_pottery_sherd": "כאַול טעפּערייַ שערד",
  "item.minecraft.husk_spawn_egg": "מידברניק־באמידשזי־איי",
  "item.minecraft.ink_sac": "טינטנבייטל",
  "item.minecraft.iron_axe": "אייַזנהאק",
  "item.minecraft.iron_boots": "אייַזנשטיוול",
  "item.minecraft.iron_chestplate": "אייַזנהעמד",
  "item.minecraft.iron_golem_spawn_egg": "אײַזן־גולם רויגן אײ",
  "item.minecraft.iron_helmet": "אייַזנהעלם",
  "item.minecraft.iron_hoe": "אייַזנגראבאייַזן",
  "item.minecraft.iron_horse_armor": "אייַזנפערדפאנצער",
  "item.minecraft.iron_ingot": "אייַזנצאנקען",
  "item.minecraft.iron_leggings": "אייַזנהויזן",
  "item.minecraft.iron_nautilus_armor": "Iron Nautilus Armor",
  "item.minecraft.iron_nugget": "אייזנקלומף",
  "item.minecraft.iron_pickaxe": "אייַזנשפיצהאק",
  "item.minecraft.iron_shovel": "אייַזנשופל",
  "item.minecraft.iron_spear": "Iron Spear",
  "item.minecraft.iron_sword": "אייַזנשווערד",
  "item.minecraft.item_frame": "געגנשטאנדראם",
  "item.minecraft.jungle_boat": "דזשונגלע שיפֿל",
  "item.minecraft.jungle_chest_boat": "דזשונגלע שיפֿל מיט קאַסטן",
  "item.minecraft.knowledge_book": "וויסנסבוך",
  "item.minecraft.lapis_lazuli": "בלאשטיין",
  "item.minecraft.lava_bucket": "לאוועעמער",
  "item.minecraft.lead": "פעטליע",
  "item.minecraft.leather": "לעדער",
  "item.minecraft.leather_boots": "לעדערשטיוול",
  "item.minecraft.leather_chestplate": "לעדערהעמד",
  "item.minecraft.leather_helmet": "לעדערהעלם",
  "item.minecraft.leather_horse_armor": "לעדערפערדפאנצער",
  "item.minecraft.leather_leggings": "לעדערהויזן",
  "item.minecraft.light_blue_bundle": "Light Blue Bundle",
  "item.minecraft.light_blue_dye": "העלבלויפארבשטאף",
  "item.minecraft.light_blue_harness": "Light Blue Harness",
  "item.minecraft.light_gray_bundle": "Light Gray Bundle",
  "item.minecraft.light_gray_dye": "העלגרויפארבשטאף",
  "item.minecraft.light_gray_harness": "Light Gray Harness",
  "item.minecraft.lime_bundle": "Lime Bundle",
  "item.minecraft.lime_dye": "העלגרינפארבשטאף",
  "item.minecraft.lime_harness": "Lime Harness",
  "item.minecraft.lingering_potion": "פארוויילטרונק",
  "item.minecraft.lingering_potion.effect.awkward": "אומהיימלעכער פארוויילטרונק",
  "item.minecraft.lingering_potion.effect.empty": "אומברויבארער פארוויילטרונק",
  "item.minecraft.lingering_potion.effect.fire_resistance": "פייערשוצספארוויילטרונק",
  "item.minecraft.lingering_potion.effect.harming": "דירעקטשאדנספארוויילטרונק",
  "item.minecraft.lingering_potion.effect.healing": "דירעקטהיילונגספארוויילטרונק",
  "item.minecraft.lingering_potion.effect.infested": "Lingering Potion of Infestation",
  "item.minecraft.lingering_potion.effect.invisibility": "אומזיכטבארקייטספארוויילטרונק",
  "item.minecraft.lingering_potion.effect.leaping": "שפרונגקראפטספארוויילטרונק",
  "item.minecraft.lingering_potion.effect.levitation": "שוועבקראפטספארוויילטרונק",
  "item.minecraft.lingering_potion.effect.luck": "גליקספארוויילטרונק",
  "item.minecraft.lingering_potion.effect.mundane": "געוויינלעכער פארוויילטרונק",
  "item.minecraft.lingering_potion.effect.night_vision": "נאכטזיכטספארוויילטרונק",
  "item.minecraft.lingering_potion.effect.oozing": "Lingering Potion of Oozing",
  "item.minecraft.lingering_potion.effect.poison": "פארגיפטונגספארוויילטרונק",
  "item.minecraft.lingering_potion.effect.regeneration": "רעגענעראציעספארוויילטרונק",
  "item.minecraft.lingering_potion.effect.slow_falling": "ספארוויילטרונק פין א לינדערן פאל",
  "item.minecraft.lingering_potion.effect.slowness": "לאנגזאמקייטספארוויילטרונק",
  "item.minecraft.lingering_potion.effect.strength": "שטארקייטספארוויילטרונק",
  "item.minecraft.lingering_potion.effect.swiftness": "שנעלקייטספארוויילטרונק",
  "item.minecraft.lingering_potion.effect.thick": "דיקער פארוויילטרונק",
  "item.minecraft.lingering_potion.effect.turtle_master": "שילדקרויטנמייסטערספארוויילטרונק",
  "item.minecraft.lingering_potion.effect.water": "פארוויילסוואסערפלאש",
  "item.minecraft.lingering_potion.effect.water_breathing": "אונטערוואסעראטעמספארוויילטרונק",
  "item.minecraft.lingering_potion.effect.weakness": "שוואכקייטספארוויילטרונק",
  "item.minecraft.lingering_potion.effect.weaving": "Lingering Potion of Weaving",
  "item.minecraft.lingering_potion.effect.wind_charged": "Lingering Potion of Wind Charging",
  "item.minecraft.llama_spawn_egg": "לאמע־באמידשזי־איי",
  "item.minecraft.lodestone_compass": "לאדעשטיין קאמפאס",
  "item.minecraft.mace": "געטין פון דונער",
  "item.minecraft.magenta_bundle": "Magenta Bundle",
  "item.minecraft.magenta_dye": "מאדזשענטאפארבשטאףפארבשטאף",
  "item.minecraft.magenta_harness": "Magenta Harness",
  "item.minecraft.magma_cream": "מאגמעקרעם",
  "item.minecraft.magma_cube_spawn_egg": "מאגמעווערפל־באמידשזי־איי",
  "item.minecraft.mangrove_boat": "מאַנגראָווע באָאַט",
  "item.minecraft.mangrove_chest_boat": "מאַנגראָווע שיפל מיט קאַסטן",
  "item.minecraft.map": "לערע קארטע",
  "item.minecraft.melon_seeds": "מעלאנענקערנדלעך",
  "item.minecraft.melon_slice": "מעלאנענשויב",
  "item.minecraft.milk_bucket": "מליכעמער",
  "item.minecraft.minecart": "דראבינע",
  "item.minecraft.miner_pottery_shard": "מענטש וואס מיינס טעפּערייַ שאַרד",
  "item.minecraft.miner_pottery_sherd": "מענטש וואס מיינס טעפּערייַ שערד",
  "item.minecraft.mojang_banner_pattern": "באַנער מוסטער",
  "item.minecraft.mojang_banner_pattern.desc": "שטעמפּל",
  "item.minecraft.mojang_banner_pattern.new": "עמבלעם פאָן מוסטער",
  "item.minecraft.mooshroom_spawn_egg": "מושרום־באמידשזי־איי",
  "item.minecraft.mourner_pottery_shard": "מענטש וואס מאָרנז טעפּערייַ שאַרד",
  "item.minecraft.mourner_pottery_sherd": "מענטש וואס מאָרנז טעפּערייַ שערד",
  "item.minecraft.mule_spawn_egg": "מוילאייזל־באמידשזי־איי",
  "item.minecraft.mushroom_stew": "שוועמלזוף",
  "item.minecraft.music_disc_11": "מוזיק דיסק",
  "item.minecraft.music_disc_11.desc": "C418 - 11",
  "item.minecraft.music_disc_13": "שאלפלאטע",
  "item.minecraft.music_disc_13.desc": "C418 - 13",
  "item.minecraft.music_disc_5": "מוזיק דיסק",
  "item.minecraft.music_disc_5.desc": "שמואל אבערג — 5",
  "item.minecraft.music_disc_blocks": "מוזיק דיסק",
  "item.minecraft.music_disc_blocks.desc": "C418 - blocks",
  "item.minecraft.music_disc_cat": "מוזיק דיסק",
  "item.minecraft.music_disc_cat.desc": "C418 - cat",
  "item.minecraft.music_disc_chirp": "מוזיק דיסק",
  "item.minecraft.music_disc_chirp.desc": "C418 - chirp",
  "item.minecraft.music_disc_creator": "מוזיקאליש דיסק",
  "item.minecraft.music_disc_creator.desc": "לענאַ ריין - Creator",
  "item.minecraft.music_disc_creator_music_box": "מוזיקאליש דיסק",
  "item.minecraft.music_disc_creator_music_box.desc": "לענאַ ריין - Creator ‏(Music Box)",
  "item.minecraft.music_disc_far": "מוזיק דיסק",
  "item.minecraft.music_disc_far.desc": "C418 - far",
  "item.minecraft.music_disc_lava_chicken": "Music Disc",
  "item.minecraft.music_disc_lava_chicken.desc": "Hyper Potions - Lava Chicken",
  "item.minecraft.music_disc_mall": "מוזיק דיסק",
  "item.minecraft.music_disc_mall.desc": "C418 - mall",
  "item.minecraft.music_disc_mellohi": "מוזיק דיסק",
  "item.minecraft.music_disc_mellohi.desc": "C418 - mellohi",
  "item.minecraft.music_disc_otherside": "מוזיק דיסק",
  "item.minecraft.music_disc_otherside.desc": "Lena Raine - otherside",
  "item.minecraft.music_disc_pigstep": "מוזיק דיסק",
  "item.minecraft.music_disc_pigstep.desc": "לענאַ ריין - Pigstep",
  "item.minecraft.music_disc_precipice": "מוזיק דיסק",
  "item.minecraft.music_disc_precipice.desc": "אהרן טשעראָף - פּריפּיס",
  "item.minecraft.music_disc_relic": "מוזיק דיסק",
  "item.minecraft.music_disc_relic.desc": "אהרן טשערוף - רעליק",
  "item.minecraft.music_disc_stal": "מוזיק דיסק",
  "item.minecraft.music_disc_stal.desc": "C418 - stal",
  "item.minecraft.music_disc_strad": "מוזיק דיסק",
  "item.minecraft.music_disc_strad.desc": "C418 - strad",
  "item.minecraft.music_disc_tears": "Music Disc",
  "item.minecraft.music_disc_tears.desc": "Amos Roddy - Tears",
  "item.minecraft.music_disc_wait": "מוזיק דיסק",
  "item.minecraft.music_disc_wait.desc": "C418 - wait",
  "item.minecraft.music_disc_ward": "מוזיק דיסק",
  "item.minecraft.music_disc_ward.desc": "C418 - ward",
  "item.minecraft.mutton": "רויס שאפנפלייש",
  "item.minecraft.name_tag": "נאמענסשילד",
  "item.minecraft.nautilus_shell": "נאוטילוסשאל",
  "item.minecraft.nautilus_spawn_egg": "Nautilus Spawn Egg",
  "item.minecraft.nether_brick": "נעדערציגל",
  "item.minecraft.nether_star": "נעדערשטערן",
  "item.minecraft.nether_wart": "נעטהער וואַרט",
  "item.minecraft.netherite_axe": "נעטהעריטע האק",
  "item.minecraft.netherite_boots": "נעטהעריטע שיך",
  "item.minecraft.netherite_chestplate": "נעטהעריטע טשאסטפלאטע",
  "item.minecraft.netherite_helmet": "נעטהעריטע העלם",
  "item.minecraft.netherite_hoe": "נעדעריטע היי",
  "item.minecraft.netherite_horse_armor": "Netherite Horse Armor",
  "item.minecraft.netherite_ingot": "נעטהעריטע באראן",
  "item.minecraft.netherite_leggings": "נעטהעריטע הויזן",
  "item.minecraft.netherite_nautilus_armor": "Netherite Nautilus Armor",
  "item.minecraft.netherite_pickaxe": "נעטהעריטע שפיציקהאק",
  "item.minecraft.netherite_scrap": "נעטהעריטע ברעקלעך",
  "item.minecraft.netherite_shovel": "נעטהעריטע רידל",
  "item.minecraft.netherite_spear": "Netherite Spear",
  "item.minecraft.netherite_sword": "נעטהעריטע שווערד",
  "item.minecraft.netherite_upgrade_smithing_template": "שמיד ס שאַבלאָן",
  "item.minecraft.netherite_upgrade_smithing_template.new": "אַפּגרייד צו נעדעריטע",
  "item.minecraft.oak_boat": "אייכנהאלצלאדקע",
  "item.minecraft.oak_chest_boat": "דעמב שיפל מיט קאַסטן",
  "item.minecraft.ocelot_spawn_egg": "אצעלאט־באמידשזי־איי",
  "item.minecraft.ominous_bottle": "קללה'דיגע פלאש",
  "item.minecraft.ominous_trial_key": "Ominous Trial Key",
  "item.minecraft.orange_bundle": "Orange Bundle",
  "item.minecraft.orange_dye": "אראנזשפארבשטאף",
  "item.minecraft.orange_harness": "Orange Harness",
  "item.minecraft.painting": "געמעל",
  "item.minecraft.pale_oak_boat": "Pale Oak Boat",
  "item.minecraft.pale_oak_chest_boat": "Pale Oak Boat with Chest",
  "item.minecraft.panda_spawn_egg": "רויג יי פּאנדא",
  "item.minecraft.paper": "פאפיר",
  "item.minecraft.parched_spawn_egg": "Parched Spawn Egg",
  "item.minecraft.parrot_spawn_egg": "פאפוגיי־באמידשזי־איי",
  "item.minecraft.phantom_membrane": "פאנטאמהייטל",
  "item.minecraft.phantom_spawn_egg": "פֿאַנטאָם רויגן־אײ",
  "item.minecraft.pig_spawn_egg": "שוויין־באמידשזי־איי",
  "item.minecraft.piglin_banner_pattern": "באַנער מוסטער",
  "item.minecraft.piglin_banner_pattern.desc": "שנוק",
  "item.minecraft.piglin_banner_pattern.new": "Snout Banner Pattern",
  "item.minecraft.piglin_brute_spawn_egg": "שוויינלין ברוט ספּאון איי",
  "item.minecraft.piglin_spawn_egg": "שוויינלין באמידשזי איי",
  "item.minecraft.pillager_spawn_egg": "רויג יי פּיללאגער",
  "item.minecraft.pink_bundle": "Pink Bundle",
  "item.minecraft.pink_dye": "העלרויטפארבשטאף",
  "item.minecraft.pink_harness": "Pink Harness",
  "item.minecraft.pitcher_plant": "קרוג פּלאַנט",
  "item.minecraft.pitcher_pod": "Pitcher Pod",
  "item.minecraft.plenty_pottery_shard": "Plenty Pottery Shard",
  "item.minecraft.plenty_pottery_sherd": "Plenty Pottery Sherd",
  "item.minecraft.poisonous_potato": "גיפטיקע קארטאפל",
  "item.minecraft.polar_bear_spawn_egg": "אייזבער־באמידשזי־איי",
  "item.minecraft.popped_chorus_fruit": "געפלאצע כארפרוכט",
  "item.minecraft.porkchop": "רויס שוויינפלייש",
  "item.minecraft.potato": "קארטאפל",
  "item.minecraft.potion": "טרונק",
  "item.minecraft.potion.effect.awkward": "אומהיימלעכער טרונק",
  "item.minecraft.potion.effect.empty": "אומברויבארער טרונק",
  "item.minecraft.potion.effect.fire_resistance": "פייערשוצסטרונק",
  "item.minecraft.potion.effect.harming": "דירעקטשאדנסטרונק",
  "item.minecraft.potion.effect.healing": "דירעקטהיילונגסטרונק",
  "item.minecraft.potion.effect.infested": "Potion of Infestation",
  "item.minecraft.potion.effect.invisibility": "אומזיכטבארקייטסטרונק",
  "item.minecraft.potion.effect.leaping": "שפרונגקראפטסטרונק",
  "item.minecraft.potion.effect.levitation": "שוועבקראפטסטרונק",
  "item.minecraft.potion.effect.luck": "גליקססטרונק",
  "item.minecraft.potion.effect.mundane": "געוויינלעכער טרונק",
  "item.minecraft.potion.effect.night_vision": "נאכטזיכטסטרונק",
  "item.minecraft.potion.effect.oozing": "Potion of Oozing",
  "item.minecraft.potion.effect.poison": "פארגיפטונגסטרונק",
  "item.minecraft.potion.effect.regeneration": "רעגענעראציעסטרונק",
  "item.minecraft.potion.effect.slow_falling": "סטרונק פין א לינדערן פאל",
  "item.minecraft.potion.effect.slowness": "לאנגזאמקייטסטרונק",
  "item.minecraft.potion.effect.strength": "שטארקייטסטרונק",
  "item.minecraft.potion.effect.swiftness": "שנעלקייטסטרונק",
  "item.minecraft.potion.effect.thick": "דיקער טרונק",
  "item.minecraft.potion.effect.turtle_master": "שילדקרויטנמייסטערסטרונק",
  "item.minecraft.potion.effect.water": "וואסערפלאש",
  "item.minecraft.potion.effect.water_breathing": "אונטערוואסעראטעמסטרונק",
  "item.minecraft.potion.effect.weakness": "שוואכקייטסטרונק",
  "item.minecraft.potion.effect.weaving": "Potion of Weaving",
  "item.minecraft.potion.effect.wind_charged": "Potion of Wind Charging",
  "item.minecraft.pottery_shard_archer": "Archer Pottery Shard",
  "item.minecraft.pottery_shard_arms_up": "Arms Up Pottery Shard",
  "item.minecraft.pottery_shard_prize": "Prize Pottery Shard",
  "item.minecraft.pottery_shard_skull": "Skull Pottery Shard",
  "item.minecraft.powder_snow_bucket": "שניי פּודער עמער",
  "item.minecraft.prismarine_crystals": "פּריסמארינקרישטאלן",
  "item.minecraft.prismarine_shard": "פּריסמארינשערבל",
  "item.minecraft.prize_pottery_shard": "Prize Pottery Shard",
  "item.minecraft.prize_pottery_sherd": "Prize Pottery Sherd",
  "item.minecraft.pufferfish": "שוועלפיש",
  "item.minecraft.pufferfish_bucket": "שוועלפישעמער",
  "item.minecraft.pufferfish_spawn_egg": "שוועלפיש־באמידשזי־איי",
  "item.minecraft.pumpkin_pie": "קירבעסקוכן",
  "item.minecraft.pumpkin_seeds": "קירבעסקערנדלעך",
  "item.minecraft.purple_bundle": "Purple Bundle",
  "item.minecraft.purple_dye": "לילאפארבשטאף",
  "item.minecraft.purple_harness": "Purple Harness",
  "item.minecraft.quartz": "נעדערקווארץ",
  "item.minecraft.rabbit": "רויס קראליקפלייש",
  "item.minecraft.rabbit_foot": "האזנפוס",
  "item.minecraft.rabbit_hide": "האזנפעל",
  "item.minecraft.rabbit_spawn_egg": "קיניגל־באמידשזי־איי",
  "item.minecraft.rabbit_stew": "האזנראגו",
  "item.minecraft.raiser_armor_trim_smithing_template": "Smithing Template",
  "item.minecraft.raiser_armor_trim_smithing_template.new": "Raiser Armor Trim",
  "item.minecraft.ravager_spawn_egg": "רויג איי כארעוו מאכן",
  "item.minecraft.raw_copper": "קופּער פירן",
  "item.minecraft.raw_gold": "ניט-פּראַסעסט גאָלד",
  "item.minecraft.raw_iron": "אייַזן פירן",
  "item.minecraft.recovery_compass": "רעקאָווערי קאָמפּאַס",
  "item.minecraft.red_bundle": "רויט בונדלע",
  "item.minecraft.red_dye": "רוייטער פארבשטאף",
  "item.minecraft.red_harness": "Red Harness",
  "item.minecraft.redstone": "רעדסטאן־שטויב",
  "item.minecraft.resin_brick": "Resin Brick",
  "item.minecraft.resin_clump": "Resin Clump",
  "item.minecraft.rib_armor_trim_smithing_template": "Smithing Template",
  "item.minecraft.rib_armor_trim_smithing_template.new": "Rib Armor Trim",
  "item.minecraft.rotten_flesh": "פארפוילטס פלייש",
  "item.minecraft.saddle": "זאטל",
  "item.minecraft.salmon": "רויער לאקס",
  "item.minecraft.salmon_bucket": "לאקסעמער",
  "item.minecraft.salmon_spawn_egg": "לאקס־באמידשזי־איי",
  "item.minecraft.scrape_pottery_sherd": "Scrape Pottery Sherd",
  "item.minecraft.scute": "הארנשילד",
  "item.minecraft.sentry_armor_trim_smithing_template": "שמיד ס שאַבלאָן",
  "item.minecraft.sentry_armor_trim_smithing_template.new": "גאַרד פאנצער באַפּוצונג",
  "item.minecraft.shaper_armor_trim_smithing_template": "שמיד ס שאַבלאָן",
  "item.minecraft.shaper_armor_trim_smithing_template.new": "א פּלאַן פאנצער באַפּוצונג",
  "item.minecraft.sheaf_pottery_shard": "האַרץ טעפּערייַ שאַרד",
  "item.minecraft.sheaf_pottery_sherd": "האַרץ טעפּערייַ שאַרד",
  "item.minecraft.shears": "שערן",
  "item.minecraft.sheep_spawn_egg": "שאף־באמידשזי־איי",
  "item.minecraft.shelter_pottery_shard": "האַרץ טעפּערייַ שאַרד",
  "item.minecraft.shelter_pottery_sherd": "האַרץ טעפּערייַ שאַרד",
  "item.minecraft.shield": "שילד",
  "item.minecraft.shield.black": "שווארצער שילד",
  "item.minecraft.shield.blue": "בלויער שילד",
  "item.minecraft.shield.brown": "ברוינער שילד",
  "item.minecraft.shield.cyan": "טורקיזער שילד",
  "item.minecraft.shield.gray": "גרויער שילד",
  "item.minecraft.shield.green": "גרינער שילד",
  "item.minecraft.shield.light_blue": "העלבלויער שילד",
  "item.minecraft.shield.light_gray": "העלגרויער שילד",
  "item.minecraft.shield.lime": "העלגרינער שילד",
  "item.minecraft.shield.magenta": "מאדזשענטאער שילד",
  "item.minecraft.shield.orange": "אראנזשער שילד",
  "item.minecraft.shield.pink": "העלרויטער שילד",
  "item.minecraft.shield.purple": "לילאער שילד",
  "item.minecraft.shield.red": "רויטער שילד",
  "item.minecraft.shield.white": "ווייסער שילד",
  "item.minecraft.shield.yellow": "געלער שילד",
  "item.minecraft.shulker_shell": "שולקערשאל",
  "item.minecraft.shulker_spawn_egg": "שולקער־באמידשזי־איי",
  "item.minecraft.sign": "שילד",
  "item.minecraft.silence_armor_trim_smithing_template": "שמיד ס שאַבלאָן",
  "item.minecraft.silence_armor_trim_smithing_template.new": "אַרמאָר באַפּוצונג פון שטילקייַט",
  "item.minecraft.silverfish_spawn_egg": "זילבערפישל־באמידשזי־איי",
  "item.minecraft.skeleton_horse_spawn_egg": "סקעלעטפערד־באמידשזי־איי",
  "item.minecraft.skeleton_spawn_egg": "סקעלעט־באמידשזי־איי",
  "item.minecraft.skull_banner_pattern": "מוסטער פאָן",
  "item.minecraft.skull_banner_pattern.desc": "שיידלפארעם",
  "item.minecraft.skull_banner_pattern.new": "שאַרבן פאָן מוסטער",
  "item.minecraft.skull_pottery_shard": "שאַרבן טעפּערייַ פראַגמענט",
  "item.minecraft.skull_pottery_sherd": "שאַרבן טעפּערייַ פראַגמענט",
  "item.minecraft.slime_ball": "שליימבאל",
  "item.minecraft.slime_spawn_egg": "שליים־באמידשזי־איי",
  "item.minecraft.smithing_template": "שמיד ס שאַבלאָן",
  "item.minecraft.smithing_template.applies_to": "אַפּלייז צו:",
  "item.minecraft.smithing_template.armor_trim.additions_slot_description": "לייג אַ ינגגאַט אָדער קריסטאַל",
  "item.minecraft.smithing_template.armor_trim.applies_to": "פּאנצער",
  "item.minecraft.smithing_template.armor_trim.base_slot_description": "לייג אַ פאנצער שטיק",
  "item.minecraft.smithing_template.armor_trim.ingredients": "ינגגאַץ און קריסטאַלז",
  "item.minecraft.smithing_template.ingredients": "קאַמפּאָונאַנץ:",
  "item.minecraft.smithing_template.netherite_upgrade.additions_slot_description": "לייג אַ נעדעריטע ינגגאָט",
  "item.minecraft.smithing_template.netherite_upgrade.applies_to": "דימענט ויסריכט",
  "item.minecraft.smithing_template.netherite_upgrade.base_slot_description": "לייג פאנצער, וואָפן אָדער געצייַג - פֿון אַ דימענט",
  "item.minecraft.smithing_template.netherite_upgrade.ingredients": "לייג אַ נעדעריטע ינגגאָט",
  "item.minecraft.smithing_template.upgrade": "ופענד: ",
  "item.minecraft.sniffer_spawn_egg": "סניפפער סוממאָנינג איי",
  "item.minecraft.snort_pottery_shard": "שער פון טעפּערייַ",
  "item.minecraft.snort_pottery_sherd": "שער פון טעפּערייַ",
  "item.minecraft.snout_armor_trim_smithing_template": "שמיד ס שאַבלאָן",
  "item.minecraft.snout_armor_trim_smithing_template.new": "שנוק פאנצער באַפּוצונג",
  "item.minecraft.snow_golem_spawn_egg": "שניי־גולם רויגן אײ",
  "item.minecraft.snowball": "שנייבאל",
  "item.minecraft.spectral_arrow": "ספעקטראלפֿייַל",
  "item.minecraft.spider_eye": "שפינענויג",
  "item.minecraft.spider_spawn_egg": "שפינען־באמידשזי־איי",
  "item.minecraft.spire_armor_trim_smithing_template": "שמיד ס שאַבלאָן",
  "item.minecraft.spire_armor_trim_smithing_template.new": "טערט פאנצער באַפּוצונג",
  "item.minecraft.splash_potion": "ווארפטרונק",
  "item.minecraft.splash_potion.effect.awkward": "אומהיימלעכער ווארפטרונק",
  "item.minecraft.splash_potion.effect.empty": "אומברויבארער ווארפטרונק",
  "item.minecraft.splash_potion.effect.fire_resistance": "פייערשוצסווארפטרונק",
  "item.minecraft.splash_potion.effect.harming": "דירעקטשאדנסווארפטרונק",
  "item.minecraft.splash_potion.effect.healing": "דירעקטהיילונגסווארפטרונק",
  "item.minecraft.splash_potion.effect.infested": "שאַריטאַ ס שפּריצן פּאָטיאָן",
  "item.minecraft.splash_potion.effect.invisibility": "אומזיכטבארקייטסווארפטרונק",
  "item.minecraft.splash_potion.effect.leaping": "שפרונגקראפטסווארפטרונק",
  "item.minecraft.splash_potion.effect.levitation": "שוועבקראפטסווארפטרונק",
  "item.minecraft.splash_potion.effect.luck": "גליקסווארפטרונק",
  "item.minecraft.splash_potion.effect.mundane": "געוויינלעכער ווארפטרונק",
  "item.minecraft.splash_potion.effect.night_vision": "נאכטזיכטסווארפטרונק",
  "item.minecraft.splash_potion.effect.oozing": "שאַריטאַ ס שפּריצן פּאָטיאָן",
  "item.minecraft.splash_potion.effect.poison": "פארגיפטונגסווארפטרונק",
  "item.minecraft.splash_potion.effect.regeneration": "רעגענעראציעסווארפטרונק",
  "item.minecraft.splash_potion.effect.slow_falling": "סווארפטרונק פין א לינדערן פאל",
  "item.minecraft.splash_potion.effect.slowness": "לאנגזאמקייטסווארפטרונק",
  "item.minecraft.splash_potion.effect.strength": "שטארקייטסווארפטרונק",
  "item.minecraft.splash_potion.effect.swiftness": "שנעלקייטסווארפטרונק",
  "item.minecraft.splash_potion.effect.thick": "דיקער ווארפטרונק",
  "item.minecraft.splash_potion.effect.turtle_master": "שילדקרויטנמייסטערסווארפטרונק",
  "item.minecraft.splash_potion.effect.water": "ווארפווארפפלאש",
  "item.minecraft.splash_potion.effect.water_breathing": "אונטערוואסעראטעמסווארפטרונק",
  "item.minecraft.splash_potion.effect.weakness": "שוואכקייטסווארפטרונק",
  "item.minecraft.splash_potion.effect.weaving": "שאַריטאַ ס שפּריצן פּאָטיאָן",
  "item.minecraft.splash_potion.effect.wind_charged": "שאַריטאַ ס שפּריצן פּאָטיאָן",
  "item.minecraft.spruce_boat": "טענענהאלצלאדקע",
  "item.minecraft.spruce_chest_boat": "טענענבוים שיפל מיט קאַסטן",
  "item.minecraft.spyglass": "טעלעסקאָפּ",
  "item.minecraft.squid_spawn_egg": "טינטפיש־באמידשזי־איי",
  "item.minecraft.stick": "שטעקן",
  "item.minecraft.stone_axe": "שטיינהאק",
  "item.minecraft.stone_hoe": "שטיינגראבאייַזןשטיינ",
  "item.minecraft.stone_pickaxe": "שטיינשפיצהאק",
  "item.minecraft.stone_shovel": "שטיינשופל",
  "item.minecraft.stone_spear": "Stone Spear",
  "item.minecraft.stone_sword": "שטיינשווערד",
  "item.minecraft.stray_spawn_egg": "אייזוואנדערער־באמידשזי־איי",
  "item.minecraft.strider_spawn_egg": "סטרידער באמידשזי איי",
  "item.minecraft.string": "פאדעם",
  "item.minecraft.sugar": "צוקער",
  "item.minecraft.suspicious_stew": "חשדימדיקע זופּ",
  "item.minecraft.sweet_berries": "זיסיאגדעס",
  "item.minecraft.tadpole_bucket": "עמער פון טאַדפּאָלע",
  "item.minecraft.tadpole_spawn_egg": "טאַדפּאָלע ספּאון איי",
  "item.minecraft.tide_armor_trim_smithing_template": "שמיד ס שאַבלאָן",
  "item.minecraft.tide_armor_trim_smithing_template.new": "אַרמאָר באַפּוצונג - יאַמ - פלייץ",
  "item.minecraft.tipped_arrow": "געטונקע פייל",
  "item.minecraft.tipped_arrow.effect.awkward": "דיפּט פייַל",
  "item.minecraft.tipped_arrow.effect.empty": "אוממאכבארער געטונקע פייל",
  "item.minecraft.tipped_arrow.effect.fire_resistance": "פייערשוצספֿייַל",
  "item.minecraft.tipped_arrow.effect.harming": "דירעקטשאדנספֿייַל",
  "item.minecraft.tipped_arrow.effect.healing": "דירעקטהיילונגספֿייַלספֿייַל",
  "item.minecraft.tipped_arrow.effect.infested": "א פליסנדיק פייַל",
  "item.minecraft.tipped_arrow.effect.invisibility": "אומזיכטבארקייטספֿייַל",
  "item.minecraft.tipped_arrow.effect.leaping": "שפרונגקראפטספֿייַל",
  "item.minecraft.tipped_arrow.effect.levitation": "שוועבקראפטספֿייַל",
  "item.minecraft.tipped_arrow.effect.luck": "גליקספֿייַל",
  "item.minecraft.tipped_arrow.effect.mundane": "דיפּט פייַל",
  "item.minecraft.tipped_arrow.effect.night_vision": "נאכטזיכטספֿייַל",
  "item.minecraft.tipped_arrow.effect.oozing": "ליקאַדזש פייַל",
  "item.minecraft.tipped_arrow.effect.poison": "פארגיפטונגספֿייַל",
  "item.minecraft.tipped_arrow.effect.regeneration": "רעגענעראציעספֿייַל",
  "item.minecraft.tipped_arrow.effect.slow_falling": "פייל פין א לינדערן פאל",
  "item.minecraft.tipped_arrow.effect.slowness": "לאנגזאמקייטספֿייַל",
  "item.minecraft.tipped_arrow.effect.strength": "שטארקייטספֿייַל",
  "item.minecraft.tipped_arrow.effect.swiftness": "שנעלקייטספֿייַל",
  "item.minecraft.tipped_arrow.effect.thick": "דיפּט פייַל",
  "item.minecraft.tipped_arrow.effect.turtle_master": "שילדקרויטנמייסטערספֿייַל",
  "item.minecraft.tipped_arrow.effect.water": "נאסער פייל",
  "item.minecraft.tipped_arrow.effect.water_breathing": "אונטערוואסעראטעמספֿייַל",
  "item.minecraft.tipped_arrow.effect.weakness": "שוואכקייטספֿייַל",
  "item.minecraft.tipped_arrow.effect.weaving": "ספּיננינג פייַל",
  "item.minecraft.tipped_arrow.effect.wind_charged": "ווינט טשאַרדזשינג פייַל",
  "item.minecraft.tnt_minecart": "דינאמיטדראבינע",
  "item.minecraft.torchflower_seeds": "שטורקאַץ בלום זאמען",
  "item.minecraft.totem_of_undying": "טאטעם פון דער אומשטארבלעכקייט",
  "item.minecraft.trader_llama_spawn_egg": "רויג איי טריידער לאמא",
  "item.minecraft.trial_key": "אַרויסרופן שליסל",
  "item.minecraft.trident": "דרייצאק",
  "item.minecraft.tropical_fish": "טראפנפיש",
  "item.minecraft.tropical_fish_bucket": "טראפנפישעמער",
  "item.minecraft.tropical_fish_spawn_egg": "טראפנפיש־באמידשזי־איי",
  "item.minecraft.turtle_helmet": "טשערעפּאַכע שאָל",
  "item.minecraft.turtle_scute": "א שטיק טשערעפּאַכע שאָל",
  "item.minecraft.turtle_spawn_egg": "שילדקרויטן־באמידשזי־איי",
  "item.minecraft.vex_armor_trim_smithing_template": "שמיד ס שאַבלאָן",
  "item.minecraft.vex_armor_trim_smithing_template.new": "וואַקס פאנצער באַפּוצונג",
  "item.minecraft.vex_spawn_egg": "סקומבו־באמידשזי־איי",
  "item.minecraft.villager_spawn_egg": "דאָרפֿסלײַט רויגן־אײ",
  "item.minecraft.vindicator_spawn_egg": "דינער־באמידשזי־איי",
  "item.minecraft.wandering_trader_spawn_egg": "רויג איי וואנדערינג טריידער",
  "item.minecraft.ward_armor_trim_smithing_template": "שמיד ס שאַבלאָן",
  "item.minecraft.ward_armor_trim_smithing_template.new": "וואַרדען פאנצער באַפּוצונג",
  "item.minecraft.warden_spawn_egg": "וואַרדען ספּאַון איי",
  "item.minecraft.warped_fungus_on_a_stick": "צעמישט שוועמל רוט",
  "item.minecraft.water_bucket": "וואסערעמער",
  "item.minecraft.wayfinder_armor_trim_smithing_template": "שמיד ס שאַבלאָן",
  "item.minecraft.wayfinder_armor_trim_smithing_template.new": "מאַגביאַ אַרמאָר באַפּוצונג",
  "item.minecraft.wheat": "ווייצן",
  "item.minecraft.wheat_seeds": "ווייצנקערנדלעך",
  "item.minecraft.white_bundle": "ווייס בונדלע",
  "item.minecraft.white_dye": "ווייסער פארבשטאף",
  "item.minecraft.white_harness": "White Harness",
  "item.minecraft.wild_armor_trim_smithing_template": "שמיד ס שאַבלאָן",
  "item.minecraft.wild_armor_trim_smithing_template.new": "ווילד פאנצער באַפּוצונג",
  "item.minecraft.wind_charge": "לאַסט ווינט",
  "item.minecraft.witch_spawn_egg": "מכשפֿה־באמידשזי־איי",
  "item.minecraft.wither_skeleton_spawn_egg": "ווידער־סקעלעט־באמידשזי־איי",
  "item.minecraft.wither_spawn_egg": "ווידער סומאַנינג איי",
  "item.minecraft.wolf_armor": "פאנצער פאר א וואלף",
  "item.minecraft.wolf_spawn_egg": "וואלף־באמידשזי־איי",
  "item.minecraft.wooden_axe": "האלצהאק",
  "item.minecraft.wooden_hoe": "האלצגראבאייַזן",
  "item.minecraft.wooden_pickaxe": "האלצשפיצהאק",
  "item.minecraft.wooden_shovel": "האלצשופל",
  "item.minecraft.wooden_spear": "Wooden Spear",
  "item.minecraft.wooden_sword": "האלצשווערד",
  "item.minecraft.writable_book": "בוך און פעדער",
  "item.minecraft.written_book": "באשריבנס בוך",
  "item.minecraft.yellow_bundle": "געל בונדלע",
  "item.minecraft.yellow_dye": "געלער פארבשטאף",
  "item.minecraft.yellow_harness": "Yellow Harness",
  "item.minecraft.zoglin_spawn_egg": "זאגלין באמידשזי איי",
  "item.minecraft.zombie_horse_spawn_egg": "זאמביפֿערד־באמידשזי־איי",
  "item.minecraft.zombie_nautilus_spawn_egg": "Zombie Nautilus Spawn Egg",
  "item.minecraft.zombie_spawn_egg": "זאמבי־באמידשזי־איי",
  "item.minecraft.zombie_villager_spawn_egg": "זאמבידארפֿייַנוווינער־באמידשזי־איי",
  "item.minecraft.zombified_piglin_spawn_egg": "זאָמבּי־שוויינלין באמידשזי איי"
}
export const yi_de = items; 
